
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dSJSp", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiBackground", function () { return $9260c7e6a9a0f7d6$export$89e553d210168ba3; });
/* paid-jira-ai-background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $9260c7e6a9a0f7d6$var$containerStyle = null;
const $9260c7e6a9a0f7d6$var$backgroundBlurStyle = null;
const $9260c7e6a9a0f7d6$var$leftVectorStyle = null;
const $9260c7e6a9a0f7d6$var$leftTicketsStyle = null;
const $9260c7e6a9a0f7d6$var$rightVectorStyle = null;
const $9260c7e6a9a0f7d6$var$rightGoalsStyle = null;
const $9260c7e6a9a0f7d6$export$89e553d210168ba3 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "paid-jira-ai-background",
        className: (0, $2jatx.default)([
            "_1pby1mrw _kqswstnw _152tidpf _1e02idpf _1bsb1osq _4t3i1kxc"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1r6p _p12f1osq _4t3i4d55 _kqswstnw _1e021ssb _t9eczr6s _152t1lze _11q7ob6u _kdam1tg5 _tzy41ou4"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf _152t1wdt _spvdglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "278",
                        height: "346",
                        viewBox: "0 0 278 346",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M126.304 216.886C141.869 233.09 165.768 229.102 199.031 197.151C202.628 193.696 205.438 189.284 209.035 185.829L277.314 256.912C271.899 263.892 263.781 271.69 252.99 282.056C170.191 361.588 93.474 360.919 42.4374 307.786C4.43138 268.22 0.727808 230.217 3.22073 191.465C3.82247 163.224 5.10354 142.958 -8.71683 128.57C-24.2812 112.367 -48.1115 116.288 -81.4433 148.306L-93.0907 159.494L-160.514 89.3015C-154.209 81.4664 -146.09 73.6677 -136.19 64.1579C-52.5348 -16.1976 23.3597 -16.3841 75.219 37.6046C113.258 77.2054 116.038 116.03 114.333 154.025C113.8 182.2 112.45 202.531 126.27 216.919L126.304 216.886Z",
                            fill: "#FCA700"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1e02idpf _152t1ame _1itk1wg8 _1lrw1dfr _12vemgnk _1bsb1l5f _4t3i1g4h _1pbycs5v"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _rjxpidpf _152tcae7 _spvdglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "259",
                        height: "422",
                        viewBox: "0 0 259 422",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M387.189 211.854L214.396 384.134L111.034 351.343L69.1056 110.944L261.572 55.9512L387.189 211.854Z",
                            fill: "#BF63F3",
                            stroke: "#BF63F3",
                            strokeWidth: "6"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _rjxpidpf _152tautk _1itk1t7m _1lrw1dfr _12vemgnk _1bsb3sup _4t3io25y _1pbycs5v"
                        ])
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("jYNiT", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiDisclaimer", function () { return $ae803050897374c7$export$360a68ea5c3472a9; });
/* paid-jira-ai-disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $kYjgt = parcelRequire("kYjgt");
const $ae803050897374c7$var$containerCss = null;
const $ae803050897374c7$export$360a68ea5c3472a9 = ()=>{
    const acceptableUsePolicyLinkHref = (0, $kooLp.useLocalizedHref)("/legal/acceptable-use-policy");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ect418aq _1wyboqnp _vwz41cby _syazr3uz _1pfh1j6v _y3gn1h6o _ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $kYjgt.messages).acceptableUsePolicyDisclaimer), {
            values: {
                acceptableUsePolicyLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        type: "inline",
                        text: text,
                        "aria-label": text,
                        href: acceptableUsePolicyLinkHref
                    })
            }
        }))
    });
};

});
parcelRegister("kYjgt", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $96f168e338d9fe03$export$defe85febe8b728c; });
$parcel$export(module.exports, "getSuggestionsForTeamType", function () { return $96f168e338d9fe03$export$1699afe393f55639; });

var $fnHPc = parcelRequire("fnHPc");

var $7XYQW = parcelRequire("7XYQW");
const $96f168e338d9fe03$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    getToDoneFaster: {
        id: "PaidLanding.JiraAI.getToDoneFaster",
        defaultMessage: "Get to <highlight>done</highlight> faster with Jira + Rovo",
        description: "Page header"
    },
    aiPoweredProjectManagement: {
        id: "PaidLanding.JiraAI.aiPoweredProjectManagement",
        defaultMessage: "AI-powered project management that removes the work around work.",
        description: "Description below the page header"
    },
    softwareDevelopment: {
        id: "PaidLanding.JiraAI.madLibPrompt.softwareDevelopment",
        defaultMessage: "Software development",
        description: "Mad-lib suggestion option 1"
    },
    productManagement: {
        id: "PaidLanding.JiraAI.madLibPrompt.productManagement",
        defaultMessage: "Product management",
        description: "Mad-lib suggestion option 2"
    },
    marketing: {
        id: "PaidLanding.JiraAI.madLibPrompt.marketing",
        defaultMessage: "Marketing",
        description: "Mad-lib suggestion option 3"
    },
    projectManagement: {
        id: "PaidLanding.JiraAI.madLibPrompt.projectManagement",
        defaultMessage: "Project management",
        description: "Mad-lib suggestion option 4"
    },
    design: {
        id: "PaidLanding.JiraAI.madLibPrompt.design",
        defaultMessage: "Design",
        description: "Mad-lib suggestion option 5"
    },
    it: {
        id: "PaidLanding.JiraAI.madLibPrompt.it",
        defaultMessage: "IT",
        description: "Mad-lib suggestion option 6"
    },
    madLib: {
        id: "PaidLanding.JiraAI.madLibPrompt.madLib",
        defaultMessage: "<workingOn>I'm working on</workingOn> {workingOnInput} <goal>with the goal of</goal> {goalInput}",
        description: "Ex: I'm working on brand awareness campaign with the goal of driving 25% more signups across email, paid, and social channels"
    },
    poweredByAi: {
        id: "PaidLanding.JiraAI.madLibPrompt.poweredByAi",
        defaultMessage: "Uses AI. Verify results.",
        description: "Description in mad-lib prompt footer"
    },
    shuffle: {
        id: "PaidLanding.JiraAI.madLibPrompt.shuffle",
        defaultMessage: "Shuffle",
        description: "Button text to shuffle mad-lib"
    },
    getStarted: {
        id: "PaidLanding.JiraAI.madLibPrompt.getStarted",
        defaultMessage: "Get started",
        description: "Button text to submit mad-lib"
    },
    rerunPrompt: {
        id: "PaidLanding.JiraAI.madLibPrompt.rerunPrompt",
        defaultMessage: "Rerun prompt",
        description: "Button text to submit mad-lib"
    },
    working: {
        id: "PaidLanding.JiraAI.madLibPrompt.working",
        defaultMessage: "Working...",
        description: "Button text for loading message"
    },
    close: {
        id: "PaidLanding.JiraAI.previewModal.close",
        defaultMessage: "Close",
        description: "Label for the close button"
    },
    paidJiraAiPreviewModal: {
        id: "PaidLanding.JiraAI.signup.previewBackground.paidJiraAiPreviewModal",
        defaultMessage: "Paid Jira AI Preview Modal",
        description: "Aria label for preview modal"
    },
    acceptableUsePolicyDisclaimer: {
        id: "PaidLanding.JiraAI.acceptableUsePolicyDisclaimer",
        defaultMessage: 'By selecting "Get started," you agree to use of a feature that is subject to Atlassian\'s <acceptableUsePolicyLink>Acceptable Use Policy</acceptableUsePolicyLink>.',
        description: "Acceptable use policy disclaimer"
    }
});
const $96f168e338d9fe03$export$3e3e8e3ace2d7f0e = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.1.ffl.content",
        defaultMessage: "Feature release with the goal of meeting a key user need",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.1.ffl.task",
        defaultMessage: "feature release",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.1.ffl.goal",
        defaultMessage: "meeting a key user need",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$4083d838b33ee248 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.2.ffl.content",
        defaultMessage: "Platform migration with the goal of improving reliability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.2.ffl.task",
        defaultMessage: "platform migration",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.2.ffl.goal",
        defaultMessage: "improving reliability",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$238954bdf622c599 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.3.ffl.content",
        defaultMessage: "Backend revamp with the goal of improving system performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.3.ffl.task",
        defaultMessage: "backend revamp",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.3.ffl.goal",
        defaultMessage: "improving system performance",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$e67cd156d6d6f2ae = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.4.ffl.content",
        defaultMessage: "Design system update with the goal of unifying components",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.4.ffl.task",
        defaultMessage: "design system update",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.4.ffl.goal",
        defaultMessage: "unifying components",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$c859d4b806b7c319 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.5.ffl.content",
        defaultMessage: "API integration project with the goal of connecting new services",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.5.ffl.task",
        defaultMessage: "api integration project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.5.ffl.goal",
        defaultMessage: "connecting new services",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$aa93c7dd62258c4c = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.6.ffl.content",
        defaultMessage: "Mobile app launch with the goal of delivering a responsive design",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.6.ffl.task",
        defaultMessage: "mobile app launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.6.ffl.goal",
        defaultMessage: "delivering a responsive design",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$5eb899ea0abf885b = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.7.ffl.content",
        defaultMessage: "Security fix with the goal of resolving vulnerabilities",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.7.ffl.task",
        defaultMessage: "security fix",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.7.ffl.goal",
        defaultMessage: "resolving vulnerabilities",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$fffcfc2b88cf5096 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.8.ffl.content",
        defaultMessage: "Performance optimization with the goal of speeding up the app",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.8.ffl.task",
        defaultMessage: "performance optimization",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.8.ffl.goal",
        defaultMessage: "speeding up the app",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$9fe450f0fded883a = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.softwareDevelopment.9.ffl.content",
        defaultMessage: "Engineering sprint with the goal of QAing live prototypes built with AI",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.softwareDevelopment.9.ffl.task",
        defaultMessage: "engineering sprint",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.softwareDevelopment.9.ffl.goal",
        defaultMessage: "QAing live prototypes built with AI",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$ec5ddcbed75bc531 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.softwareDevelopment.10.ffl.content",
        defaultMessage: "Bug tracking initiative with the goal of resolving defects before feature launch",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.softwareDevelopment.10.ffl.task",
        defaultMessage: "bug tracking initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.softwareDevelopment.10.ffl.goal",
        defaultMessage: "resolving defects before feature launch",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$d946a96bae566935 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.9.ffl.content",
        defaultMessage: "Product launch with the goal of shipping a new service to market",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.9.ffl.task",
        defaultMessage: "product launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.9.ffl.goal",
        defaultMessage: "shipping a new service to market",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$7c01f95ee53b1178 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.10.ffl.content",
        defaultMessage: "Feature launch with the goal of delivering value to users",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.10.ffl.task",
        defaultMessage: "feature launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.10.ffl.goal",
        defaultMessage: "delivering value to users",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$2f763ba3e5452cc1 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.11.ffl.content",
        defaultMessage: "Strategic plan with the goal of creating a clear roadmap",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.11.ffl.task",
        defaultMessage: "strategic plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.11.ffl.goal",
        defaultMessage: "creating a clear roadmap",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$1397ef1e776ed951 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.12.ffl.content",
        defaultMessage: "Customer research study with the goal of gathering insights",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.12.ffl.task",
        defaultMessage: "customer research study",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.12.ffl.goal",
        defaultMessage: "gathering insights",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$8cad710146c3f103 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.13.ffl.content",
        defaultMessage: "Platform upgrade with the goal of improving reliability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.13.ffl.task",
        defaultMessage: "platform upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.13.ffl.goal",
        defaultMessage: "improving reliability",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$51ac07ea9a8753b7 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.14.ffl.content",
        defaultMessage: "Analytics project with the goal of tracking key metrics",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.14.ffl.task",
        defaultMessage: "analytics project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.14.ffl.goal",
        defaultMessage: "tracking key metrics",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$aa3333d2f7d341a9 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.15.ffl.content",
        defaultMessage: "Quarterly product plan with the goal of creating a strong backlog",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.15.ffl.task",
        defaultMessage: "quarterly product plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.15.ffl.goal",
        defaultMessage: "creating a strong backlog",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$ba89ed94fac4b472 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.16.ffl.content",
        defaultMessage: "A/B experiment with the goal of optimizing an experience",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.16.ffl.task",
        defaultMessage: "a/b experiment",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.16.ffl.goal",
        defaultMessage: "optimizing an experience",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$700e64e0f0dceb08 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.17.ffl.content",
        defaultMessage: "Campaign launch with the goal of driving brand awareness",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.17.ffl.task",
        defaultMessage: "campaign launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.17.ffl.goal",
        defaultMessage: "driving brand awareness",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$50293e2ec360ad90 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.18.ffl.content",
        defaultMessage: "Content strategy with the goal of improving SEO",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.18.ffl.task",
        defaultMessage: "content strategy",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.18.ffl.goal",
        defaultMessage: "improving SEO",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$2c612aa5d867d94d = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.19.ffl.content",
        defaultMessage: "Referral program with the goal of growing customers via referrals",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.19.ffl.task",
        defaultMessage: "referral program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.19.ffl.goal",
        defaultMessage: "growing customers via referrals",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$75d56ecc14891dc1 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.20.ffl.content",
        defaultMessage: "Social media campaign with the goal of increasing engagement",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.20.ffl.task",
        defaultMessage: "social media campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.20.ffl.goal",
        defaultMessage: "increasing engagement",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$10d5913842e26806 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.21.ffl.content",
        defaultMessage: "Influencer partnership with the goal of reaching new audiences",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.21.ffl.task",
        defaultMessage: "influencer partnership",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.21.ffl.goal",
        defaultMessage: "reaching new audiences",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$e32f3ee079464889 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.22.ffl.content",
        defaultMessage: "Promotional event with the goal of driving brand awareness",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.22.ffl.task",
        defaultMessage: "promotional event",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.22.ffl.goal",
        defaultMessage: "driving brand awareness",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$3c2846799041acd1 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.23.ffl.content",
        defaultMessage: "Email campaign with the goal of generating leads",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.23.ffl.task",
        defaultMessage: "email campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.23.ffl.goal",
        defaultMessage: "generating leads",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$28f387abcb0b61c2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.24.ffl.content",
        defaultMessage: "Paid advertising with the goal of reaching new customers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.24.ffl.task",
        defaultMessage: "paid advertising",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.24.ffl.goal",
        defaultMessage: "reaching new customers",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$217ea0fee69755b2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.25.ffl.content",
        defaultMessage: "Cross-team launch with the goal of delivering a new service",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.25.ffl.task",
        defaultMessage: "cross-team launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.25.ffl.goal",
        defaultMessage: "delivering a new service",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$ba7d0398d02cd9c0 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.26.ffl.content",
        defaultMessage: "System upgrade with the goal of improving performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.26.ffl.task",
        defaultMessage: "system upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.26.ffl.goal",
        defaultMessage: "improving performance",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$510943abc3818b56 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.27.ffl.content",
        defaultMessage: "Training program with the goal of upskilling team members",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.27.ffl.task",
        defaultMessage: "training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.27.ffl.goal",
        defaultMessage: "upskilling team members",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$eb28136e581b59a2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.28.ffl.content",
        defaultMessage: "Communication strategy with the goal of aligning stakeholders",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.28.ffl.task",
        defaultMessage: "communication strategy",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.28.ffl.goal",
        defaultMessage: "aligning stakeholders",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$fb13f40a79e19ca5 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.29.ffl.content",
        defaultMessage: "Event planning initiative with the goal of engaging participants",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.29.ffl.task",
        defaultMessage: "event planning initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.29.ffl.goal",
        defaultMessage: "engaging participants",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$443d3648968f7329 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.30.ffl.content",
        defaultMessage: "Process optimization project with the goal of increasing efficiency",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.30.ffl.task",
        defaultMessage: "process optimization project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.30.ffl.goal",
        defaultMessage: "increasing efficiency",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$b47a1b25f95c27f7 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.31.ffl.content",
        defaultMessage: "Company-wide initiative with the goal of improving collaboration",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.31.ffl.task",
        defaultMessage: "company-wide initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.31.ffl.goal",
        defaultMessage: "improving collaboration",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$ff468a2badd833da = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.32.ffl.content",
        defaultMessage: "Technology upgrade with the goal of modernizing our tools",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.32.ffl.task",
        defaultMessage: "technology upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.32.ffl.goal",
        defaultMessage: "modernizing our tools",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$5a07aeb3f31820fd = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.33.ffl.content",
        defaultMessage: "Dashboard with the goal of tracking performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.33.ffl.task",
        defaultMessage: "dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.33.ffl.goal",
        defaultMessage: "tracking performance",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$dfd30a31c0976d81 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.34.ffl.content",
        defaultMessage: "Segmentation model with the goal of driving personalization",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.34.ffl.task",
        defaultMessage: "segmentation model",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.34.ffl.goal",
        defaultMessage: "driving personalization",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$95dbb3526f288923 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.35.ffl.content",
        defaultMessage: "Predictive model with the goal of forecasting demand",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.35.ffl.task",
        defaultMessage: "predictive model",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.35.ffl.goal",
        defaultMessage: "forecasting demand",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$70448386f1965d8f = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.36.ffl.content",
        defaultMessage: "A/B test analysis with the goal of measuring experiment impact",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.36.ffl.task",
        defaultMessage: "a/b test analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.36.ffl.goal",
        defaultMessage: "measuring experiment impact",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$9b985ff42826fe70 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.37.ffl.content",
        defaultMessage: "Churn analysis with the goal of reducing customer loss",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.37.ffl.task",
        defaultMessage: "churn analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.37.ffl.goal",
        defaultMessage: "reducing customer loss",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$90db3bc5ac7e2675 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.38.ffl.content",
        defaultMessage: "Data pipeline with the goal of improving data quality",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.38.ffl.task",
        defaultMessage: "data pipeline",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.38.ffl.goal",
        defaultMessage: "improving data quality",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$cacf7e1270784764 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.39.ffl.content",
        defaultMessage: "Data lake migration with the goal of centralizing datasets",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.39.ffl.task",
        defaultMessage: "data lake migration",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.39.ffl.goal",
        defaultMessage: "centralizing datasets",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$73dab2578d6196e = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.40.ffl.content",
        defaultMessage: "Funnel analysis with the goal of identifying new opportunities",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.40.ffl.task",
        defaultMessage: "funnel analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.40.ffl.goal",
        defaultMessage: "identifying new opportunities",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$e89b21d7e4f = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.41.ffl.content",
        defaultMessage: "Lead generation project with the goal of finding new customers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.41.ffl.task",
        defaultMessage: "lead generation project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.41.ffl.goal",
        defaultMessage: "finding new customers",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$7552cab841864320 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.42.ffl.content",
        defaultMessage: "Sales campaign with the goal of increasing revenue",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.42.ffl.task",
        defaultMessage: "sales campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.42.ffl.goal",
        defaultMessage: "increasing revenue",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$7a24837b79d45438 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.43.ffl.content",
        defaultMessage: "Account plan with the goal of growing client relationships",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.43.ffl.task",
        defaultMessage: "account plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.43.ffl.goal",
        defaultMessage: "growing client relationships",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$8b9f0dc25b70b492 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.44.ffl.content",
        defaultMessage: "Sales kickoff plan with the goal of driving sales growth",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.44.ffl.task",
        defaultMessage: "sales kickoff plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.44.ffl.goal",
        defaultMessage: "driving sales growth",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$6aaa62a0350d7e26 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.45.ffl.content",
        defaultMessage: "Pipeline optimization with the goal of increasing deal flow",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.45.ffl.task",
        defaultMessage: "pipeline optimization",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.45.ffl.goal",
        defaultMessage: "increasing deal flow",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$2998d96008544a57 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.46.ffl.content",
        defaultMessage: "Sales training program with the goal of improving team skills",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.46.ffl.task",
        defaultMessage: "sales training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.46.ffl.goal",
        defaultMessage: "improving team skills",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$9f50b52f7978030 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.47.ffl.content",
        defaultMessage: "Market analysis with the goal of identifying new opportunities",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.47.ffl.task",
        defaultMessage: "market analysis",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.47.ffl.goal",
        defaultMessage: "identifying new opportunities",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$233be78d085cc677 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.48.ffl.content",
        defaultMessage: "Customer retention initiative with the goal of reducing churn",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.48.ffl.task",
        defaultMessage: "customer retention initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.48.ffl.goal",
        defaultMessage: "reducing churn",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$9a70a449effffd31 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.49.ffl.content",
        defaultMessage: "Annual budget plan with the goal of optimizing resource allocation",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.49.ffl.task",
        defaultMessage: "annual budget plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.49.ffl.goal",
        defaultMessage: "optimizing resource allocation",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$b42e1c0dd11c43a8 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.50.ffl.content",
        defaultMessage: "Financial dashboard with the goal of surfacing key metrics",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.50.ffl.task",
        defaultMessage: "financial dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.50.ffl.goal",
        defaultMessage: "surfacing key metrics",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$c75ce3d04975da18 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.51.ffl.content",
        defaultMessage: "Financial audit preparation with the goal of ensuring compliance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.51.ffl.task",
        defaultMessage: "financial audit preparation",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.51.ffl.goal",
        defaultMessage: "ensuring compliance",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$7d4e88dfaf5cfbf2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.52.ffl.content",
        defaultMessage: "Cost reduction project with the goal of improving profitability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.52.ffl.task",
        defaultMessage: "cost reduction project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.52.ffl.goal",
        defaultMessage: "improving profitability",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$edc324362fedbd80 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.53.ffl.content",
        defaultMessage: "Forecasting project with the goal of predicting revenue",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.53.ffl.task",
        defaultMessage: "forecasting project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.53.ffl.goal",
        defaultMessage: "predicting revenue",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$fe3389126f5cb0d8 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.54.ffl.content",
        defaultMessage: "Automation project with the goal of streamlining operations",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.54.ffl.task",
        defaultMessage: "automation project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.54.ffl.goal",
        defaultMessage: "streamlining operations",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$dd6b1ebf96801fbc = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.55.ffl.content",
        defaultMessage: "Technology upgrade with the goal of modernizing our systems",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.55.ffl.task",
        defaultMessage: "technology upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.55.ffl.goal",
        defaultMessage: "modernizing our systems",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$4d5e8549a481dc8f = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.56.ffl.content",
        defaultMessage: "Tax planning initiative with the goal of ensuring compliance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.56.ffl.task",
        defaultMessage: "tax planning initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.56.ffl.goal",
        defaultMessage: "ensuring compliance",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$93f014d48a475135 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.57.ffl.content",
        defaultMessage: "Contract review project with the goal of faster approvals",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.57.ffl.task",
        defaultMessage: "contract review project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.57.ffl.goal",
        defaultMessage: "faster approvals",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$d11bd1cb56453b28 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.58.ffl.content",
        defaultMessage: "Compliance rollout with the goal of meeting regulatory standards",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.58.ffl.task",
        defaultMessage: "compliance rollout",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.58.ffl.goal",
        defaultMessage: "meeting regulatory standards",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$4c3a6919fce6fd40 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.59.ffl.content",
        defaultMessage: "Property transaction with the goal of finalizing a deal",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.59.ffl.task",
        defaultMessage: "property transaction",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.59.ffl.goal",
        defaultMessage: "finalizing a deal",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$c439b80ed7353230 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.60.ffl.content",
        defaultMessage: "IP litigation case with the goal of protecting intellectual property",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.60.ffl.task",
        defaultMessage: "ip litigation case",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.60.ffl.goal",
        defaultMessage: "protecting intellectual property",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$ea984107697503fc = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.61.ffl.content",
        defaultMessage: "Legal intake portal with the goal of streamlining request handling",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.61.ffl.task",
        defaultMessage: "legal intake portal",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.61.ffl.goal",
        defaultMessage: "streamlining request handling",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$28e7793f76656931 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.62.ffl.content",
        defaultMessage: "Data privacy project with the goal of protecting customer data",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.62.ffl.task",
        defaultMessage: "data privacy project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.62.ffl.goal",
        defaultMessage: "protecting customer data",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$1da97b56a73dc2b2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.63.ffl.content",
        defaultMessage: "Employee policy review with the goal of ensuring compliance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.63.ffl.task",
        defaultMessage: "employee policy review",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.63.ffl.goal",
        defaultMessage: "ensuring compliance",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$ced6c8fb350e76bb = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.64.ffl.content",
        defaultMessage: "Legal tech adoption plan with the goal of improving team efficiency",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.64.ffl.task",
        defaultMessage: "legal tech adoption plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.64.ffl.goal",
        defaultMessage: "improving team efficiency",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$a4bf996d2c840321 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.65.ffl.content",
        defaultMessage: "Support project with the goal of monitoring requests",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.65.ffl.task",
        defaultMessage: "support project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.65.ffl.goal",
        defaultMessage: "monitoring requests",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$673f161eccda0fd2 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.66.ffl.content",
        defaultMessage: "Knowledge base redesign with the goal of simplifying resources",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.66.ffl.task",
        defaultMessage: "knowledge base redesign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.66.ffl.goal",
        defaultMessage: "simplifying resources",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$16b6eaa2913019eb = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.67.ffl.content",
        defaultMessage: "AI chat tool with the goal of automating responses",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.67.ffl.task",
        defaultMessage: "ai chat tool",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.67.ffl.goal",
        defaultMessage: "automating responses",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$747e538403f25754 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.68.ffl.content",
        defaultMessage: "Customer feedback survey with the goal of gathering insights",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.68.ffl.task",
        defaultMessage: "customer feedback survey",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.68.ffl.goal",
        defaultMessage: "gathering insights",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$131cdd783f6832db = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.69.ffl.content",
        defaultMessage: "Process optimization with the goal of reducing bottlenecks",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.69.ffl.task",
        defaultMessage: "process optimization",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.69.ffl.goal",
        defaultMessage: "reducing bottlenecks",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$b39996d55eda2c57 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.70.ffl.content",
        defaultMessage: "Multi-channel integration with the goal of centralizing interactions",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.70.ffl.task",
        defaultMessage: "multi-channel integration",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.70.ffl.goal",
        defaultMessage: "centralizing interactions",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$db220d81a1a51dbb = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.71.ffl.content",
        defaultMessage: "Support dashboard with the goal of tracking key metrics",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.71.ffl.task",
        defaultMessage: "support dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.71.ffl.goal",
        defaultMessage: "tracking key metrics",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$22b3d354cda23d40 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.72.ffl.content",
        defaultMessage: "Training program with the goal of improving team skills",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.72.ffl.task",
        defaultMessage: "training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.72.ffl.goal",
        defaultMessage: "improving team skills",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$116ac96c94b3d638 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.73.ffl.content",
        defaultMessage: "New hire onboarding with the goal of ramping up employees",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.73.ffl.task",
        defaultMessage: "new hire onboarding",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.73.ffl.goal",
        defaultMessage: "ramping up employees",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$a2ffbc021439bdbd = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.74.ffl.content",
        defaultMessage: "Employee training with the goal of building skills",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.74.ffl.task",
        defaultMessage: "employee training",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.74.ffl.goal",
        defaultMessage: "building skills",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$de23ac620cd66202 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.75.ffl.content",
        defaultMessage: "Performance review process with the goal of evaluating growth",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.75.ffl.task",
        defaultMessage: "performance review process",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.75.ffl.goal",
        defaultMessage: "evaluating growth",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$22b19d3e0decb8c0 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.76.ffl.content",
        defaultMessage: "Benefits rollout with the goal of improving employee satisfaction",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.76.ffl.task",
        defaultMessage: "benefits rollout",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.76.ffl.goal",
        defaultMessage: "improving employee satisfaction",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$78bb6bf9117c9ba8 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.77.ffl.content",
        defaultMessage: "Recruitment campaign with the goal of hiring top talent",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.77.ffl.task",
        defaultMessage: "recruitment campaign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.77.ffl.goal",
        defaultMessage: "hiring top talent",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$35ab0ba9aa19c048 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.78.ffl.content",
        defaultMessage: "Employee survey with the goal of gathering feedback",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.78.ffl.task",
        defaultMessage: "employee survey",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.78.ffl.goal",
        defaultMessage: "gathering feedback",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$a2510dd93efe31ef = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.79.ffl.content",
        defaultMessage: "Compliance audit with the goal of meeting regulations",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.79.ffl.task",
        defaultMessage: "compliance audit",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.79.ffl.goal",
        defaultMessage: "meeting regulations",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$35ae46aa9cb3c54f = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.80.ffl.content",
        defaultMessage: "Campus hiring program with the goal of recruiting new graduates",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.80.ffl.task",
        defaultMessage: "campus hiring program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.80.ffl.goal",
        defaultMessage: "recruiting new graduates",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$d873cca220ce6032 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.81.ffl.content",
        defaultMessage: "Knowledge base with the goal of speeding up troubleshooting",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.81.ffl.task",
        defaultMessage: "knowledge base",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.81.ffl.goal",
        defaultMessage: "speeding up troubleshooting",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$c3408d7adaa661b = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.82.ffl.content",
        defaultMessage: "Support workflow with the goal of managing requests",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.82.ffl.task",
        defaultMessage: "support workflow",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.82.ffl.goal",
        defaultMessage: "managing requests",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$8376003f433cab7a = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.83.ffl.content",
        defaultMessage: "Asset management project with the goal of tracking hardware",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.83.ffl.task",
        defaultMessage: "asset management project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.83.ffl.goal",
        defaultMessage: "tracking hardware",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$e8c57044a32c12dd = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.84.ffl.content",
        defaultMessage: "Backup and recovery plan with the goal of protecting data",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.84.ffl.task",
        defaultMessage: "backup and recovery plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.84.ffl.goal",
        defaultMessage: "protecting data",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$219354e66633cab9 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.85.ffl.content",
        defaultMessage: "Training program with the goal of reducing support requests",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.85.ffl.task",
        defaultMessage: "training program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.85.ffl.goal",
        defaultMessage: "reducing support requests",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$2e05d8d366fc16ef = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.86.ffl.content",
        defaultMessage: "Vendor procurement project with the goal of managing suppliers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.86.ffl.task",
        defaultMessage: "vendor procurement project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.86.ffl.goal",
        defaultMessage: "managing suppliers",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$f82da0359a5d86b = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.87.ffl.content",
        defaultMessage: "System upgrade with the goal of improving reliability",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.87.ffl.task",
        defaultMessage: "system upgrade",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.87.ffl.goal",
        defaultMessage: "improving reliability",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$ac718d2313dc759b = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.88.ffl.content",
        defaultMessage: "Dashboard with the goal of tracking system performance",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.88.ffl.task",
        defaultMessage: "dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.88.ffl.goal",
        defaultMessage: "tracking system performance",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$df6110169c836468 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.89.ffl.content",
        defaultMessage: "Process update initiative with the goal of optimizing workflows",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.89.ffl.task",
        defaultMessage: "process update initiative",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.89.ffl.goal",
        defaultMessage: "optimizing workflows",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$a7287c8dd13a5aea = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.90.ffl.content",
        defaultMessage: "Dashboard with the goal of providing actionable insights",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.90.ffl.task",
        defaultMessage: "dashboard",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.90.ffl.goal",
        defaultMessage: "providing actionable insights",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$a611f3e4d87fb273 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.91.ffl.content",
        defaultMessage: "Inventory overhaul with the goal of improving stock management",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.91.ffl.task",
        defaultMessage: "inventory overhaul",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.91.ffl.goal",
        defaultMessage: "improving stock management",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$8334b28c2d4fc9d9 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.92.ffl.content",
        defaultMessage: "Workflow update with the goal of improving team collaboration",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.92.ffl.task",
        defaultMessage: "workflow update",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.92.ffl.goal",
        defaultMessage: "improving team collaboration",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$24a7a9835dd5371e = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.93.ffl.content",
        defaultMessage: "Vendor onboarding program with the goal of streamlining suppliers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.93.ffl.task",
        defaultMessage: "vendor onboarding program",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.93.ffl.goal",
        defaultMessage: "streamlining suppliers",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$e9aed7ccbc11b019 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.94.ffl.content",
        defaultMessage: "Logistics plan with the goal of ensuring smooth operations",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.94.ffl.task",
        defaultMessage: "logistics plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.94.ffl.goal",
        defaultMessage: "ensuring smooth operations",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$314e0f69ccc1d38a = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.95.ffl.content",
        defaultMessage: "Budget plan with the goal of controlling costs",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.95.ffl.task",
        defaultMessage: "budget plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.95.ffl.goal",
        defaultMessage: "controlling costs",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$1e537e1670815d80 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.96.ffl.content",
        defaultMessage: "Process optimization project with the goal of reducing bottlenecks",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.96.ffl.task",
        defaultMessage: "process optimization project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.96.ffl.goal",
        defaultMessage: "reducing bottlenecks",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$bda370311792820b = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.97.ffl.content",
        defaultMessage: "Product feature with the goal of improving the user experience",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.97.ffl.task",
        defaultMessage: "product feature",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.97.ffl.goal",
        defaultMessage: "improving the user experience",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$9e431b0aa66e8252 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.98.ffl.content",
        defaultMessage: "Design system with the goal of scaling consistent components",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.98.ffl.task",
        defaultMessage: "design system",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.98.ffl.goal",
        defaultMessage: "scaling consistent components",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$4b2bd99114944c59 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.99.ffl.content",
        defaultMessage: "Website redesign with the goal of simplifying navigation",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.99.ffl.task",
        defaultMessage: "website redesign",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.99.ffl.goal",
        defaultMessage: "simplifying navigation",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$a41c7817b9e4797e = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.100.ffl.content",
        defaultMessage: "Brand refresh with the goal of unifying visuals",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.100.ffl.task",
        defaultMessage: "brand refresh",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.100.ffl.goal",
        defaultMessage: "unifying visuals",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$c8d0d05503dbe79a = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.101.ffl.content",
        defaultMessage: "Interactive prototype with the goal of testing new concepts",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.101.ffl.task",
        defaultMessage: "interactive prototype",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.101.ffl.goal",
        defaultMessage: "testing new concepts",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$a240bee4318a7275 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.102.ffl.content",
        defaultMessage: "Research study with the goal of validating design decisions",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.102.ffl.task",
        defaultMessage: "research study",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.102.ffl.goal",
        defaultMessage: "validating design decisions",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$21a95300c10295cb = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.103.ffl.content",
        defaultMessage: "Content strategy with the goal of creating a consistent voice",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.103.ffl.task",
        defaultMessage: "content strategy",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.103.ffl.goal",
        defaultMessage: "creating a consistent voice",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$cfa4185509d4a774 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.104.ffl.content",
        defaultMessage: "Mobile app design with the goal of streamlining core user flows",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.104.ffl.task",
        defaultMessage: "mobile app design",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.104.ffl.goal",
        defaultMessage: "streamlining core user flows",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$ed7df379a72deca9 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.105.ffl.content",
        defaultMessage: "Product release with the goal of keeping teams aligned",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.105.ffl.task",
        defaultMessage: "product release",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.105.ffl.goal",
        defaultMessage: "keeping teams aligned",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$a238aef13a297f47 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.106.ffl.content",
        defaultMessage: "A new product with the goal of increasing revenue",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.106.ffl.task",
        defaultMessage: "a new product",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.106.ffl.goal",
        defaultMessage: "increasing revenue",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$4c943dbf592d3daf = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.107.ffl.content",
        defaultMessage: "Marketing launch with the goal of ensuring on-time delivery",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.107.ffl.task",
        defaultMessage: "marketing launch",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.107.ffl.goal",
        defaultMessage: "ensuring on-time delivery",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$8ea24421c21eb989 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.108.ffl.content",
        defaultMessage: "Resource plan with the goal of balancing workloads",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.108.ffl.task",
        defaultMessage: "resource plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.108.ffl.goal",
        defaultMessage: "balancing workloads",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$9060f613b4033371 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.109.ffl.content",
        defaultMessage: "Status report with the goal of keeping leadership informed",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.109.ffl.task",
        defaultMessage: "status report",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.109.ffl.goal",
        defaultMessage: "keeping leadership informed",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$3b9fc7e351d5a0da = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.110.ffl.content",
        defaultMessage: "Timeline plan with the goal of meeting deadlines",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.110.ffl.task",
        defaultMessage: "timeline plan",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.110.ffl.goal",
        defaultMessage: "meeting deadlines",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$8558a67dfa2e822a = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.111.ffl.content",
        defaultMessage: "Risk assessment with the goal of reducing project blockers",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.111.ffl.task",
        defaultMessage: "risk assessment",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.111.ffl.goal",
        defaultMessage: "reducing project blockers",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$91724e490013331 = (0, $fnHPc.defineMessages)({
    content: {
        id: "suggestion.112.ffl.content",
        defaultMessage: "Cross-functional project with the goal of coordinating team tasks",
        description: "The content for the suggestion"
    },
    task: {
        id: "suggestion.112.ffl.task",
        defaultMessage: "cross-functional project",
        description: "The task for the suggestion"
    },
    goal: {
        id: "suggestion.112.ffl.goal",
        defaultMessage: "coordinating team tasks",
        description: "The goal for the suggestion"
    }
});
const $96f168e338d9fe03$export$1699afe393f55639 = (teamType)=>{
    switch(teamType){
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE:
            return [
                $96f168e338d9fe03$export$3e3e8e3ace2d7f0e,
                $96f168e338d9fe03$export$4083d838b33ee248,
                $96f168e338d9fe03$export$238954bdf622c599,
                $96f168e338d9fe03$export$e67cd156d6d6f2ae,
                $96f168e338d9fe03$export$c859d4b806b7c319,
                $96f168e338d9fe03$export$aa93c7dd62258c4c,
                $96f168e338d9fe03$export$5eb899ea0abf885b,
                $96f168e338d9fe03$export$fffcfc2b88cf5096,
                $96f168e338d9fe03$export$9fe450f0fded883a,
                $96f168e338d9fe03$export$ec5ddcbed75bc531
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT:
            return [
                $96f168e338d9fe03$export$d946a96bae566935,
                $96f168e338d9fe03$export$7c01f95ee53b1178,
                $96f168e338d9fe03$export$2f763ba3e5452cc1,
                $96f168e338d9fe03$export$1397ef1e776ed951,
                $96f168e338d9fe03$export$8cad710146c3f103,
                $96f168e338d9fe03$export$51ac07ea9a8753b7,
                $96f168e338d9fe03$export$aa3333d2f7d341a9,
                $96f168e338d9fe03$export$ba89ed94fac4b472
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_MARKETING:
            return [
                $96f168e338d9fe03$export$700e64e0f0dceb08,
                $96f168e338d9fe03$export$50293e2ec360ad90,
                $96f168e338d9fe03$export$2c612aa5d867d94d,
                $96f168e338d9fe03$export$75d56ecc14891dc1,
                $96f168e338d9fe03$export$10d5913842e26806,
                $96f168e338d9fe03$export$e32f3ee079464889,
                $96f168e338d9fe03$export$3c2846799041acd1,
                $96f168e338d9fe03$export$28f387abcb0b61c2
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL:
            return [
                $96f168e338d9fe03$export$217ea0fee69755b2,
                $96f168e338d9fe03$export$ba7d0398d02cd9c0,
                $96f168e338d9fe03$export$510943abc3818b56,
                $96f168e338d9fe03$export$eb28136e581b59a2,
                $96f168e338d9fe03$export$fb13f40a79e19ca5,
                $96f168e338d9fe03$export$443d3648968f7329,
                $96f168e338d9fe03$export$b47a1b25f95c27f7,
                $96f168e338d9fe03$export$ff468a2badd833da
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE:
            return [
                $96f168e338d9fe03$export$5a07aeb3f31820fd,
                $96f168e338d9fe03$export$dfd30a31c0976d81,
                $96f168e338d9fe03$export$95dbb3526f288923,
                $96f168e338d9fe03$export$70448386f1965d8f,
                $96f168e338d9fe03$export$9b985ff42826fe70,
                $96f168e338d9fe03$export$90db3bc5ac7e2675,
                $96f168e338d9fe03$export$cacf7e1270784764,
                $96f168e338d9fe03$export$73dab2578d6196e
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SALES:
            return [
                $96f168e338d9fe03$export$e89b21d7e4f,
                $96f168e338d9fe03$export$7552cab841864320,
                $96f168e338d9fe03$export$7a24837b79d45438,
                $96f168e338d9fe03$export$8b9f0dc25b70b492,
                $96f168e338d9fe03$export$6aaa62a0350d7e26,
                $96f168e338d9fe03$export$2998d96008544a57,
                $96f168e338d9fe03$export$9f50b52f7978030,
                $96f168e338d9fe03$export$233be78d085cc677
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_FINANCE:
            return [
                $96f168e338d9fe03$export$9a70a449effffd31,
                $96f168e338d9fe03$export$b42e1c0dd11c43a8,
                $96f168e338d9fe03$export$c75ce3d04975da18,
                $96f168e338d9fe03$export$7d4e88dfaf5cfbf2,
                $96f168e338d9fe03$export$edc324362fedbd80,
                $96f168e338d9fe03$export$fe3389126f5cb0d8,
                $96f168e338d9fe03$export$dd6b1ebf96801fbc,
                $96f168e338d9fe03$export$4d5e8549a481dc8f
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_LEGAL:
            return [
                $96f168e338d9fe03$export$93f014d48a475135,
                $96f168e338d9fe03$export$d11bd1cb56453b28,
                $96f168e338d9fe03$export$4c3a6919fce6fd40,
                $96f168e338d9fe03$export$c439b80ed7353230,
                $96f168e338d9fe03$export$ea984107697503fc,
                $96f168e338d9fe03$export$28e7793f76656931,
                $96f168e338d9fe03$export$1da97b56a73dc2b2,
                $96f168e338d9fe03$export$ced6c8fb350e76bb
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE:
            return [
                $96f168e338d9fe03$export$a4bf996d2c840321,
                $96f168e338d9fe03$export$673f161eccda0fd2,
                $96f168e338d9fe03$export$16b6eaa2913019eb,
                $96f168e338d9fe03$export$747e538403f25754,
                $96f168e338d9fe03$export$131cdd783f6832db,
                $96f168e338d9fe03$export$b39996d55eda2c57,
                $96f168e338d9fe03$export$db220d81a1a51dbb,
                $96f168e338d9fe03$export$22b3d354cda23d40
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_HR:
            return [
                $96f168e338d9fe03$export$116ac96c94b3d638,
                $96f168e338d9fe03$export$a2ffbc021439bdbd,
                $96f168e338d9fe03$export$de23ac620cd66202,
                $96f168e338d9fe03$export$22b19d3e0decb8c0,
                $96f168e338d9fe03$export$78bb6bf9117c9ba8,
                $96f168e338d9fe03$export$35ab0ba9aa19c048,
                $96f168e338d9fe03$export$a2510dd93efe31ef,
                $96f168e338d9fe03$export$35ae46aa9cb3c54f
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT:
            return [
                $96f168e338d9fe03$export$d873cca220ce6032,
                $96f168e338d9fe03$export$c3408d7adaa661b,
                $96f168e338d9fe03$export$8376003f433cab7a,
                $96f168e338d9fe03$export$e8c57044a32c12dd,
                $96f168e338d9fe03$export$219354e66633cab9,
                $96f168e338d9fe03$export$2e05d8d366fc16ef,
                $96f168e338d9fe03$export$f82da0359a5d86b,
                $96f168e338d9fe03$export$ac718d2313dc759b
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS:
            return [
                $96f168e338d9fe03$export$df6110169c836468,
                $96f168e338d9fe03$export$a7287c8dd13a5aea,
                $96f168e338d9fe03$export$a611f3e4d87fb273,
                $96f168e338d9fe03$export$8334b28c2d4fc9d9,
                $96f168e338d9fe03$export$24a7a9835dd5371e,
                $96f168e338d9fe03$export$e9aed7ccbc11b019,
                $96f168e338d9fe03$export$314e0f69ccc1d38a,
                $96f168e338d9fe03$export$1e537e1670815d80
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DESIGN:
            return [
                $96f168e338d9fe03$export$bda370311792820b,
                $96f168e338d9fe03$export$9e431b0aa66e8252,
                $96f168e338d9fe03$export$4b2bd99114944c59,
                $96f168e338d9fe03$export$a41c7817b9e4797e,
                $96f168e338d9fe03$export$c8d0d05503dbe79a,
                $96f168e338d9fe03$export$a240bee4318a7275,
                $96f168e338d9fe03$export$21a95300c10295cb,
                $96f168e338d9fe03$export$cfa4185509d4a774
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT:
            return [
                $96f168e338d9fe03$export$ed7df379a72deca9,
                $96f168e338d9fe03$export$a238aef13a297f47,
                $96f168e338d9fe03$export$4c943dbf592d3daf,
                $96f168e338d9fe03$export$8ea24421c21eb989,
                $96f168e338d9fe03$export$9060f613b4033371,
                $96f168e338d9fe03$export$3b9fc7e351d5a0da,
                $96f168e338d9fe03$export$8558a67dfa2e822a,
                $96f168e338d9fe03$export$91724e490013331
            ];
        default:
            return [];
    }
};

});


parcelRegister("4Dg8Z", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiHeader", function () { return $849bf4e102b0673b$export$82f38f5bb421b213; });
/* paid-jira-ai-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $2u2Jd = parcelRequire("2u2Jd");

var $kbpa7 = parcelRequire("kbpa7");

var $kM675 = parcelRequire("kM675");

var $kYjgt = parcelRequire("kYjgt");
const $849bf4e102b0673b$var$containerCss = null;
const $849bf4e102b0673b$var$lottieContainerCss = null;
const $849bf4e102b0673b$var$mobileHeaderCss = null;
const $849bf4e102b0673b$var$headerHighlightCss = null;
const $849bf4e102b0673b$var$subHeaderCss = null;
const $849bf4e102b0673b$export$82f38f5bb421b213 = ()=>{
    const [animationStarted, setAnimationStarted] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setAnimationStarted(true);
        }, 400);
        return ()=>clearTimeout(timer);
    }, []);
    const lottieOptions = {
        loop: false,
        autoplay: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($kM675))),
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1osq _p12fkqnl _ahbq1wug _12l21wug _1pfh1k92 _6rth10gz _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2u2Jd))), {
                    options: lottieOptions,
                    isPaused: !animationStarted
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _ect41roz _k48p9y44 _1wyb8pqr _vwz41k18 _y3gn1h6o _syazr3uz _1pfh1h39 _1mjb1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $kYjgt.messages).getToDoneFaster), {
                    values: {
                        highlight: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_bfhkihgv _ca0q17lu _u5f39asb _n3td17lu _19bv9asb _1e0c1o8l _1p1dangw _k48pbfng _2rko1mvu _1wybviql _vwz48pqr"
                                ]),
                                style: {
                                    "--_1efrnav": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.lime300"))
                                },
                                children: str
                            })
                    }
                }))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_ect418aq _k48p1nn1 _1wyb7vkz _vwz41tcg _y3gn1h6o _syazr3uz _19pkftgi _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).aiPoweredProjectManagement))
            })
        ]
    });
};

});
parcelRegister("kM675", function(module, exports) {
module.exports = JSON.parse("{\"v\":\"5.9.0\",\"fr\":23.976,\"ip\":0,\"op\":72,\"w\":1806,\"h\":300,\"nm\":\"Get to done...\",\"assets\":[],\"fonts\":{\"list\":[{\"fName\":\"CharlieDisplay-Black\",\"fFamily\":\"Charlie Display\",\"fStyle\":\"Black\",\"ascent\":70.9},{\"fName\":\"AtlassianSans-Bold\",\"fFamily\":\"Atlassian Sans\",\"fStyle\":\"Bold\",\"ascent\":72.754}]},\"layers\":[{\"ind\":1,\"ty\":3,\"nm\":\"Master nudge Null\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[879,170,0],\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"ip\":0,\"op\":72,\"st\":0},{\"ind\":2,\"ty\":4,\"nm\":\"Check.svg\",\"cl\":\"svg\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":14},\"p\":{\"a\":0,\"k\":[-227.25,-100.75,0],\"l\":2},\"a\":{\"a\":0,\"k\":[15.5,14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":33,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[5.236,5.126],[-1.335,-0.006],[-7.381,9.16],[-9.046,11.659],[-7.65,14.385],[-5.964,16.127],[-5.507,14.021],[-3.476,13.134],[5.859,7.679]],\"c\":true}]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":34.5,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.597,12.696],[3.026,7.564],[-3.02,16.73],[-4.685,19.229],[-3.289,21.955],[-1.603,23.697],[-1.146,21.591],[0.885,20.704],[10.22,15.249]],\"c\":true}]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":36,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.597,12.696],[3.026,7.564],[-3.02,16.73],[5.38,27.85],[11.083,31.976],[13.586,30.052],[15.672,28.528],[18.402,26.478],[10.22,15.249]],\"c\":true}]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":39,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.597,12.696],[3.026,7.564],[-3.02,16.73],[5.38,27.85],[11.083,31.976],[20.46,22.896],[27.208,12.295],[35.414,3.438],[25.541,-3.66]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":60.25,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.597,12.696],[3.026,7.564],[-3.02,16.73],[5.38,27.85],[11.083,31.976],[20.46,22.896],[27.208,12.295],[35.414,3.438],[25.541,-3.66]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":61.5,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.597,12.696],[8.36,13.613],[2.314,22.779],[5.38,27.85],[11.083,31.976],[20.46,22.896],[27.208,12.295],[35.414,3.438],[25.541,-3.66]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":62.75,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.597,12.696],[8.36,13.613],[16.525,24.974],[19.591,30.046],[22.405,25.874],[29.338,17.95],[33.126,10.82],[35.414,3.438],[25.541,-3.66]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":64,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[18.865,0.547],[16.599,2.814],[28.496,11.605],[31.562,16.677],[34.376,12.504],[34.679,11.972],[36.665,7.478],[35.414,3.438],[25.541,-3.66]],\"c\":true}]},{\"t\":65.25,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[24.98,-7.81],[22.714,-5.543],[34.611,3.249],[37.677,8.32],[40.491,4.148],[40.794,3.616],[42.78,-0.879],[41.529,-4.919],[31.656,-12.016]],\"c\":true}]}]},\"o\":{\"a\":0,\"k\":100},\"x\":{\"a\":0,\"k\":0},\"nm\":\"Mask 1\"}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-0.61,-0.89],[-1.38,-1.39],[-0.54,-0.33],[0,0],[0,0],[0,0],[-0.19,-0.19],[-0.41,-0.59],[-1.1,-1.73],[-1.01,1.38],[-0.47,0.58],[-0.12,0.12],[-0.07,0.07],[-0.08,0.14],[-3.08,3.04],[-0.7,0.68],[-0.91,1.59],[0.98,-0.37],[1.8,-1.7],[2.04,-2.03],[0.21,-0.44],[1.02,-1.46],[0,0],[0,0],[0,0],[0.16,-0.21],[0.19,0.22],[0.1,0.11],[0.24,0.26],[0.26,0.26],[1.6,0.59]],\"o\":[[-1.15,-0.42],[0.87,1.29],[0.84,0.72],[0,0],[0,0],[0,0],[0.2,0.17],[0.38,0.37],[0.81,1.09],[1.14,-1.55],[0.55,-0.76],[0.28,-0.35],[0.1,-0.1],[0.12,-0.11],[0.5,-1.01],[2.02,-2.26],[1.65,-1.62],[0.5,-0.87],[-1.79,0.66],[-0.7,0.66],[-0.33,0.33],[-0.91,1.85],[-1.02,1.45],[0,0],[0,0],[-0.18,0.26],[-0.17,-0.24],[-0.12,-0.14],[-0.32,-0.35],[-0.49,-0.51],[-1.62,-1.56],[0,0]],\"v\":[[-12.57,-1.04],[-15.02,2.18],[-11.77,6.03],[-9.76,7.45],[-9.66,7.51],[-9.51,7.63],[-9.2,7.89],[-8.62,8.43],[-7.46,9.8],[-4.58,14.09],[-1.23,9.53],[0.34,7.5],[0.8,6.99],[1.06,6.73],[1.35,6.35],[7.43,-2.08],[11.5,-6.34],[15.13,-10.95],[12.82,-13.72],[7.6,-10.38],[2.86,-6.84],[2.05,-5.69],[-1.15,-0.49],[-2.97,1.97],[-4.04,3.53],[-4.54,4.29],[-5.05,5.09],[-5.58,4.4],[-5.91,4.03],[-6.75,3.12],[-7.85,2.01],[-12.6,-1.06]],\"c\":true}},\"nm\":\"Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.063,0.071,0.078,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[15.137,13.76]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Group 1\"}],\"ip\":24,\"op\":72,\"st\":26},{\"ind\":3,\"ty\":4,\"nm\":\"Circle.svg\",\"cl\":\"svg\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":14},\"p\":{\"a\":0,\"k\":[-225.5,-98.5,0],\"l\":2},\"a\":{\"a\":0,\"k\":[48.5,47.5,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":37,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[46.187,16.528],[29.147,20.949],[18.6,29.033],[12.775,49.267],[17.066,67.746],[26.385,79.18],[37.695,81.699],[54.523,83.562],[58.514,81.57],[66.318,73.642],[79.177,58.803],[85.876,46.912],[86.629,29.269],[84.356,18.811],[83.551,26.248],[82.982,31.5],[82.651,34.558],[64.369,21.916]],\"c\":true}]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":38.2,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[46.187,16.528],[29.147,20.949],[18.6,29.033],[12.775,49.267],[17.066,67.746],[26.385,79.18],[37.695,81.699],[54.523,83.562],[58.514,81.57],[66.318,73.642],[79.177,58.803],[85.876,46.912],[86.629,29.269],[84.356,18.811],[79.247,13.414],[75.64,9.603],[73.539,7.384],[64.369,21.916]],\"c\":true}]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":39.4,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[22.55,-1.416],[29.147,20.949],[18.6,29.033],[12.775,49.267],[17.066,67.746],[26.385,79.18],[37.695,81.699],[54.523,83.562],[58.514,81.57],[66.318,73.642],[79.177,58.803],[85.876,46.912],[86.629,29.269],[84.356,18.811],[79.247,13.414],[75.64,9.603],[73.539,7.384],[56.577,-5.587]],\"c\":true}]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":40.6,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[22.55,-1.416],[4.069,19.724],[-5.281,47.607],[0,74.888],[10.122,90.51],[25.604,96.669],[37.695,81.699],[54.523,83.562],[58.514,81.57],[66.318,73.642],[79.177,58.803],[85.876,46.912],[86.629,29.269],[84.356,18.811],[79.247,13.414],[75.64,9.603],[73.539,7.384],[56.577,-5.587]],\"c\":true}]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":41.8,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[22.55,-1.416],[4.069,19.724],[-5.281,47.607],[0,74.888],[10.122,90.51],[25.604,96.669],[48.683,99.525],[73.987,92.264],[87.331,84.668],[94.914,77.729],[103.38,52.768],[85.876,46.912],[86.629,29.269],[84.356,18.811],[79.247,13.414],[75.64,9.603],[73.539,7.384],[56.577,-5.587]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":43,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[22.55,-1.416],[4.069,19.724],[-5.281,47.607],[0,74.888],[10.122,90.51],[25.604,96.669],[48.683,99.525],[73.987,92.264],[87.331,84.668],[94.914,77.729],[103.38,52.768],[96.894,17.991],[89.392,8.482],[79.2,-1.871],[76.526,2.5],[74.638,5.587],[73.539,7.384],[56.577,-5.587]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":64,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[22.55,-1.416],[4.069,19.724],[-5.281,47.607],[0,74.888],[10.122,90.51],[25.604,96.669],[48.683,99.525],[73.987,92.264],[87.331,84.668],[94.914,77.729],[103.38,52.768],[96.894,17.991],[89.392,8.482],[79.2,-1.871],[76.526,2.5],[74.638,5.587],[73.539,7.384],[56.577,-5.587]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":65.4,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[22.55,-1.416],[4.069,19.724],[-5.281,47.607],[0,74.888],[10.122,90.51],[25.604,96.669],[48.683,99.525],[73.987,92.264],[87.331,84.668],[94.914,77.729],[103.38,52.768],[96.894,17.991],[89.392,8.482],[79.2,-1.871],[75.74,5.628],[84.344,30.908],[63.847,26.627],[31.267,12.876]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":66.8,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[23.305,22.233],[13.071,46.458],[16.707,64.56],[23.759,74.573],[32.349,78.425],[25.604,96.669],[48.683,99.525],[73.987,92.264],[87.331,84.668],[94.914,77.729],[103.38,52.768],[96.894,17.991],[89.392,8.482],[79.2,-1.871],[75.74,5.628],[84.344,30.908],[63.847,26.627],[31.267,12.876]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":68.2,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[23.305,22.233],[13.071,46.458],[16.707,64.56],[23.759,74.573],[32.349,78.425],[45.742,81.832],[62.007,76.105],[72.571,69.714],[79.755,61.785],[84.483,49.014],[103.38,52.768],[96.894,17.991],[89.392,8.482],[79.2,-1.871],[75.74,5.628],[84.344,30.908],[63.847,26.627],[31.267,12.876]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":69.6,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[23.305,22.233],[13.071,46.458],[16.707,64.56],[23.759,74.573],[32.349,78.425],[45.742,81.832],[62.007,76.105],[72.571,69.714],[79.755,61.785],[84.483,49.014],[83.809,39.886],[82.705,17.322],[92.03,11.563],[79.2,-1.871],[75.74,5.628],[84.344,30.908],[63.847,26.627],[31.267,12.876]],\"c\":true}]},{\"t\":71,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[23.305,22.233],[13.071,46.458],[16.707,64.56],[23.759,74.573],[32.349,78.425],[45.742,81.832],[62.007,76.105],[72.571,69.714],[79.755,61.785],[84.483,49.014],[83.809,39.886],[82.705,17.322],[76.083,7.593],[79.2,-1.871],[75.74,5.628],[84.344,30.908],[63.847,26.627],[31.267,12.876]],\"c\":true}]}]},\"o\":{\"a\":0,\"k\":100},\"x\":{\"a\":0,\"k\":0},\"nm\":\"Mask 1\"}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-0.27,-0.3],[-0.23,-0.26],[-0.39,-0.31],[-0.42,0.21],[0.17,1.03],[0.26,0.71],[0.2,0.4],[0.27,0.42],[5.23,3.68],[7.82,1.06],[3.09,-0.65],[0.7,-0.24],[0.65,-0.2],[1.13,-0.49],[4.27,-4.08],[0.91,-0.98],[0.82,-1.16],[1.38,-2.69],[0.98,-2.91],[0.51,-2.9],[-0.57,-4.63],[-0.72,-1.95],[-0.24,-0.57],[0,0],[-3.82,-3.91],[-2.79,-1.74],[-3.49,-1.22],[-8.21,1.05],[-3.88,1.37],[-0.96,0.37],[-0.92,0.48],[-0.92,0.46],[-0.89,0.51],[-2.97,3.71],[-1.49,3.4],[-0.34,3.68],[0.46,3.84],[1.07,3.35],[4.5,4.78],[0.54,0.4],[0.45,0.16],[0.25,-0.33],[-0.41,-0.76],[-0.33,-0.52],[-0.45,-0.66],[-1.65,-6.21],[-0.33,-3.53],[0.36,-3.94],[2.46,-5.61],[2.29,-2.93],[3.57,-2.54],[2.52,-1.38],[1.47,-0.67],[1.57,-0.46],[3.26,-0.29],[1.62,-0.01],[1.54,0.24],[2.63,0.98],[2.51,2.26],[0.48,0.45],[0.31,0.34],[0.14,0.19],[0,0],[0.21,0.27],[0.38,0.55],[0.49,0.81],[0.49,1.1],[-0.01,7.4],[-0.81,3.8],[-1.57,3.39],[-1.99,2.61],[-1.92,1.66],[-2.59,1.19],[-0.61,0.25],[-0.58,0.19],[-0.55,0.14],[-0.52,0.09],[-2.22,-0.32],[-4.79,-3.05],[-3.13,-4.13]],\"o\":[[0.28,0.36],[0.25,0.32],[0.45,0.53],[0.78,0.63],[0.42,-0.21],[-0.08,-0.52],[-0.14,-0.35],[-0.21,-0.38],[-3,-4.82],[-5.22,-3.65],[-4.42,-0.52],[-0.77,0.17],[-0.7,0.22],[-1.32,0.35],[-4.34,2.17],[-0.91,0.85],[-0.85,1.04],[-1.68,2.27],[-1.39,2.68],[-1,2.91],[-1.03,5.84],[0.55,4.65],[0.22,0.58],[0,0],[1.03,1.95],[1.93,1.92],[2.78,1.75],[6.96,2.49],[4.1,-0.51],[0.99,-0.29],[0.95,-0.41],[0.93,-0.46],[0.93,-0.44],[4.92,-3.05],[2.98,-3.71],[2.82,-6.89],[0.39,-4.36],[-0.45,-3.84],[-2.14,-6.66],[-0.58,-0.68],[-0.54,-0.41],[-0.9,-0.32],[-0.25,0.33],[0.21,0.38],[0.33,0.52],[3.51,4.59],[0.83,3.11],[0.33,3.52],[-0.27,3.05],[-1.27,2.78],[-2.3,2.92],[-2.29,1.7],[-1.37,0.72],[-1.52,0.53],[-3.13,0.99],[-1.63,0.16],[-1.61,-0.09],[-3.09,-0.44],[-5.27,-1.93],[-0.62,-0.58],[-0.45,-0.49],[-0.31,-0.34],[-0.15,-0.19],[0,0],[-0.21,-0.28],[-0.37,-0.56],[-0.46,-0.83],[-2.2,-4.25],[-0.01,-3.69],[0.81,-3.77],[1.57,-3.39],[1.99,-2.62],[2.89,-2.49],[0.65,-0.27],[0.59,-0.28],[0.59,-0.16],[0.56,-0.09],[4.19,-0.61],[6.78,0.89],[4.8,3.08],[0,0]],\"v\":[[27.375,-24.39],[28.205,-23.4],[28.905,-22.52],[30.175,-21.25],[32.025,-20.63],[32.445,-22.5],[31.935,-24.35],[31.455,-25.49],[30.725,-26.69],[18.455,-39.61],[-1.015,-47.35],[-12.215,-47.06],[-14.435,-46.58],[-16.455,-45.95],[-20.035,-44.47],[-31.955,-35.82],[-34.615,-33],[-37.185,-29.76],[-41.835,-22.29],[-45.415,-13.86],[-47.595,-5.04],[-48.045,11.11],[-45.605,21.29],[-44.925,23.02],[-44.105,24.7],[-37.205,34.22],[-30.165,39.89],[-20.725,44.44],[2.695,46.82],[14.775,43.94],[17.675,42.84],[20.525,41.63],[23.295,40.25],[25.965,38.7],[37.785,28.31],[44.305,17.47],[48.235,1.45],[48.025,-10.86],[45.715,-21.63],[36.075,-38.96],[34.285,-40.51],[32.755,-41.33],[31.035,-41.26],[31.285,-39.58],[32.105,-38.27],[33.345,-36.6],[40.845,-20.23],[42.605,-10.28],[42.645,0.92],[39.045,14.32],[33.845,23.03],[25.075,31.35],[17.765,35.85],[13.455,37.86],[8.825,39.48],[-0.855,41.32],[-5.735,41.48],[-10.475,41.07],[-19.135,38.96],[-30.975,32.06],[-32.625,30.51],[-33.765,29.26],[-34.455,28.47],[-34.675,28.18],[-35.005,27.76],[-35.945,26.54],[-37.295,24.51],[-38.845,21.67],[-42.875,3.45],[-41.665,-7.9],[-38.005,-18.75],[-32.555,-27.84],[-26.535,-34.25],[-18.185,-39.69],[-16.305,-40.47],[-14.495,-41.03],[-12.795,-41.5],[-11.165,-41.76],[-1.765,-41.81],[15.565,-35.33],[27.385,-24.43]],\"c\":true}},\"nm\":\"Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.063,0.071,0.078,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[48.432,47.66]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Group 1\"}],\"ip\":24,\"op\":72,\"st\":26},{\"ind\":4,\"ty\":4,\"nm\":\"Eyelash c.svg\",\"cl\":\"svg\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[-215.5,59.5,0],\"l\":2},\"a\":{\"a\":0,\"k\":[36.5,23.5,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,-100,100],\"l\":2}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":1,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.331,32.886],[-4.661,25.225],[-8.29,18.929],[-6.783,33.162],[15.699,42.959],[32.279,49.742],[46.599,56.525],[67.609,58.786],[58.93,52.786],[54.37,50.395],[45.25,48.555],[41.41,45.016],[35.276,43.096],[23.495,38.056],[10.553,33.976]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":4,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.044,-8.29],[-1.507,-9.71],[-7.536,15.914],[-6.029,30.147],[16.452,39.945],[33.033,46.728],[47.353,53.511],[68.362,55.772],[72.884,37.771],[72.884,27.219],[72.884,12.9],[72.884,0],[57.15,0],[40.57,0],[19.467,0]],\"c\":true}]},{\"t\":7,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.044,-8.29],[-1.507,-9.71],[-2.496,-3.286],[11.732,-2.254],[51.013,7.544],[59.434,27.767],[75.434,29.99],[68.362,55.772],[72.884,37.771],[72.884,27.219],[72.884,12.9],[72.884,0],[57.15,0],[40.57,0],[19.467,0]],\"c\":true}]}]},\"o\":{\"a\":0,\"k\":100},\"x\":{\"a\":0,\"k\":0},\"nm\":\"Mask 1\"}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0.79,0.04],[1.63,-0.66],[1.91,-0.65],[0.25,-0.25],[0,0],[2.101,-0.886],[0.47,-0.2],[0.86,-0.9],[0,0],[-0.88,-0.01],[-1.43,0.58],[-1.12,0.39],[-0.84,0.11],[-0.1,0.07],[-3.1,1.05],[-0.68,0.29],[-0.94,1.09]],\"o\":[[-1.44,-0.08],[-0.63,0.26],[-0.31,0.11],[-2.16,2.09],[-0.044,0.019],[-1.59,0.68],[-1.41,0.62],[0,0],[-0.61,0.64],[1.25,0.01],[1.55,-0.83],[1.84,-0.78],[0.12,-0.02],[0.75,-0.45],[2.12,-0.91],[1.61,-0.71],[0.52,-0.6]],\"v\":[[34.843,7.929],[30.433,8.699],[26.273,9.429],[25.433,9.959],[19.813,13.189],[12.703,16.179],[9.883,17.389],[6.603,19.629],[6.613,19.629],[8.193,23.359],[12.083,22.569],[14.883,20.539],[21.043,19.189],[21.383,19.069],[28.513,15.629],[32.623,13.87],[36.253,11.249]],\"c\":true}},\"nm\":\"Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.063,0.071,0.078,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[36.5,23.369]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Group 1\"}],\"ip\":1,\"op\":8,\"st\":0},{\"ind\":5,\"ty\":4,\"nm\":\"Eyelash b.svg \",\"cl\":\"svg\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[-215.5,59.5,0],\"l\":2},\"a\":{\"a\":0,\"k\":[36.5,23.5,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,-100,100],\"l\":2}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":1,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.331,32.886],[-4.661,25.225],[-8.29,18.929],[-6.783,33.162],[15.699,42.959],[32.279,49.742],[46.599,56.525],[67.609,58.786],[58.93,52.786],[54.37,50.395],[45.25,48.555],[41.41,45.016],[35.276,43.096],[23.495,38.056],[10.553,33.976]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":4,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.044,-8.29],[-1.507,-9.71],[-7.536,15.914],[-6.029,30.147],[16.452,39.945],[33.033,46.728],[47.353,53.511],[68.362,55.772],[72.884,37.771],[72.884,27.219],[72.884,12.9],[72.884,0],[57.15,0],[40.57,0],[19.467,0]],\"c\":true}]},{\"t\":7,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.044,-8.29],[-1.507,-9.71],[-2.496,-3.286],[11.732,-2.254],[51.013,7.544],[59.434,27.767],[75.434,29.99],[68.362,55.772],[72.884,37.771],[72.884,27.219],[72.884,12.9],[72.884,0],[57.15,0],[40.57,0],[19.467,0]],\"c\":true}]}]},\"o\":{\"a\":0,\"k\":100},\"x\":{\"a\":0,\"k\":0},\"nm\":\"Mask 1\"}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0.72,-0.329],[1.12,-1.35],[1.36,-1.479],[0.11,-0.33],[0.02,-0.021],[1.43,-1.78],[0.32,-0.4],[0.33,-1.2],[0,0],[-0.78,0.41],[-0.99,1.19],[-0.81,0.87],[-0.7,0.49],[-0.07,0.11],[-2.22,2.39],[-0.46,0.58],[-0.31,1.41]],\"o\":[[-1.3,0.61],[-0.431,0.53],[-0.22,0.24],[-0.896,2.858],[0,0],[-1.07,1.35],[-0.95,1.22],[0,0],[-0.23,0.85],[1.1,-0.58],[0.97,-1.46],[1.25,-1.57],[0.1,-0.07],[0.44,-0.75],[1.43,-1.8],[1.08,-1.39],[0.169,-0.77]],\"v\":[[6.693,-13.191],[3.183,-10.421],[-0.127,-7.801],[-0.617,-6.941],[-4.037,-1.431],[-8.877,4.579],[-10.787,6.979],[-12.607,10.499],[-12.617,10.509],[-9.457,13.039],[-6.407,10.499],[-4.897,7.389],[-0.107,3.279],[0.143,3.009],[4.783,-3.401],[7.563,-6.901],[9.513,-10.931]],\"c\":true}},\"nm\":\"Path 2\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.063,0.071,0.078,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[36.5,23.369]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Group 1\"}],\"ip\":1,\"op\":8,\"st\":0},{\"ind\":6,\"ty\":4,\"nm\":\"Eyelash a.svg\",\"cl\":\"svg\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[-215.5,59.5,0],\"l\":2},\"a\":{\"a\":0,\"k\":[36.5,23.5,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,-100,100],\"l\":2}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":1,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.331,32.886],[-4.661,25.225],[-8.29,18.929],[-6.783,33.162],[15.699,42.959],[32.279,49.742],[46.599,56.525],[67.609,58.786],[58.93,52.786],[54.37,50.395],[45.25,48.555],[41.41,45.016],[35.276,43.096],[23.495,38.056],[10.553,33.976]],\"c\":true}]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":4,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.044,-8.29],[-1.507,-9.71],[-7.536,15.914],[-6.029,30.147],[16.452,39.945],[33.033,46.728],[47.353,53.511],[68.362,55.772],[72.884,37.771],[72.884,27.219],[72.884,12.9],[72.884,0],[57.15,0],[40.57,0],[19.467,0]],\"c\":true}]},{\"t\":7,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[9.044,-8.29],[-1.507,-9.71],[-2.496,-3.286],[11.732,-2.254],[51.013,7.544],[59.434,27.767],[75.434,29.99],[68.362,55.772],[72.884,37.771],[72.884,27.219],[72.884,12.9],[72.884,0],[57.15,0],[40.57,0],[19.467,0]],\"c\":true}]}]},\"o\":{\"a\":0,\"k\":100},\"x\":{\"a\":0,\"k\":0},\"nm\":\"Mask 1\"}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0.48,-0.63],[0.38,-1.72],[0.54,-1.94],[-0.06,-0.34],[0,0],[0.458,-2.229],[0.1,-0.5],[-0.26,-1.22],[0,0],[-0.511,0.72],[-0.33,1.51],[-0.31,1.15],[-0.39,0.75],[-0.01,0.12],[-0.88,3.15],[-0.15,0.73],[0.37,1.39]],\"o\":[[-0.88,1.14],[-0.14,0.67],[-0.09,0.32],[0.51,2.96],[-0.01,0.05],[-0.33,1.69],[-0.28,1.52],[0,0],[0.18,0.86],[0.71,-1.02],[0.19,-1.75],[0.39,-1.97],[0.06,-0.11],[0.05,-0.87],[0.45,-2.26],[0.32,-1.73],[-0.201,-0.76]],\"v\":[[-30.037,-23.101],[-31.887,-19.021],[-33.627,-15.171],[-33.667,-14.181],[-34.167,-7.711],[-35.707,-0.151],[-36.297,2.859],[-36.297,6.829],[-36.307,6.819],[-32.337,7.62],[-30.797,3.959],[-30.887,0.499],[-28.527,-5.351],[-28.427,-5.701],[-27.247,-13.531],[-26.377,-17.921],[-26.497,-22.391]],\"c\":true}},\"nm\":\"Path 3\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.063,0.071,0.078,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[36.5,23.369]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Group 1\"}],\"ip\":1,\"op\":8,\"st\":0},{\"ind\":7,\"ty\":3,\"nm\":\"[Null] To-do Lozenge\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[-9]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":3,\"s\":[4]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":5,\"s\":[0]},{\"t\":16,\"s\":[0]}]},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[-355,-78,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":3,\"s\":[-337,-16,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":5,\"s\":[-343,-28,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":7,\"s\":[-343,-28,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":10,\"s\":[-343,-28,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":13,\"s\":[-343,-28,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":16,\"s\":[-343,-28,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":20,\"s\":[-742,-28,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[50,50,0],\"l\":2},\"s\":{\"a\":0,\"k\":[244,108,100],\"l\":2}},\"ao\":0,\"ip\":0,\"op\":72,\"st\":0},{\"ind\":8,\"ty\":5,\"nm\":\"TO DO\",\"parent\":7,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":13,\"s\":[100]},{\"t\":17,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[44.721,51.577,0],\"l\":2},\"a\":{\"a\":0,\"k\":[0.391,-23.281,0],\"l\":2},\"s\":{\"a\":0,\"k\":[40.984,92.593,100],\"l\":2}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":64,\"f\":\"AtlassianSans-Bold\",\"t\":\"TO DO\",\"ca\":0,\"j\":2,\"tr\":-28,\"lh\":169,\"ls\":0,\"fc\":[0,0,0]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0]}},\"a\":[]},\"ip\":0,\"op\":72,\"st\":0},{\"ind\":9,\"ty\":4,\"nm\":\"TO DO BG\",\"parent\":7,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":13,\"s\":[100]},{\"t\":17,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[44.721,51.577,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-265.359,-17.484,0],\"l\":2},\"s\":{\"a\":0,\"k\":[40.984,92.593,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"s\":{\"a\":0,\"k\":[250,96]},\"p\":{\"a\":0,\"k\":[0,0]},\"r\":{\"a\":0,\"k\":12},\"nm\":\"Rectangle Path 1\"},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0,0,1]},\"o\":{\"a\":0,\"k\":100},\"w\":{\"a\":0,\"k\":0},\"lc\":1,\"lj\":1,\"ml\":4,\"nm\":\"Stroke 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.867,0.871,0.882,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-265.359,-17.484]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Rectangle 1\"}],\"ip\":0,\"op\":72,\"st\":0},{\"ind\":10,\"ty\":3,\"nm\":\"[Null] In-progress Lozenge\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.649,\"y\":0.649},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":7,\"s\":[57,-28,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.646,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":14,\"s\":[57,-28,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.646,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":20,\"s\":[-342,-28,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.646,\"y\":1},\"o\":{\"x\":0.167,\"y\":0},\"t\":23,\"s\":[-356,-28,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":25,\"s\":[-342,-28,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[50,50,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":34,\"s\":[244,108,100]},{\"t\":37,\"s\":[191,84.541,100]}],\"l\":2}},\"ao\":0,\"ip\":0,\"op\":72,\"st\":0},{\"ind\":11,\"ty\":5,\"nm\":\"IN PROGRESS\",\"parent\":10,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":15,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":16,\"s\":[100]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":37,\"s\":[100]},{\"t\":38,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[50.459,50.651,0],\"l\":2},\"a\":{\"a\":0,\"k\":[0.391,-23.281,0],\"l\":2},\"s\":{\"a\":0,\"k\":[40.984,92.593,100],\"l\":2}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":64,\"f\":\"AtlassianSans-Bold\",\"t\":\"IN PROGRESS\",\"ca\":0,\"j\":2,\"tr\":-28,\"lh\":169,\"ls\":0,\"fc\":[0,0,0]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0]}},\"a\":[]},\"ip\":0,\"op\":72,\"st\":0},{\"ind\":12,\"ty\":4,\"nm\":\"IN PROGRESS BG\",\"parent\":10,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":15,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":16,\"s\":[100]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":37,\"s\":[100]},{\"t\":38,\"s\":[0]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[50.459,50.651,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-265.359,-17.484,0],\"l\":2},\"s\":{\"a\":0,\"k\":[40.984,92.593,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"s\":{\"a\":0,\"k\":[490,96]},\"p\":{\"a\":0,\"k\":[0,0]},\"r\":{\"a\":0,\"k\":12},\"nm\":\"Rectangle Path 1\"},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0,0,1]},\"o\":{\"a\":0,\"k\":100},\"w\":{\"a\":0,\"k\":0},\"lc\":1,\"lj\":1,\"ml\":4,\"nm\":\"Stroke 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.561,0.722,0.965,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-265.359,-17.484]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Rectangle 1\"}],\"ip\":0,\"op\":72,\"st\":0},{\"ind\":13,\"ty\":3,\"nm\":\"[Null] Done Lozenge\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":37,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":40,\"s\":[-4]},{\"t\":47,\"s\":[0]}]},\"p\":{\"a\":0,\"k\":[-343,-28,0],\"l\":2},\"a\":{\"a\":0,\"k\":[50,50,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":37,\"s\":[203.333,90,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":40,\"s\":[244,108,100]},{\"t\":47,\"s\":[244,108,100]}],\"l\":2}},\"ao\":0,\"ip\":0,\"op\":72,\"st\":0},{\"ind\":14,\"ty\":5,\"nm\":\"DONE\",\"parent\":13,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":37,\"s\":[0]},{\"t\":38,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[50.459,50.651,0],\"l\":2},\"a\":{\"a\":0,\"k\":[0.391,-23.281,0],\"l\":2},\"s\":{\"a\":0,\"k\":[40.984,92.593,100],\"l\":2}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":64,\"f\":\"AtlassianSans-Bold\",\"t\":\"DONE\",\"ca\":0,\"j\":2,\"tr\":-28,\"lh\":169,\"ls\":0,\"fc\":[0,0,0]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0]}},\"a\":[]},\"ip\":0,\"op\":72,\"st\":0},{\"ind\":15,\"ty\":4,\"nm\":\"DONE BG\",\"parent\":13,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":37,\"s\":[0]},{\"t\":38,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[50.459,50.651,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-265.359,-17.484,0],\"l\":2},\"s\":{\"a\":0,\"k\":[40.984,92.593,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"rc\",\"d\":1,\"s\":{\"a\":0,\"k\":[230,96]},\"p\":{\"a\":0,\"k\":[0,0]},\"r\":{\"a\":0,\"k\":12},\"nm\":\"Rectangle Path 1\"},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[0,0,0,1]},\"o\":{\"a\":0,\"k\":100},\"w\":{\"a\":0,\"k\":0},\"lc\":1,\"lj\":1,\"ml\":4,\"nm\":\"Stroke 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.702,0.875,0.447,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-265.359,-17.484]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Rectangle 1\"}],\"ip\":0,\"op\":72,\"st\":0},{\"ind\":16,\"ty\":5,\"nm\":\"faster with Jira + Rovo\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":7,\"s\":[274.338,7.172,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":14,\"s\":[274.338,7.172,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":20,\"s\":[405.338,7.172,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":34,\"s\":[405.338,7.172,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":41,\"s\":[275.338,7.172,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":96,\"f\":\"CharlieDisplay-Black\",\"t\":\"faster with Jira + Rovo\",\"ca\":0,\"j\":2,\"tr\":-28,\"lh\":169,\"ls\":0,\"fc\":[0,0,0]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0]}},\"a\":[]},\"ip\":0,\"op\":72,\"st\":0},{\"ind\":17,\"ty\":5,\"nm\":\"Get to\",\"parent\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":7,\"s\":[-621.662,7.172,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":14,\"s\":[-621.662,7.172,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":20,\"s\":[-726.662,7.172,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":34,\"s\":[-726.662,7.172,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":41,\"s\":[-597.662,7.172,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":96,\"f\":\"CharlieDisplay-Black\",\"t\":\"Get to\",\"ca\":0,\"j\":2,\"tr\":-28,\"lh\":169,\"ls\":0,\"fc\":[0,0,0]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0]}},\"a\":[]},\"ip\":0,\"op\":72,\"st\":0}],\"markers\":[],\"chars\":[{\"ch\":\"G\",\"size\":96,\"style\":\"Black\",\"w\":67.6,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[-5.539,3.424],[0,0],[0,0],[0,0],[0,0],[0,0],[1.108,0],[0,10.272],[-14.905,0],[-6.042,-3.021],[0,0],[6.445,0],[0,-21.652],[-23.868,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[-1.611,0.101],[-13.394,0],[0,-10.272],[5.539,0],[0,0],[-6.546,-3.223],[-24.673,0],[0,20.142],[8.157,0]],\"v\":[[63.245,-3.625],[63.245,-39.78],[34.946,-39.78],[34.946,-25.983],[45.621,-25.983],[45.621,-16.214],[41.492,-16.013],[22.256,-33.334],[43.103,-50.555],[62.54,-46.426],[62.54,-63.144],[41.19,-67.374],[2.014,-32.932],[38.672,1.108]],\"c\":true}},\"nm\":\"G\"}],\"nm\":\"G\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"e\",\"size\":96,\"style\":\"Black\",\"w\":54,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[-4.733,0],[-0.504,-7.05],[0,0]],\"o\":[[4.532,0],[0,0],[0.604,-6.747]],\"v\":[[27.896,-40.082],[35.349,-29.91],[20.142,-29.91]],\"c\":true}},\"nm\":\"e\"},{\"ind\":1,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[-4.935,1.813],[0,0],[6.042,0],[1.208,5.136],[0,0],[0,0],[17.12,0],[0,-16.415],[-20.847,0]],\"o\":[[0,0],[-5.338,1.511],[-7.15,0],[0,0],[0,0],[0,-16.516],[-17.322,0],[0,17.12],[6.747,0]],\"v\":[[50.455,-2.115],[50.455,-17.02],[32.428,-14.603],[20.544,-21.35],[52.368,-21.35],[52.368,-25.278],[28.198,-53.375],[1.813,-25.278],[32.025,1.007]],\"c\":true}},\"nm\":\"e\"}],\"nm\":\"e\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"t\",\"size\":96,\"style\":\"Black\",\"w\":35.9,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,3.223],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-13.092,0],[-2.618,0.604],[0,0],[1.511,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,11.279],[4.532,0],[0,0],[-1.108,0.201],[-3.122,0]],\"v\":[[24.774,-20.847],[24.774,-36.758],[33.536,-36.758],[33.536,-52.167],[24.774,-52.167],[24.774,-62.741],[5.841,-62.741],[5.841,-52.167],[1.007,-52.167],[1.007,-36.758],[5.841,-36.758],[5.841,-18.228],[23.465,0.806],[33.536,-0.302],[33.536,-16.516],[29.507,-16.013]],\"c\":true}},\"nm\":\"t\"}],\"nm\":\"t\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\" \",\"size\":96,\"style\":\"Black\",\"w\":16.5,\"data\":{},\"fFamily\":\"Charlie Display\"},{\"ch\":\"o\",\"size\":96,\"style\":\"Black\",\"w\":56.1,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[-16.818,0],[0,16.415],[16.617,0],[0,-16.315]],\"o\":[[16.617,0],[0,-16.315],[-16.818,0],[0,16.415]],\"v\":[[28.4,1.309],[54.584,-26.184],[28.4,-53.375],[1.813,-26.184]],\"c\":true}},\"nm\":\"o\"},{\"ind\":1,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[-5.539,0],[0,-6.546],[5.237,0],[0,6.647]],\"o\":[[5.237,0],[0,6.647],[-5.539,0],[0,-6.546]],\"v\":[[28.4,-37.061],[36.053,-26.184],[28.4,-14.905],[20.444,-26.184]],\"c\":true}},\"nm\":\"o\"}],\"nm\":\"o\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"f\",\"size\":96,\"style\":\"Black\",\"w\":36.3,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-3.726,0],[-1.309,-0.302],[0,0],[2.618,0],[0,-11.078],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,-2.921],[1.813,0],[0,0],[-2.417,-0.403],[-16.013,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[24.875,-54.785],[30.313,-59.72],[35.248,-59.216],[35.248,-72.308],[26.788,-73.114],[5.841,-54.584],[5.841,-52.167],[1.007,-52.167],[1.007,-36.758],[5.841,-36.758],[5.841,0],[24.875,0],[24.875,-36.758],[35.147,-36.758],[35.147,-52.167],[24.875,-52.167]],\"c\":true}},\"nm\":\"f\"}],\"nm\":\"f\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"a\",\"size\":96,\"style\":\"Black\",\"w\":56.9,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,7.352],[-4.834,0],[0,-6.345],[0,0],[3.726,0]],\"o\":[[0,-7.15],[3.827,0],[0,0],[0,6.244],[-4.532,0]],\"v\":[[20.544,-26.083],[27.896,-37.262],[34.442,-28.198],[34.442,-24.069],[27.493,-15.106]],\"c\":true}},\"nm\":\"a\"},{\"ind\":1,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[6.848,0],[0,-14.804],[-12.085,0],[-3.021,6.949]],\"o\":[[0,0],[0,0],[0,0],[0,0],[-2.618,-5.942],[-12.891,0],[0,15.71],[6.546,0],[0,0]],\"v\":[[34.442,0],[53.476,0],[53.476,-52.167],[34.442,-52.167],[34.442,-43.204],[20.242,-53.174],[1.813,-26.083],[19.437,1.007],[34.442,-9.265]],\"c\":true}},\"nm\":\"a\"}],\"nm\":\"a\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"s\",\"size\":96,\"style\":\"Black\",\"w\":46.2,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,10.776],[15.509,2.719],[0,1.712],[-3.122,0],[-7.05,-2.618],[0,0],[7.755,0],[0,-10.675],[-15.207,-2.417],[0,-1.813],[3.122,0],[4.834,2.316],[0,0],[-8.661,0]],\"o\":[[0,-7.855],[-5.841,-1.108],[0,-1.611],[5.942,0],[0,0],[-4.431,-2.417],[-13.596,0],[0,8.057],[4.532,1.007],[0,1.611],[-6.949,0],[0,0],[4.33,2.316],[15.61,0]],\"v\":[[44.916,-16.214],[25.681,-32.629],[18.53,-36.356],[23.163,-38.873],[42.902,-34.341],[42.902,-49.347],[23.465,-53.375],[2.014,-36.658],[21.552,-19.839],[27.795,-16.113],[22.961,-13.495],[2.82,-18.43],[2.82,-3.223],[23.062,1.108]],\"c\":true}},\"nm\":\"s\"}],\"nm\":\"s\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"r\",\"size\":96,\"style\":\"Black\",\"w\":36.9,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-10.172,-0.705],[0,0],[2.719,-7.05],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,-6.747],[0,0],[-6.848,-0.403],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[22.861,-25.278],[36.658,-33.334],[36.658,-52.872],[22.861,-42.297],[22.861,-52.167],[3.726,-52.167],[3.726,0],[22.861,0]],\"c\":true}},\"nm\":\"r\"}],\"nm\":\"r\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"w\",\"size\":96,\"style\":\"Black\",\"w\":85.6,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[75.027,0],[87.012,-52.167],[69.388,-52.167],[62.741,-12.085],[53.073,-52.167],[34.442,-52.167],[24.875,-12.286],[18.127,-52.167],[-0.504,-52.167],[11.481,0],[35.147,0],[39.679,-17.926],[42.7,-35.349],[45.621,-17.926],[50.052,0]],\"c\":true}},\"nm\":\"w\"}],\"nm\":\"w\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"i\",\"size\":96,\"style\":\"Black\",\"w\":26.4,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-6.546],[-6.647,0],[0,6.647],[6.848,0]],\"o\":[[0,6.647],[6.848,0],[0,-6.546],[-6.647,0]],\"v\":[[1.611,-66.669],[13.193,-56.195],[24.875,-66.669],[13.193,-77.042]],\"c\":true}},\"nm\":\"i\"},{\"ind\":1,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[3.726,0],[22.76,0],[22.76,-52.167],[3.726,-52.167]],\"c\":true}},\"nm\":\"i\"}],\"nm\":\"i\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"h\",\"size\":96,\"style\":\"Black\",\"w\":56.4,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[10.977,0],[2.82,-6.647],[0,0],[0,0],[0,0],[0,0],[0,0],[-3.827,0],[0,-4.733],[0,0],[0,0]],\"o\":[[0,-13.797],[-7.452,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,-5.841],[3.726,0],[0,0],[0,0],[0,0]],\"v\":[[53.476,-31.723],[38.068,-53.275],[22.76,-42.801],[22.76,-71.402],[3.726,-71.402],[3.726,0],[22.76,0],[22.76,-29.004],[29.205,-37.463],[34.442,-30.414],[34.442,0],[53.476,0]],\"c\":true}},\"nm\":\"h\"}],\"nm\":\"h\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"J\",\"size\":96,\"style\":\"Black\",\"w\":38,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[4.633,0],[1.813,0.604],[0,0],[-4.733,0],[0,12.186],[0,0],[0,0]],\"o\":[[0,4.431],[-2.014,0],[0,0],[2.518,0.906],[15.308,0],[0,0],[0,0],[0,0]],\"v\":[[12.991,-25.58],[6.747,-18.228],[1.007,-19.235],[1.007,-1.309],[11.884,0.403],[33.737,-20.142],[33.737,-66.165],[12.991,-66.165]],\"c\":true}},\"nm\":\"J\"}],\"nm\":\"J\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"+\",\"size\":96,\"style\":\"Black\",\"w\":49.6,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[16.214,-55.188],[16.214,-40.485],[2.316,-40.485],[2.316,-23.566],[16.214,-23.566],[16.214,-7.855],[33.636,-7.855],[33.636,-23.566],[47.635,-23.566],[47.635,-40.485],[33.636,-40.485],[33.636,-55.188]],\"c\":true}},\"nm\":\"+\"}],\"nm\":\"+\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"R\",\"size\":96,\"style\":\"Black\",\"w\":66.6,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,-4.431],[6.546,0],[0,0],[0,0]],\"o\":[[6.546,0],[0,4.834],[0,0],[0,0],[0,0]],\"v\":[[33.737,-49.448],[42.599,-42.096],[33.737,-34.341],[25.681,-34.341],[25.681,-49.448]],\"c\":true}},\"nm\":\"R\"},{\"ind\":1,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,9.164],[17.322,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,-14.703],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[6.445,-3.827]],\"v\":[[63.245,-42.297],[37.463,-66.165],[5.035,-66.165],[5.035,0],[25.681,0],[25.681,-19.135],[33.636,-19.135],[42.599,0],[66.769,0],[53.677,-22.76]],\"c\":true}},\"nm\":\"R\"}],\"nm\":\"R\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"v\",\"size\":96,\"style\":\"Black\",\"w\":52.2,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[39.578,0],[53.275,-52.167],[35.147,-52.167],[26.587,-13.394],[18.027,-52.167],[-0.504,-52.167],[13.193,0]],\"c\":true}},\"nm\":\"v\"}],\"nm\":\"v\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"A\",\"size\":96,\"style\":\"Black\",\"w\":67.3,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[-3.122,0],[-3.525,0.504],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[3.424,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[3.323,0.504]],\"v\":[[33.536,-11.078],[43.808,-11.884],[46.426,0],[68.582,0],[48.944,-66.165],[18.832,-66.165],[-0.906,0],[21.249,0],[23.868,-11.783]],\"c\":true}},\"nm\":\"A\"},{\"ind\":1,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[2.316,0],[2.216,0.201],[0,0],[0,0]],\"o\":[[-2.115,0],[0,0],[0,0],[-2.417,0.302]],\"v\":[[33.536,-25.681],[27.09,-25.983],[33.838,-56.094],[40.585,-26.083]],\"c\":true}},\"nm\":\"A\"}],\"nm\":\"A\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"I\",\"size\":96,\"style\":\"Black\",\"w\":30.4,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[4.935,-66.165],[4.935,0],[25.681,0],[25.681,-66.165]],\"c\":true}},\"nm\":\"I\"}],\"nm\":\"I\"}]},\"fFamily\":\"Charlie Display\"},{\"ch\":\"D\",\"size\":64,\"style\":\"Bold\",\"w\":72.22,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[-5.29,2.914],[-2.832,5.437],[0,7.585],[2.832,5.42],[5.257,2.914],[7.291,0],[0,0],[0,0],[0,0],[-3.142,-1.66],[-1.611,-3.467],[0,-5.403],[1.595,-3.483],[3.174,-1.66],[4.688,0],[0,0],[0,0],[0,0]],\"o\":[[5.289,-2.913],[2.832,-5.436],[0,-7.552],[-2.832,-5.42],[-5.257,-2.913],[0,0],[0,0],[0,0],[4.655,0],[3.141,1.66],[1.611,3.467],[0,5.437],[-1.595,3.484],[-3.174,1.66],[0,0],[0,0],[0,0],[7.389,0]],\"v\":[[51.196,-4.37],[63.379,-16.895],[67.627,-36.426],[63.379,-55.884],[51.245,-68.384],[32.422,-72.754],[12.988,-72.754],[12.988,-59.912],[31.543,-59.912],[43.237,-57.422],[50.366,-49.731],[52.783,-36.426],[50.391,-23.047],[43.237,-15.332],[31.445,-12.842],[13.33,-12.842],[13.33,0],[32.178,0]],\"c\":true}},\"nm\":\"D\"},{\"ind\":1,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[6.592,-72.754],[6.592,0],[21.484,0],[21.484,-72.754]],\"c\":true}},\"nm\":\"D\"}],\"nm\":\"D\"}]},\"fFamily\":\"Atlassian Sans\"},{\"ch\":\"O\",\"size\":64,\"style\":\"Bold\",\"w\":77.05,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[-5.111,2.93],[-2.979,5.566],[0,7.878],[2.979,5.583],[5.11,2.93],[6.445,0],[5.127,-2.93],[2.979,-5.582],[0,-7.91],[-2.979,-5.566],[-5.127,-2.93],[-6.413,0]],\"o\":[[5.11,-2.93],[2.979,-5.566],[0,-7.91],[-2.979,-5.582],[-5.111,-2.93],[-6.413,0],[-5.127,2.93],[-2.979,5.583],[0,7.878],[2.979,5.566],[5.127,2.93],[6.445,0]],\"v\":[[55.859,-3.418],[67.993,-16.162],[72.461,-36.328],[67.993,-56.567],[55.859,-69.336],[38.525,-73.73],[21.216,-69.336],[9.058,-56.567],[4.59,-36.328],[9.058,-16.162],[21.216,-3.418],[38.525,0.977]],\"c\":true}},\"nm\":\"O\"},{\"ind\":1,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[2.832,1.855],[1.562,3.581],[0,5.176],[-1.562,3.597],[-2.832,1.855],[-3.744,0],[-2.816,-1.839],[-1.562,-3.596],[0,-5.241],[1.562,-3.596],[2.815,-1.839],[3.776,0]],\"o\":[[-2.832,-1.855],[-1.562,-3.58],[0,-5.208],[1.562,-3.596],[2.832,-1.855],[3.776,0],[2.815,1.839],[1.562,3.597],[0,5.176],[-1.562,3.597],[-2.816,1.839],[-3.744,0]],\"v\":[[28.662,-15.039],[22.07,-23.193],[19.727,-36.328],[22.07,-49.536],[28.662,-57.715],[38.525,-60.498],[48.413,-57.739],[54.98,-49.585],[57.324,-36.328],[54.98,-23.169],[48.413,-15.015],[38.525,-12.256]],\"c\":true}},\"nm\":\"O\"}],\"nm\":\"O\"}]},\"fFamily\":\"Atlassian Sans\"},{\"ch\":\"N\",\"size\":64,\"style\":\"Bold\",\"w\":76.22,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0.114,2.621],[0.195,3.223],[0.195,3.516],[0,0],[-1.416,-2.848],[-1.302,-2.36],[-1.53,-2.506],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.13,-2.799],[-0.179,-3.059],[-0.228,-2.702],[0,0],[1.253,2.702],[1.204,2.214],[1.172,1.888],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,-1.66],[-0.114,-2.62],[-0.195,-3.223],[0,0],[1.953,3.972],[1.416,2.849],[1.302,2.361],[0,0],[0,0],[0,0],[0,0],[0,0],[0,1.953],[0.13,2.8],[0.179,3.06],[0,0],[-1.237,-3.385],[-1.254,-2.702],[-1.205,-2.213],[0,0],[0,0],[0,0],[0,0]],\"v\":[[21.826,0],[21.826,-33.447],[21.655,-39.868],[21.191,-48.633],[20.605,-58.74],[18.701,-58.74],[23.755,-48.511],[27.832,-40.698],[32.08,-33.398],[52.979,0],[69.629,0],[69.629,-72.754],[54.395,-72.754],[54.395,-37.842],[54.59,-30.713],[55.054,-21.924],[55.664,-13.281],[57.178,-13.281],[53.442,-22.412],[49.756,-29.785],[46.191,-35.938],[23.193,-72.754],[6.592,-72.754],[6.592,0]],\"c\":true}},\"nm\":\"N\"}],\"nm\":\"N\"}]},\"fFamily\":\"Atlassian Sans\"},{\"ch\":\"E\",\"size\":64,\"style\":\"Bold\",\"w\":60.74,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[55.371,0],[55.371,-12.354],[21.484,-12.354],[21.484,-30.664],[52.734,-30.664],[52.734,-42.822],[21.484,-42.822],[21.484,-60.4],[55.273,-60.4],[55.273,-72.754],[6.592,-72.754],[6.592,0]],\"c\":true}},\"nm\":\"E\"}],\"nm\":\"E\"}]},\"fFamily\":\"Atlassian Sans\"},{\"ch\":\"I\",\"size\":64,\"style\":\"Bold\",\"w\":47.66,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[44.043,0],[44.043,-12.354],[31.299,-12.354],[31.299,-60.4],[44.043,-60.4],[44.043,-72.754],[3.613,-72.754],[3.613,-60.4],[16.357,-60.4],[16.357,-12.354],[3.613,-12.354],[3.613,0]],\"c\":true}},\"nm\":\"I\"}],\"nm\":\"I\"}]},\"fFamily\":\"Atlassian Sans\"},{\"ch\":\" \",\"size\":64,\"style\":\"Bold\",\"w\":23.68,\"data\":{},\"fFamily\":\"Atlassian Sans\"},{\"ch\":\"P\",\"size\":64,\"style\":\"Bold\",\"w\":64.79,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[-1.986,-1.025],[-0.961,-1.839],[0,-2.441],[0.96,-1.855],[1.969,-1.057],[3.059,0],[0,0],[0,0],[0,0],[-3.923,2.068],[-2.068,3.662],[0,4.818],[2.034,3.695],[3.873,2.1],[5.534,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[3.059,0],[1.985,1.025],[0.96,1.839],[0,2.441],[-0.961,1.855],[-1.97,1.058],[0,0],[0,0],[0,0],[5.598,0],[3.922,-2.067],[2.067,-3.662],[0,-4.785],[-2.035,-3.694],[-3.874,-2.1],[0,0],[0,0],[0,0]],\"v\":[[21.484,0],[21.484,-60.449],[32.178,-60.449],[39.746,-58.911],[44.165,-54.614],[45.605,-48.193],[44.165,-41.748],[39.771,-37.378],[32.227,-35.791],[16.357,-35.791],[16.357,-23.779],[34.619,-23.779],[48.901,-26.88],[57.886,-35.474],[60.986,-48.193],[57.935,-60.913],[49.072,-69.604],[34.961,-72.754],[6.592,-72.754],[6.592,0]],\"c\":true}},\"nm\":\"P\"}],\"nm\":\"P\"}]},\"fFamily\":\"Atlassian Sans\"},{\"ch\":\"R\",\"size\":64,\"style\":\"Bold\",\"w\":65.67,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[-1.97,-0.879],[-0.977,-1.676],[0,-2.473],[0.977,-1.643],[1.953,-0.83],[3.059,0],[0,0],[0,0],[0,0],[-3.923,1.839],[-2.068,3.467],[0,4.785],[2.034,3.548],[3.873,1.953],[5.534,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[3.059,0],[1.969,0.879],[0.977,1.677],[0,2.409],[-0.977,1.644],[-1.953,0.83],[0,0],[0,0],[0,0],[5.598,0],[3.922,-1.839],[2.067,-3.467],[0,-4.785],[-2.035,-3.548],[-3.874,-1.953],[0,0],[0,0],[0,0]],\"v\":[[21.484,0],[21.484,-60.449],[32.178,-60.449],[39.722,-59.131],[44.141,-55.298],[45.605,-49.072],[44.141,-42.993],[39.746,-39.282],[32.227,-38.037],[15.381,-38.037],[15.381,-25.977],[34.619,-25.977],[48.901,-28.735],[57.886,-36.694],[60.986,-49.072],[57.935,-61.572],[49.072,-69.824],[34.961,-72.754],[6.592,-72.754],[6.592,0]],\"c\":true}},\"nm\":\"R\"},{\"ind\":1,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[63.574,0],[45.508,-33.105],[29.346,-33.105],[47.07,0]],\"c\":true}},\"nm\":\"R\"}],\"nm\":\"R\"}]},\"fFamily\":\"Atlassian Sans\"},{\"ch\":\"G\",\"size\":64,\"style\":\"Bold\",\"w\":75.98,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[-2.8,1.253],[-1.709,2.181],[-0.781,2.832],[0,3.125],[0,0],[0,0],[1.334,-2.441],[2.49,-1.318],[3.483,0],[2.897,1.888],[1.595,3.597],[0,5.144],[-1.595,3.581],[-2.865,1.872],[-3.744,0],[-1.693,-0.504],[-1.318,-0.977],[-0.928,-1.383],[-0.521,-1.758],[0,0],[1.741,2.979],[2.75,2.181],[3.532,1.189],[4.102,0],[5.11,-2.962],[2.995,-5.582],[0,-7.877],[-2.881,-5.582],[-4.916,-3.011],[-6.12,0]],\"o\":[[2.799,-1.253],[1.709,-2.18],[0.781,-2.832],[0,0],[0,0],[0,3.32],[-1.335,2.441],[-2.49,1.318],[-3.939,0],[-2.898,-1.888],[-1.595,-3.596],[0,-5.143],[1.595,-3.58],[2.864,-1.871],[2.018,0],[1.692,0.505],[1.318,0.977],[0.928,1.384],[0,0],[-0.521,-3.613],[-1.742,-2.979],[-2.751,-2.18],[-3.532,-1.188],[-6.38,0],[-5.111,2.962],[-2.995,5.583],[0,7.65],[2.881,5.583],[4.915,3.011],[4.036,0]],\"v\":[[47.412,-0.903],[54.175,-6.055],[57.91,-13.574],[59.082,-22.51],[59.082,-28.516],[55.811,-28.516],[53.809,-19.873],[48.071,-14.233],[39.111,-12.256],[28.857,-15.088],[22.119,-23.315],[19.727,-36.426],[22.119,-49.512],[28.809,-57.69],[38.721,-60.498],[44.287,-59.741],[48.804,-57.52],[52.173,-53.979],[54.346,-49.268],[69.482,-49.268],[66.089,-59.155],[59.351,-66.895],[49.927,-71.948],[38.477,-73.73],[21.24,-69.287],[9.082,-56.47],[4.59,-36.279],[8.911,-16.431],[20.605,-3.54],[37.158,0.977]],\"c\":true}},\"nm\":\"G\"},{\"ind\":1,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[70.215,0],[70.215,-38.77],[39.941,-38.77],[39.941,-27.441],[58.35,-27.441],[58.35,-17.236],[60.303,0]],\"c\":true}},\"nm\":\"G\"}],\"nm\":\"G\"}]},\"fFamily\":\"Atlassian Sans\"},{\"ch\":\"S\",\"size\":64,\"style\":\"Bold\",\"w\":65.48,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[-4.199,1.79],[-2.214,3.271],[0,4.395],[1.09,2.344],[1.985,1.709],[2.637,1.172],[3.059,0.684],[0,0],[1.79,0.732],[1.074,1.189],[0,1.791],[-0.928,1.27],[-1.791,0.716],[-2.507,0],[-2.23,-1.595],[-0.261,-2.93],[0,0],[2.246,3.271],[4.004,1.839],[5.371,0],[4.118,-1.823],[2.36,-3.288],[0,-4.395],[-3.484,-3.206],[-6.152,-1.497],[0,0],[-1.855,-0.813],[-0.993,-1.123],[0,-1.66],[1.106,-1.399],[1.969,-0.764],[2.669,0],[2.116,0.814],[1.27,1.644],[0.195,2.441],[0,0],[-2.409,-3.516],[-4.314,-1.79],[-5.827,0]],\"o\":[[4.199,-1.79],[2.213,-3.271],[0,-3.059],[-1.091,-2.344],[-1.986,-1.709],[-2.637,-1.172],[0,0],[-2.019,-0.488],[-1.791,-0.732],[-1.074,-1.188],[0,-1.627],[0.928,-1.27],[1.79,-0.716],[3.711,0],[2.229,1.595],[0,0],[-0.066,-4.264],[-2.246,-3.271],[-4.004,-1.839],[-5.273,0],[-4.118,1.823],[-2.361,3.288],[0,5.273],[3.483,3.207],[0,0],[2.669,0.619],[1.855,0.814],[0.993,1.123],[0,1.855],[-1.107,1.4],[-1.97,0.765],[-2.67,0],[-2.116,-0.813],[-1.27,-1.643],[0,0],[0.13,5.144],[2.409,3.516],[4.313,1.79],[5.891,0]],\"v\":[[48.389,-1.611],[58.008,-9.204],[61.328,-20.703],[59.692,-28.809],[55.078,-34.888],[48.145,-39.209],[39.6,-41.992],[33.008,-43.604],[27.295,-45.435],[22.998,-48.315],[21.387,-52.783],[22.778,-57.129],[26.855,-60.107],[33.301,-61.182],[42.212,-58.789],[45.947,-52.002],[60.352,-52.002],[56.885,-63.306],[47.51,-70.972],[33.447,-73.73],[19.36,-70.996],[9.644,-63.33],[6.104,-51.807],[11.328,-39.087],[25.781,-32.031],[33.789,-30.029],[40.576,-27.881],[44.849,-24.976],[46.338,-20.801],[44.678,-15.918],[40.063,-12.671],[33.105,-11.523],[25.928,-12.744],[20.85,-16.431],[18.652,-22.559],[4.15,-22.559],[7.959,-9.57],[18.042,-1.611],[33.252,1.074]],\"c\":true}},\"nm\":\"S\"}],\"nm\":\"S\"}]},\"fFamily\":\"Atlassian Sans\"},{\"ch\":\"T\",\"size\":64,\"style\":\"Bold\",\"w\":66.75,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[25.928,-60.4],[25.928,0],[40.869,0],[40.869,-60.4],[63.086,-60.4],[63.086,-72.754],[3.662,-72.754],[3.662,-60.4]],\"c\":true}},\"nm\":\"T\"}],\"nm\":\"T\"}]},\"fFamily\":\"Atlassian Sans\"}]}");

});


parcelRegister("6HCeC", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiPreviewModal", function () { return $aa8e2f30f553fcbf$export$10f9150bed23074; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react-hooks/exhaustive-deps */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $4WS03 = parcelRequire("4WS03");

var $h6Fsc = parcelRequire("h6Fsc");

var $63bv7 = parcelRequire("63bv7");

var $ljrfG = parcelRequire("ljrfG");

var $kbpa7 = parcelRequire("kbpa7");

var $kYjgt = parcelRequire("kYjgt");

var $jUBSR = parcelRequire("jUBSR");

var $33kEK = parcelRequire("33kEK");

var $6qT9Y = parcelRequire("6qT9Y");

var $6G35q = parcelRequire("6G35q");

var $aBUAq = parcelRequire("aBUAq");
const $aa8e2f30f553fcbf$var$REVEAL_INTERVAL_MS = 250;
const $aa8e2f30f553fcbf$var$backgroundCss = null;
const $aa8e2f30f553fcbf$var$mainContainerCss = null;
const $aa8e2f30f553fcbf$var$headerContainerCss = null;
const $aa8e2f30f553fcbf$var$headerContainerShowCss = null;
const $aa8e2f30f553fcbf$var$bodyContainerCss = null;
const $aa8e2f30f553fcbf$var$promptSlideOutKeyframes = null;
const $aa8e2f30f553fcbf$var$promptSlideInKeyframes = null;
const $aa8e2f30f553fcbf$var$promptContainerCss = null;
const $aa8e2f30f553fcbf$var$promptContainerShowAnimationCss = null;
const $aa8e2f30f553fcbf$var$promptContainerHideAnimationCss = null;
const $aa8e2f30f553fcbf$export$10f9150bed23074 = ({ onClose: onClose })=>{
    const intl = (0, $8e22h.default)();
    const { cgsDataLoading: cgsDataLoading, formattedCgsData: formattedCgsData, rawCgsData: rawCgsData, firePaidJiraAi: firePaidJiraAi, promptAttemptIndex: promptAttemptIndex, isErrorFromCgs: isErrorFromCgs } = (0, $jUBSR.useJiraAiFFL)();
    const [showJiraSpaceReady, setShowJiraSpaceReady] = (0, $1oC0p.useState)(false);
    const [jiraSpaceShownAtLeastOnce, setJiraSpaceShownAtLeastOnce] = (0, $1oC0p.useState)(false);
    const [progressiveRows, setProgressiveRows] = (0, $1oC0p.useState)(undefined);
    const revealTimeoutsRef = (0, $1oC0p.useRef)([]);
    const modalOpenedAtRef = (0, $1oC0p.useRef)(null);
    const revealStartedAtRef = (0, $1oC0p.useRef)(null);
    const rowsRevealedCountRef = (0, $1oC0p.useRef)(0);
    const revealPlannedMsRef = (0, $1oC0p.useRef)(null);
    const firePaidJiraAiRef = (0, $1oC0p.useRef)(firePaidJiraAi);
    const promptAttemptIndexRef = (0, $1oC0p.useRef)(promptAttemptIndex);
    const headerContainerRef = (0, $1oC0p.useRef)(null);
    const [showLoadingState, setShowLoadingState] = (0, $1oC0p.useState)(false);
    const [bodyContainerPositionY, setBodyContainerPositionY] = (0, $1oC0p.useState)(0);
    const clearRevealTimeouts = (0, $1oC0p.useCallback)(()=>{
        revealTimeoutsRef.current.forEach((t)=>window.clearTimeout(t));
        revealTimeoutsRef.current = [];
    }, []);
    // Disable scrolling in body
    (0, $1oC0p.useEffect)(()=>{
        window.document.body.style.overflow = "hidden";
        return ()=>{
            window.document.body.style.overflow = "";
        };
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        firePaidJiraAiRef.current = firePaidJiraAi;
    }, [
        firePaidJiraAi
    ]);
    (0, $1oC0p.useEffect)(()=>{
        promptAttemptIndexRef.current = promptAttemptIndex;
    }, [
        promptAttemptIndex
    ]);
    (0, $1oC0p.useEffect)(()=>{
        modalOpenedAtRef.current = performance.now();
        firePaidJiraAiRef.current("PreviewModalOpened", "viewed", {
            promptAttemptIndex: promptAttemptIndexRef.current
        });
        // Cleanup on unmount.
        return ()=>clearRevealTimeouts();
    }, []);
    // Show loading UI while loading
    (0, $1oC0p.useEffect)(()=>{
        if (cgsDataLoading) {
            clearRevealTimeouts();
            setShowJiraSpaceReady(false);
            setProgressiveRows(undefined);
        }
    }, [
        cgsDataLoading
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (cgsDataLoading) setShowLoadingState(true);
    }, [
        cgsDataLoading
    ]);
    // Progressive reveal: append rows one-by-one so customers see "AI generating" behavior.
    // Note: this is a UI effect; the API response still arrives as a single payload.
    (0, $1oC0p.useEffect)(()=>{
        if (!formattedCgsData || formattedCgsData.length === 0) return;
        clearRevealTimeouts();
        setShowJiraSpaceReady(false);
        rowsRevealedCountRef.current = 0;
        revealStartedAtRef.current = performance.now();
        revealPlannedMsRef.current = formattedCgsData.length * $aa8e2f30f553fcbf$var$REVEAL_INTERVAL_MS;
        firePaidJiraAiRef.current("PreviewRevealStarted", "started", {
            promptAttemptIndex: promptAttemptIndexRef.current,
            rowCount: formattedCgsData.length,
            revealPlannedMs: revealPlannedMsRef.current
        });
        // Keep a fixed height while revealing (shows placeholder rows).
        const minRowCount = 6;
        const targetLen = Math.max(minRowCount, formattedCgsData.length);
        setProgressiveRows(Array.from({
            length: targetLen
        }));
        formattedCgsData.forEach((row, idx)=>{
            const t = window.setTimeout(()=>{
                setProgressiveRows((prev)=>{
                    if (!prev) return prev;
                    const next = [
                        ...prev
                    ];
                    next[idx] = row;
                    rowsRevealedCountRef.current = Math.max(rowsRevealedCountRef.current, idx + 1);
                    return next;
                });
            }, idx * $aa8e2f30f553fcbf$var$REVEAL_INTERVAL_MS);
            revealTimeoutsRef.current.push(t);
        });
        // Mark workspace ready only after the table finishes populating.
        const done = window.setTimeout(()=>{
            setProgressiveRows(formattedCgsData);
            setShowJiraSpaceReady(true);
            setJiraSpaceShownAtLeastOnce(true);
            setShowLoadingState(false);
            const now = performance.now();
            const revealDurationMs = revealStartedAtRef.current ? Math.max(0, now - revealStartedAtRef.current) : undefined;
            const dwellMs = modalOpenedAtRef.current ? Math.max(0, now - modalOpenedAtRef.current) : undefined;
            var _revealPlannedMsRef_current;
            firePaidJiraAiRef.current("PreviewReady", "succeeded", {
                promptAttemptIndex: promptAttemptIndexRef.current,
                rowCount: formattedCgsData.length,
                revealDurationMs: revealDurationMs,
                revealPlannedMs: (_revealPlannedMsRef_current = revealPlannedMsRef.current) !== null && _revealPlannedMsRef_current !== void 0 ? _revealPlannedMsRef_current : undefined,
                dwellMs: dwellMs
            });
        }, formattedCgsData.length * $aa8e2f30f553fcbf$var$REVEAL_INTERVAL_MS + 50);
        revealTimeoutsRef.current.push(done);
    }, [
        formattedCgsData
    ]);
    // Close modal on esc press
    (0, $1oC0p.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            // If user is focused on the contentEditable span input, then don't close the modal on esc
            const active = document.activeElement;
            if ((active === null || active === void 0 ? void 0 : active.isContentEditable) || active instanceof HTMLInputElement) return;
            if (event.key === "Escape") onClose === null || onClose === void 0 ? void 0 : onClose();
        };
        window.addEventListener("keydown", handleKeyDown);
        // Cleanup
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, []);
    const handleClose = (0, $1oC0p.useCallback)(()=>{
        const now = performance.now();
        const dwellMs = modalOpenedAtRef.current ? Math.max(0, now - modalOpenedAtRef.current) : undefined;
        firePaidJiraAiRef.current("PreviewModalClosed", "closed", {
            promptAttemptIndex: promptAttemptIndexRef.current,
            closeReason: "xButton",
            dwellMs: dwellMs,
            rowsRevealedCount: rowsRevealedCountRef.current
        });
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [
        onClose
    ]);
    // Position adjustment for sliding animation
    // Adjust y position for body element when header height changes
    (0, $1oC0p.useEffect)(()=>{
        if (!showJiraSpaceReady) {
            setBodyContainerPositionY(0);
            return;
        }
        const updatePosition = ()=>{
            var _headerContainerRef_current;
            const headerHeight = ((_headerContainerRef_current = headerContainerRef.current) === null || _headerContainerRef_current === void 0 ? void 0 : _headerContainerRef_current.offsetHeight) || 0;
            setBodyContainerPositionY(headerHeight + 16);
        };
        const timer = setTimeout(updatePosition);
        window.addEventListener("resize", updatePosition);
        // Cleanup
        return ()=>{
            clearTimeout(timer);
            window.removeEventListener("resize", updatePosition);
        };
    }, [
        isErrorFromCgs,
        showJiraSpaceReady
    ]); // Keep isErrorFromCgs, ref height changes on error
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqsw1n9t _1pbyb4wl _1bsbauwl _4t3i1kxc _1ltvidpf _154iidpf _11q7cd5j"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6qT9Y.Background), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqsw1n9t _1e02idpf _152tidpf _1bsbauwl _4t3i1kxc _1pbyjwwv _ca0qgktf _u5f31f4h _n3tdgktf _19bv1f4h _1reo15zi _18m915zi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $ljrfG.default), {
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $63bv7.JiraIcon), {
                                appearance: "brand",
                                shouldUseNewLogoDesign: true
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                                shape: "circle",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($h6Fsc))),
                                label: intl.formatMessage((0, $kYjgt.messages).close),
                                appearance: "default",
                                onClick: handleClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        ref: headerContainerRef,
                        className: (0, $2jatx.default)([
                            "_m6k41rjc _kqswstnw _1bsbkest _t9ec13ve _tzy4idpf _v5646wc9",
                            showJiraSpaceReady && "_t9ec1kli _tzy4kb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6G35q.Header), {
                            onRetryClick: ()=>{
                                firePaidJiraAi("PreviewRetryClicked", "clicked", {
                                    promptAttemptIndex: promptAttemptIndex,
                                    rowsRevealedCount: rowsRevealedCountRef.current
                                });
                                clearRevealTimeouts();
                                setShowJiraSpaceReady(false);
                                setProgressiveRows(undefined);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        style: {
                            transform: `translateY(${bodyContainerPositionY}px)`
                        },
                        className: (0, $2jatx.default)([
                            "_m6k41e03 _kqswh2mm _v564o8wx _1pfhviql"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aBUAq.PreviewTable), {
                                rows: progressiveRows !== null && progressiveRows !== void 0 ? progressiveRows : formattedCgsData,
                                spaceName: cgsDataLoading ? undefined : rawCgsData === null || rawCgsData === void 0 ? void 0 : rawCgsData.sampleIssues.spaceName
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfhckbl _y3gn1h6o _m6k41rjc _kqswh2mm",
                                    showJiraSpaceReady && "",
                                    showJiraSpaceReady && "_y44v15q7",
                                    !showJiraSpaceReady && jiraSpaceShownAtLeastOnce && "",
                                    !showJiraSpaceReady && jiraSpaceShownAtLeastOnce && "_y44vayar"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33kEK.PaidJiraAiTeamTypeMadLibPrompt), {
                                    isRerun: true,
                                    showLoadingState: showLoadingState
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("ljrfG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f84082fe6c13430b$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1oC0p = parcelRequire("1oC0p");

var $3HaTX = parcelRequire("3HaTX");
var $f84082fe6c13430b$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $f84082fe6c13430b$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $f84082fe6c13430b$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $f84082fe6c13430b$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $f84082fe6c13430b$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $f84082fe6c13430b$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $f84082fe6c13430b$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $f84082fe6c13430b$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    return /*#__PURE__*/ $1oC0p.createElement(Component, {
        role: role,
        className: (0, $3HaTX.default)([
            $f84082fe6c13430b$var$styles.root,
            gap && $f84082fe6c13430b$var$columnGapMap[gap],
            columnGap && $f84082fe6c13430b$var$columnGapMap[columnGap],
            gap && $f84082fe6c13430b$var$rowGapMap[gap],
            rowGap && $f84082fe6c13430b$var$rowGapMap[rowGap],
            alignItems && $f84082fe6c13430b$var$alignItemsMap[alignItems],
            direction && $f84082fe6c13430b$var$flexDirectionMap[direction],
            justifyContent && $f84082fe6c13430b$var$justifyContentMap[justifyContent],
            wrap && $f84082fe6c13430b$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$f84082fe6c13430b$var$Flex.displayName = 'Flex';
var $f84082fe6c13430b$export$2e2bcd8739ae039 = $f84082fe6c13430b$var$Flex;

});
parcelRegister("3HaTX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2b0dd80d67d56afd$export$2e2bcd8739ae039; });
const $2b0dd80d67d56afd$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $2b0dd80d67d56afd$var$ATOMIC_GROUP_LENGTH = 5;
function $2b0dd80d67d56afd$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $2b0dd80d67d56afd$var$UNDERSCORE_UNICODE ? $2b0dd80d67d56afd$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});


parcelRegister("jUBSR", function(module, exports) {
$parcel$export(module.exports, "JiraAiFFLProvider", function () { return $0fa7666158234ad7$export$cb2adc27ad575a30; });
$parcel$export(module.exports, "useJiraAiFFL", function () { return $0fa7666158234ad7$export$2741bae471e27db6; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eLTTO = parcelRequire("eLTTO");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7XYQW = parcelRequire("7XYQW");

var $427NR = parcelRequire("427NR");

var $PE2DD = parcelRequire("PE2DD");

var $kYjgt = parcelRequire("kYjgt");

var $6qhMT = parcelRequire("6qhMT");

var $fx9D8 = parcelRequire("fx9D8");
const $0fa7666158234ad7$var$noop = ()=>{
/* empty */ };
const $0fa7666158234ad7$var$defaultContext = {
    submit: $0fa7666158234ad7$var$noop,
    selectedTeamType: (0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT),
    setSelectedTeamType: $0fa7666158234ad7$var$noop,
    workingOnSuggestion: "",
    goalSuggestion: "",
    workingOnValue: "",
    goalValue: "",
    setWorkingOnValue: $0fa7666158234ad7$var$noop,
    setGoalValue: $0fa7666158234ad7$var$noop,
    hasUserSelectedTeamType: false,
    setHasUserSelectedTeamType: $0fa7666158234ad7$var$noop,
    hasSubmittedDefaultValues: false,
    shuffle: $0fa7666158234ad7$var$noop,
    suggestMadLib: $0fa7666158234ad7$var$noop,
    promptAttemptIndex: 0,
    commonAnalyticsAttributes: {
        flow: (0, $6qhMT.PAID_JIRA_AI_FLOW),
        experimentKey: (0, $6qhMT.PAID_JIRA_AI_EXPERIMENT_KEY)
    },
    firePaidJiraAi: $0fa7666158234ad7$var$noop,
    markPromptChangedField: $0fa7666158234ad7$var$noop,
    cgsDataLoading: false,
    isErrorFromCgs: false,
    rawCgsData: undefined,
    formattedCgsData: undefined,
    setIsErrorFromCgs: $0fa7666158234ad7$var$noop
};
const $0fa7666158234ad7$var$JiraAiFFLContext = /*#__PURE__*/ (0, $1oC0p.createContext)($0fa7666158234ad7$var$defaultContext);
const $0fa7666158234ad7$export$cb2adc27ad575a30 = ({ children: children, anchor: anchor, subAnchor: subAnchor })=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eLTTO.useGoogleReCaptcha)();
    // Analytics state
    const [promptAttemptIndex, setPromptAttemptIndex] = (0, $1oC0p.useState)(0);
    const promptAttemptIndexRef = (0, $1oC0p.useRef)(0);
    const changedFieldsRef = (0, $1oC0p.useRef)(new Set());
    const [changedFieldsVersion, setChangedFieldsVersion] = (0, $1oC0p.useState)(0);
    const engagedAtRef = (0, $1oC0p.useRef)(null);
    const hasSubmittedThisAttemptRef = (0, $1oC0p.useRef)(false);
    const hasFiredViewedRef = (0, $1oC0p.useRef)(false);
    const hasFiredEngagedRef = (0, $1oC0p.useRef)(false);
    const hasFiredAbandonedRef = (0, $1oC0p.useRef)(false);
    var _getTeamTypeFromAnchor;
    // Shared Madlib UI state
    const [selectedTeamType, setSelectedTeamType] = (0, $1oC0p.useState)((_getTeamTypeFromAnchor = (0, $fx9D8.getTeamTypeFromAnchor)(anchor, subAnchor)) !== null && _getTeamTypeFromAnchor !== void 0 ? _getTeamTypeFromAnchor : $0fa7666158234ad7$var$defaultContext.selectedTeamType);
    const [workingOnSuggestion, setWorkingOnSuggestion] = (0, $1oC0p.useState)("");
    const [goalSuggestion, setGoalSuggestion] = (0, $1oC0p.useState)("");
    const [workingOnValue, setWorkingOnValue] = (0, $1oC0p.useState)("");
    const [goalValue, setGoalValue] = (0, $1oC0p.useState)("");
    const [hasUserSelectedTeamType, setHasUserSelectedTeamType] = (0, $1oC0p.useState)(false);
    const [hasSubmittedDefaultValues, setHasSubmittedDefaultValues] = (0, $1oC0p.useState)(false);
    const initialSuggestion = (0, $1oC0p.useRef)();
    const suggestionsIndex = (0, $1oC0p.useRef)({
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_MARKETING)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DESIGN)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT)]: 0
    });
    // CGS state
    const [cgsDataLoading, setCgsDataLoading] = (0, $1oC0p.useState)(false);
    const [isErrorFromCgs, setIsErrorFromCgs] = (0, $1oC0p.useState)(false);
    const [cgsData, setCgsData] = (0, $1oC0p.useState)(undefined);
    (0, $1oC0p.useEffect)(()=>{
        promptAttemptIndexRef.current = promptAttemptIndex;
    }, [
        promptAttemptIndex
    ]);
    const getChangedFields = ()=>Array.from(changedFieldsRef.current);
    const workingOnLength = (0, $1oC0p.useMemo)(()=>workingOnValue.trim().length, [
        workingOnValue
    ]);
    const goalLength = (0, $1oC0p.useMemo)(()=>goalValue.trim().length, [
        goalValue
    ]);
    const promptType = (0, $1oC0p.useMemo)(()=>(0, $6qhMT.derivePromptType)({
            workingOnValue: workingOnValue,
            goalValue: goalValue,
            workingOnSuggestion: workingOnSuggestion,
            goalSuggestion: goalSuggestion
        }), [
        workingOnValue,
        goalValue,
        workingOnSuggestion,
        goalSuggestion
    ]);
    const teamTypeCategory = (0, $1oC0p.useMemo)(()=>(0, $6qhMT.categorizeTeamType)(selectedTeamType), [
        selectedTeamType
    ]);
    const commonAnalyticsAttributes = (0, $1oC0p.useMemo)(()=>{
        const changedFields = getChangedFields();
        const cgsKey = typeof window !== "undefined" ? (0, $6qhMT.getCgsKeyFromLocationHref)(window.location.href) : undefined;
        return {
            flow: (0, $6qhMT.PAID_JIRA_AI_FLOW),
            experimentKey: (0, $6qhMT.PAID_JIRA_AI_EXPERIMENT_KEY),
            teamType: selectedTeamType,
            teamTypeCategory: teamTypeCategory,
            promptAttemptIndex: promptAttemptIndex,
            isRetry: promptAttemptIndex > 1,
            promptType: promptType,
            didChangeAnything: changedFields.length > 0,
            changedFields: changedFields,
            workingOnLength: workingOnLength,
            goalLength: goalLength,
            cgsKey: cgsKey
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedTeamType,
        teamTypeCategory,
        promptAttemptIndex,
        promptType,
        workingOnLength,
        goalLength,
        changedFieldsVersion
    ]);
    const firePaidJiraAi = (0, $1oC0p.useCallback)((step, action, attributes = {})=>{
        (0, $6qhMT.firePaidJiraAiEvent)(createAnalyticsEvent, {
            step: step,
            action: action,
            attributes: (0, $6ogO3._)({}, commonAnalyticsAttributes, attributes)
        });
    }, [
        createAnalyticsEvent,
        commonAnalyticsAttributes
    ]);
    const markPromptEngaged = (0, $1oC0p.useCallback)(()=>{
        if (!engagedAtRef.current) engagedAtRef.current = performance.now();
        if (!hasFiredEngagedRef.current) {
            hasFiredEngagedRef.current = true;
            firePaidJiraAi("PromptEngaged", "started");
        }
    }, [
        firePaidJiraAi
    ]);
    const markPromptChangedField = (0, $1oC0p.useCallback)((field)=>{
        markPromptEngaged();
        if (!changedFieldsRef.current.has(field)) {
            changedFieldsRef.current.add(field);
            setChangedFieldsVersion((v)=>v + 1);
        }
    }, [
        markPromptEngaged
    ]);
    // Prompt view + abandonment tracking
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFiredViewedRef.current) {
            hasFiredViewedRef.current = true;
            firePaidJiraAi("PromptViewed", "viewed");
        }
        const maybeFireAbandoned = ()=>{
            if (hasFiredAbandonedRef.current) return;
            if (!engagedAtRef.current || hasSubmittedThisAttemptRef.current) return;
            hasFiredAbandonedRef.current = true;
            firePaidJiraAi("PromptAbandoned", "closed", {
                dwellMs: Math.max(0, performance.now() - engagedAtRef.current)
            });
        };
        window.addEventListener("pagehide", maybeFireAbandoned);
        const onVisibilityChange = ()=>{
            if (document.visibilityState === "hidden") maybeFireAbandoned();
        };
        document.addEventListener("visibilitychange", onVisibilityChange);
        return ()=>{
            window.removeEventListener("pagehide", maybeFireAbandoned);
            document.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, [
        firePaidJiraAi
    ]);
    const suggestMadLib = (teamType)=>{
        const t = teamType || selectedTeamType;
        const suggestions = (0, $kYjgt.getSuggestionsForTeamType)(t);
        suggestionsIndex.current[t] = (suggestionsIndex.current[t] || 0) + 1;
        if (!suggestions[suggestionsIndex.current[t]]) suggestionsIndex.current[t] = 0;
        const suggestion = suggestions[suggestionsIndex.current[t]];
        const workingOnSuggestion = intl.formatMessage(suggestion === null || suggestion === void 0 ? void 0 : suggestion.task);
        const goalSuggestion = intl.formatMessage(suggestion === null || suggestion === void 0 ? void 0 : suggestion.goal);
        setWorkingOnSuggestion(workingOnSuggestion);
        setGoalSuggestion(goalSuggestion);
        if (!initialSuggestion.current) initialSuggestion.current = {
            workingOn: workingOnSuggestion,
            goal: goalSuggestion
        };
        setWorkingOnValue("");
        setGoalValue("");
    };
    // Compute anchor config synchronously during render to avoid a production
    // scope-hoisting issue where the minified `anchor` variable inside the
    // useEffect closure resolves to a different binding (markPromptChangedField).
    const anchorConfig = (0, $1oC0p.useMemo)(()=>(0, $fx9D8.getAnchorConfig)(anchor, subAnchor), [
        anchor,
        subAnchor
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $1oC0p.useEffect)(()=>{
        if (anchorConfig) {
            setSelectedTeamType(anchorConfig.teamType);
            suggestionsIndex.current[anchorConfig.teamType] = anchorConfig.suggestionIndex - 1;
            suggestMadLib(anchorConfig.teamType);
        } else suggestMadLib();
    }, [
        anchorConfig
    ]);
    const shuffle = ()=>{
        markPromptChangedField("shuffle");
        firePaidJiraAi("PromptShuffleClicked", "clicked");
        if (!hasUserSelectedTeamType) {
            const teamTypes = Object.keys((0, $fx9D8.teamTypesMap));
            const randomTeamType = teamTypes[Math.floor(Math.random() * teamTypes.length)];
            setSelectedTeamType(randomTeamType);
            suggestMadLib(randomTeamType);
        } else suggestMadLib();
    };
    const formattedCgsData = (0, $1oC0p.useMemo)(()=>{
        if (cgsDataLoading || !cgsData) return undefined;
        return (0, $fx9D8.formatCgsData)(cgsData);
    }, [
        cgsData,
        cgsDataLoading
    ]);
    const getRecaptchaOutcome = async ()=>{
        const recaptchaStart = performance.now();
        let token;
        let recaptchaError;
        try {
            token = await (0, $427NR.getRecaptcha)("", // paid landing is anonymous; token still binds to browser context
            executeRecaptcha);
        } catch (e) {
            recaptchaError = e;
            token = undefined;
        }
        const recaptchaTimeMs = Math.max(0, performance.now() - recaptchaStart);
        const result = token ? "token" : recaptchaError ? "error" : "empty";
        if (token) firePaidJiraAi("RecaptchaTokenSucceeded", "succeeded", {
            recaptchaTimeMs: recaptchaTimeMs
        });
        else firePaidJiraAi("RecaptchaTokenFailed", "failed", (0, $6ogO3._)({
            recaptchaTimeMs: recaptchaTimeMs,
            failureReason: recaptchaError ? "error" : "empty"
        }, (0, $6qhMT.safeErrorContext)(recaptchaError)));
        return {
            token: token !== null && token !== void 0 ? token : "",
            recaptchaTimeMs: recaptchaTimeMs,
            result: result
        };
    };
    const setCgsKeyInUrl = (cgsKey)=>{
        // Persist cgsKey in the URL so downstream flows (e.g. account creation)
        // can pick it up without depending on this context provider.
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set("cgsKey", cgsKey);
        window.history.replaceState(null, "", nextUrl.toString());
    };
    const submit = async (update)=>{
        const { teamType: teamType, workingOn: workingOn, goal: goal } = update;
        const attemptIndex = promptAttemptIndexRef.current + 1;
        const submitStart = performance.now();
        hasSubmittedThisAttemptRef.current = true;
        hasFiredAbandonedRef.current = false;
        const derived = {
            promptAttemptIndex: attemptIndex,
            isRetry: attemptIndex > 1,
            promptType: promptType,
            didChangeAnything: getChangedFields().length > 0,
            changedFields: getChangedFields(),
            workingOnLength: workingOnLength,
            goalLength: goalLength
        };
        setPromptAttemptIndex(attemptIndex);
        setCgsDataLoading(true);
        setIsErrorFromCgs(false);
        let recaptchaOutcome;
        try {
            var _initialSuggestion_current, _initialSuggestion_current1, _formatCgsData;
            // Explicit lifecycle start (click is tracked separately in the prompt component).
            createAnalyticsEvent({
                action: (0, $fx9D8.ANALYTIC_EVENT_ACTION_STARTED),
                eventType: "track",
                actionSubject: (0, $fx9D8.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
                attributes: (0, $6ogO3._)({
                    teamType: teamType,
                    flow: (0, $fx9D8.MADLIB_FLOW)
                }, derived)
            }).fire();
            firePaidJiraAi("ContentGenStarted", "started", derived);
            // Be resilient: even if reCAPTCHA is empty/errored, proceed and let the API
            // decide whether it's required.
            recaptchaOutcome = await getRecaptchaOutcome();
            setHasSubmittedDefaultValues(teamType === $0fa7666158234ad7$var$defaultContext.selectedTeamType && workingOn === ((_initialSuggestion_current = initialSuggestion.current) === null || _initialSuggestion_current === void 0 ? void 0 : _initialSuggestion_current.workingOn) && goal === ((_initialSuggestion_current1 = initialSuggestion.current) === null || _initialSuggestion_current1 === void 0 ? void 0 : _initialSuggestion_current1.goal));
            const response = await stargateClient.postContentGenerationForJiraFfl({
                teamType: teamType,
                workingOnSummary: workingOn,
                goal: goal,
                gRecaptchaResponse: recaptchaOutcome.token
            });
            setCgsData(response);
            setCgsKeyInUrl(response.cacheKey);
            setCgsDataLoading(false);
            var _formatCgsData_length;
            const rowCount = (_formatCgsData_length = (_formatCgsData = (0, $fx9D8.formatCgsData)(response)) === null || _formatCgsData === void 0 ? void 0 : _formatCgsData.length) !== null && _formatCgsData_length !== void 0 ? _formatCgsData_length : 0;
            createAnalyticsEvent({
                action: (0, $fx9D8.ANALYTIC_EVENT_ACTION_SUCCEEDED),
                eventType: "track",
                actionSubject: (0, $fx9D8.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
                attributes: (0, $6ogO3._)({
                    teamType: teamType,
                    flow: (0, $fx9D8.MADLIB_FLOW),
                    timeToCgsMs: Math.max(0, performance.now() - submitStart),
                    rowCount: rowCount,
                    recaptchaTimeMs: recaptchaOutcome.recaptchaTimeMs,
                    recaptchaResult: recaptchaOutcome.result
                }, derived)
            }).fire();
            firePaidJiraAi("ContentGenSucceeded", "succeeded", (0, $6ogO3._)({
                timeToCgsMs: Math.max(0, performance.now() - submitStart),
                rowCount: rowCount,
                recaptchaTimeMs: recaptchaOutcome.recaptchaTimeMs,
                recaptchaResult: recaptchaOutcome.result
            }, derived));
        } catch (error) {
            setCgsDataLoading(false);
            setIsErrorFromCgs(true);
            setCgsData((0, $fx9D8.fallbackCgsData));
            setCgsKeyInUrl((0, $fx9D8.fallbackCgsData).cacheKey);
            const safe = (0, $6qhMT.safeErrorContext)(error);
            createAnalyticsEvent({
                action: (0, $fx9D8.ANALYTIC_EVENT_ACTION_FAILED),
                eventType: "track",
                actionSubject: (0, $fx9D8.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
                attributes: (0, $6ogO3._)({
                    teamType: teamType,
                    flow: (0, $fx9D8.MADLIB_FLOW),
                    error: error.message,
                    timeToCgsMs: Math.max(0, performance.now() - submitStart),
                    recaptchaTimeMs: recaptchaOutcome === null || recaptchaOutcome === void 0 ? void 0 : recaptchaOutcome.recaptchaTimeMs,
                    recaptchaResult: recaptchaOutcome === null || recaptchaOutcome === void 0 ? void 0 : recaptchaOutcome.result
                }, derived, safe)
            }).fire();
            firePaidJiraAi("ContentGenFailed", "failed", (0, $6ogO3._)({
                timeToCgsMs: Math.max(0, performance.now() - submitStart),
                recaptchaTimeMs: recaptchaOutcome === null || recaptchaOutcome === void 0 ? void 0 : recaptchaOutcome.recaptchaTimeMs,
                recaptchaResult: recaptchaOutcome === null || recaptchaOutcome === void 0 ? void 0 : recaptchaOutcome.result
            }, derived, safe));
        } finally{
            // Reset engagement tracking for the next attempt.
            engagedAtRef.current = null;
            hasSubmittedThisAttemptRef.current = false;
            hasFiredEngagedRef.current = false;
            changedFieldsRef.current = new Set();
            setChangedFieldsVersion((v)=>v + 1);
        }
    };
    const value = (0, $1oC0p.useMemo)(()=>({
            submit: submit,
            // Madlib UI state
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            selectedTeamType: selectedTeamType,
            setSelectedTeamType: setSelectedTeamType,
            workingOnSuggestion: workingOnSuggestion,
            goalSuggestion: goalSuggestion,
            workingOnValue: workingOnValue,
            goalValue: goalValue,
            setWorkingOnValue: setWorkingOnValue,
            setGoalValue: setGoalValue,
            hasUserSelectedTeamType: hasUserSelectedTeamType,
            setHasUserSelectedTeamType: setHasUserSelectedTeamType,
            hasSubmittedDefaultValues: hasSubmittedDefaultValues,
            shuffle: shuffle,
            suggestMadLib: suggestMadLib,
            promptAttemptIndex: promptAttemptIndex,
            commonAnalyticsAttributes: commonAnalyticsAttributes,
            firePaidJiraAi: firePaidJiraAi,
            markPromptChangedField: markPromptChangedField,
            cgsDataLoading: // CGS
            cgsDataLoading,
            isErrorFromCgs: isErrorFromCgs,
            rawCgsData: cgsData,
            formattedCgsData: formattedCgsData,
            setIsErrorFromCgs: setIsErrorFromCgs
        }), [
        submit,
        selectedTeamType,
        workingOnSuggestion,
        goalSuggestion,
        workingOnValue,
        goalValue,
        hasUserSelectedTeamType,
        hasSubmittedDefaultValues,
        shuffle,
        suggestMadLib,
        promptAttemptIndex,
        commonAnalyticsAttributes,
        firePaidJiraAi,
        markPromptChangedField,
        cgsDataLoading,
        isErrorFromCgs,
        cgsData,
        formattedCgsData,
        setIsErrorFromCgs
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($0fa7666158234ad7$var$JiraAiFFLContext.Provider, {
        value: value,
        children: children
    });
};
const $0fa7666158234ad7$export$2741bae471e27db6 = ()=>(0, $1oC0p.useContext)($0fa7666158234ad7$var$JiraAiFFLContext);

});
parcelRegister("6qhMT", function(module, exports) {
$parcel$export(module.exports, "PAID_JIRA_AI_FLOW", function () { return $f5661b1f1d377ec0$export$15580d5934f13398; });
$parcel$export(module.exports, "PAID_JIRA_AI_EXPERIMENT_KEY", function () { return $f5661b1f1d377ec0$export$cece5c76676ec0b; });
$parcel$export(module.exports, "categorizeTeamType", function () { return $f5661b1f1d377ec0$export$1029d82c7dcd7984; });
$parcel$export(module.exports, "getCgsKeyFromLocationHref", function () { return $f5661b1f1d377ec0$export$22103f8d80cc8961; });
$parcel$export(module.exports, "derivePromptType", function () { return $f5661b1f1d377ec0$export$c37691d1fa2eace6; });
$parcel$export(module.exports, "firePaidJiraAiEvent", function () { return $f5661b1f1d377ec0$export$9a72bee4029287c2; });
$parcel$export(module.exports, "safeErrorContext", function () { return $f5661b1f1d377ec0$export$b800576c577b2197; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");
const $f5661b1f1d377ec0$export$15580d5934f13398 = "paidLandingJiraAi";
const $f5661b1f1d377ec0$export$cece5c76676ec0b = "cfind4666JiraFfl";
function $f5661b1f1d377ec0$export$1029d82c7dcd7984(teamType) {
    // Keep this stable and explicit so analysis is consistent.
    switch(teamType){
        case "software-development":
        case "it-support":
            return "tech";
        case "product-management":
        case "marketing":
        case "project-management":
        case "design":
            return "biz";
        default:
            return "unknown";
    }
}
function $f5661b1f1d377ec0$export$22103f8d80cc8961(href) {
    try {
        const url = new URL(href);
        var _url_searchParams_get;
        return (_url_searchParams_get = url.searchParams.get("cgsKey")) !== null && _url_searchParams_get !== void 0 ? _url_searchParams_get : undefined;
    } catch (e) {
        return undefined;
    }
}
function $f5661b1f1d377ec0$export$c37691d1fa2eace6(args) {
    var _args_workingOnValue, _args_goalValue;
    const workingOnIsCustom = Boolean((_args_workingOnValue = args.workingOnValue) === null || _args_workingOnValue === void 0 ? void 0 : _args_workingOnValue.trim());
    const goalIsCustom = Boolean((_args_goalValue = args.goalValue) === null || _args_goalValue === void 0 ? void 0 : _args_goalValue.trim());
    if (workingOnIsCustom && goalIsCustom) return "custom";
    if (!workingOnIsCustom && !goalIsCustom) return "template";
    return "mixed";
}
function $f5661b1f1d377ec0$export$9a72bee4029287c2(createAnalyticsEvent, payload) {
    var _payload_eventType;
    createAnalyticsEvent({
        eventType: (_payload_eventType = payload.eventType) !== null && _payload_eventType !== void 0 ? _payload_eventType : "track",
        action: payload.action,
        actionSubject: "paidLandingJiraAiExperiment",
        attributes: (0, $dPABA._)((0, $6ogO3._)({}, payload.attributes), {
            step: payload.step
        })
    }).fire();
}
function $f5661b1f1d377ec0$export$b800576c577b2197(error) {
    if (error instanceof Error) {
        var _error_response;
        const msg = error.message || "";
        if (msg.includes("Missing reCAPTCHA")) return {
            errorType: "recaptcha_missing",
            errorName: error.name,
            message: msg
        };
        return {
            errorType: "unknown",
            errorName: error.name,
            message: msg,
            status: error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status
        };
    }
    // Support UnsuccessfulFetchError-like shapes without importing cross-package types.
    if (error && typeof error === "object") {
        const maybeStatus = error.status;
        if (typeof maybeStatus === "number") return {
            errorType: "http_error",
            status: maybeStatus
        };
    }
    return {
        errorType: "unknown"
    };
}

});


parcelRegister("33kEK", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiTeamTypeMadLibPrompt", function () { return $cd6c6dd32e2ad127$export$df93ffe29d467f53; });
/* paid-jira-ai-team-type-mad-lib-prompt.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $7Sqn0 = parcelRequire("7Sqn0");
var $ddxTX = parcelRequire("ddxTX");

var $4se1R = parcelRequire("4se1R");

var $ahmPu = parcelRequire("ahmPu");

var $9yC2v = parcelRequire("9yC2v");

var $kbpa7 = parcelRequire("kbpa7");

var $kYjgt = parcelRequire("kYjgt");

var $jUBSR = parcelRequire("jUBSR");

var $fx9D8 = parcelRequire("fx9D8");

var $l7lZe = parcelRequire("l7lZe");
const $cd6c6dd32e2ad127$var$modalCss = null;
const $cd6c6dd32e2ad127$var$teamTypeContainerCss = null;
const $cd6c6dd32e2ad127$var$teamTypeButtonsGroupCss = null;
const $cd6c6dd32e2ad127$var$teamTypeButtonStyles = {
    fontWeight: 400,
    borderRadius: 8,
    marginInlineStart: 4,
    marginBlockEnd: 4
};
const $cd6c6dd32e2ad127$var$footerCss = null;
const $cd6c6dd32e2ad127$var$disclaimerCss = null;
const $cd6c6dd32e2ad127$var$poweredByAiCss = null;
const $cd6c6dd32e2ad127$var$footerButtonStyles = {
    borderRadius: "40px",
    paddingLeft: "24px",
    paddingRight: "24px"
};
const $cd6c6dd32e2ad127$export$df93ffe29d467f53 = ({ isRerun: isRerun, showLoadingState: showLoadingState })=>{
    const { submit: submit, cgsDataLoading: cgsDataLoading, selectedTeamType: selectedTeamType, setSelectedTeamType: setSelectedTeamType, workingOnSuggestion: workingOnSuggestion, goalSuggestion: goalSuggestion, workingOnValue: workingOnValue, goalValue: goalValue, setWorkingOnValue: setWorkingOnValue, setGoalValue: setGoalValue, setHasUserSelectedTeamType: setHasUserSelectedTeamType, hasUserSelectedTeamType: hasUserSelectedTeamType, shuffle: shuffle, suggestMadLib: suggestMadLib, setIsErrorFromCgs: setIsErrorFromCgs, firePaidJiraAi: firePaidJiraAi, markPromptChangedField: markPromptChangedField, commonAnalyticsAttributes: commonAnalyticsAttributes, promptAttemptIndex: promptAttemptIndex } = (0, $jUBSR.useJiraAiFFL)();
    const [isFormValid, setIsFormValid] = (0, $1oC0p.useState)(true);
    const handleOnSubmit = async ()=>{
        if (!isFormValid) return;
        // Track click intent separately from the async lifecycle events in the context.
        firePaidJiraAi("BuildWithAIClicked", "clicked", {
            cta: isRerun ? "rerunPrompt" : "getStarted",
            promptAttemptIndex: promptAttemptIndex + 1
        });
        const params = {
            teamType: selectedTeamType,
            workingOnValue: workingOnValue || workingOnSuggestion,
            goalValue: goalValue || goalSuggestion
        };
        await submit({
            teamType: params.teamType,
            workingOn: params.workingOnValue,
            goal: params.goalValue
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1o8l _1bsbn0dd _p12f1osq _16qs1kzk _2rko7vkz _11q7cd5j _ca0q1tcg _u5f3gktf _n3td1tcg _19bvgktf _y3gn1e5h"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            !isRerun ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rth7vkz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ahbqmyb0 _6rthmyb0"
                    ]),
                    children: Object.entries((0, $fx9D8.teamTypesMap)).map(([teamType, { messageKey: messageKey }])=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                            appearance: selectedTeamType === teamType ? "subtle" : "default",
                            isSelected: selectedTeamType === teamType,
                            style: $cd6c6dd32e2ad127$var$teamTypeButtonStyles,
                            onClick: ()=>{
                                markPromptChangedField("teamType");
                                firePaidJiraAi("PromptTeamTypeSelected", "clicked", {
                                    previousTeamType: selectedTeamType,
                                    newTeamType: teamType,
                                    isFirstSelection: !hasUserSelectedTeamType
                                });
                                setHasUserSelectedTeamType(true);
                                setSelectedTeamType(teamType);
                                suggestMadLib(teamType);
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages)[messageKey]))
                        }, teamType))
                })
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7lZe.PaidJiraAiMadLib), {
                focusInput: !isRerun,
                workingOnSuggestion: workingOnSuggestion,
                goalSuggestion: goalSuggestion,
                workingOnValue: workingOnValue,
                goalValue: goalValue,
                onEnter: handleOnSubmit,
                onChange: ({ workingOnValue: newWorkingOnValue, goalValue: newGoalValue })=>{
                    if (newWorkingOnValue !== workingOnValue) {
                        var _commonAnalyticsAttributes_changedFields;
                        setIsErrorFromCgs(false);
                        setWorkingOnValue(newWorkingOnValue);
                        if (!((_commonAnalyticsAttributes_changedFields = commonAnalyticsAttributes.changedFields) === null || _commonAnalyticsAttributes_changedFields === void 0 ? void 0 : _commonAnalyticsAttributes_changedFields.includes("workingOn"))) firePaidJiraAi("PromptFieldChanged", "clicked", {
                            field: "workingOn",
                            valueLength: newWorkingOnValue.trim().length,
                            isCustom: Boolean(newWorkingOnValue.trim())
                        });
                        markPromptChangedField("workingOn");
                    }
                    if (newGoalValue !== goalValue) {
                        var _commonAnalyticsAttributes_changedFields1;
                        setIsErrorFromCgs(false);
                        setGoalValue(newGoalValue);
                        if (!((_commonAnalyticsAttributes_changedFields1 = commonAnalyticsAttributes.changedFields) === null || _commonAnalyticsAttributes_changedFields1 === void 0 ? void 0 : _commonAnalyticsAttributes_changedFields1.includes("goal"))) firePaidJiraAi("PromptFieldChanged", "clicked", {
                            field: "goal",
                            valueLength: newGoalValue.trim().length,
                            isCustom: Boolean(newGoalValue.trim())
                        });
                        markPromptChangedField("goal");
                    }
                },
                setAreInputsValid: setIsFormValid
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1pfh7vkz _1e0c1txw _1bah1yb4 _4cvr1q9y"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ect4b1j9 _1wyb1crf _vwz47vkz _syaz1ggn"
                        ]),
                        children: !isRerun ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _zulp1y44"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).poweredByAi)),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4se1R))), {
                                    label: "Status info"
                                })
                            ]
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Sqn0.default), {
                        children: cgsDataLoading || showLoadingState ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                            isDisabled: true,
                            appearance: "subtle",
                            style: $cd6c6dd32e2ad127$var$footerButtonStyles,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).working))
                        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    appearance: "subtle",
                                    iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9yC2v))), {
                                        label: ""
                                    }),
                                    style: $cd6c6dd32e2ad127$var$footerButtonStyles,
                                    onClick: shuffle,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).shuffle))
                                }),
                                isRerun ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    isDisabled: !isFormValid,
                                    appearance: "subtle",
                                    iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                                        label: ""
                                    }),
                                    style: $cd6c6dd32e2ad127$var$footerButtonStyles,
                                    onClick: handleOnSubmit,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).rerunPrompt))
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    isDisabled: !isFormValid,
                                    appearance: "primary",
                                    style: $cd6c6dd32e2ad127$var$footerButtonStyles,
                                    onClick: handleOnSubmit,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, (0, $kYjgt.messages).getStarted))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7Sqn0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5bc20816e4beb8e1$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $5bc20816e4beb8e1$var$buttonGroupStyles = (0, $3dJ4i.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> *': {
        flex: '1 0 auto'
    }
});
function $5bc20816e4beb8e1$export$2e2bcd8739ae039(_ref) {
    var appearance = _ref.appearance, children = _ref.children;
    return (0, $3dJ4i.jsx)("div", {
        css: $5bc20816e4beb8e1$var$buttonGroupStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: idx
        }, appearance ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(child, {
            appearance: appearance
        }) : child);
    }));
}

});

parcelRegister("9yC2v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79393cf52935af5d2ce7204817b33e1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f54cbdf12a460b8$var$_react = $6f54cbdf12a460b8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6f54cbdf12a460b8$var$_baseNew = $6f54cbdf12a460b8$var$_interopRequireDefault((parcelRequire("jcI35")));
function $6f54cbdf12a460b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Randomize".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for randomizing or shuffling functionality.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f54cbdf12a460b8$var$RandomizeIcon = (props)=>/*#__PURE__*/ $6f54cbdf12a460b8$var$_react.default.createElement($6f54cbdf12a460b8$var$_baseNew.default, Object.assign({
        name: "RandomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 .052 1.004l-.052.056-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="m15.78 3.72.05.06a.75.75 0 0 1-.05 1l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM2.91 3a2 2 0 0 1 1.55.74l1.53 1.88-.97 1.19-1.73-2.13a.5.5 0 0 0-.39-.18H0V3z"/>`
    }, props));
$6f54cbdf12a460b8$var$RandomizeIcon.displayName = 'RandomizeIcon';
var $6f54cbdf12a460b8$var$_default = module.exports.default = $6f54cbdf12a460b8$var$RandomizeIcon;

});

parcelRegister("l7lZe", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiMadLib", function () { return $d5f42ac48b84f3d9$export$c896215e2accffb4; });
/* paid-jira-ai-mad-lib.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $grHEz = parcelRequire("grHEz");

var $kbpa7 = parcelRequire("kbpa7");

var $kYjgt = parcelRequire("kYjgt");
const $d5f42ac48b84f3d9$var$containerStyle = null;
const $d5f42ac48b84f3d9$var$inlineInputStyle = null;
const $d5f42ac48b84f3d9$var$MadLibLabel = ({ id: id, str: str, forSelector: forSelector })=>{
    const focusInput = ()=>{
        const element = window.document.querySelector(forSelector);
        element === null || element === void 0 ? void 0 : element.focus();
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            focusInput();
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        id: id,
        onClick: focusInput,
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        role: "button",
        children: str
    });
};
const $d5f42ac48b84f3d9$export$c896215e2accffb4 = ({ workingOnSuggestion: workingOnSuggestion, goalSuggestion: goalSuggestion, workingOnValue: workingOnValue, goalValue: goalValue, onChange: onChange, onEnter: onEnter, focusInput: focusInput, setAreInputsValid: setAreInputsValid })=>{
    const [isWorkingOnInputValid, setIsWorkingOnInputValid] = (0, $1oC0p.useState)(true);
    const [isGoalInputValid, setIsGoalInputValid] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        setAreInputsValid === null || setAreInputsValid === void 0 ? void 0 : setAreInputsValid(isWorkingOnInputValid && isGoalInputValid);
    }, [
        setAreInputsValid,
        isWorkingOnInputValid,
        isGoalInputValid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ect41pz4 _1wyb1tcg _vwz41ylp _1dyznl7k _syazpmk4 _1tke1lev"
        ]),
        style: {
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $dPABA._)((0, $6ogO3._)({}, (0, $kYjgt.messages).madLib), {
            values: {
                workingOn: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($d5f42ac48b84f3d9$var$MadLibLabel, {
                        id: "workingOnLabel",
                        str: str,
                        forSelector: "#working-on-input span[contenteditable]"
                    }),
                goal: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($d5f42ac48b84f3d9$var$MadLibLabel, {
                        id: "goalLabel",
                        str: str,
                        forSelector: "#goal-input span[contenteditable]"
                    }),
                workingOnInput: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    id: "working-on-input",
                    className: (0, $2jatx.default)([
                        "_syaz17la _179r1p8s _5pio1be1 _y3gn1h6o _1ul953f4 _1e0c1nu9 _1tke1u1b _vwz4d6z3 _s7n4z0dk _1kt9f705 _9tn1qvpr _aetrf705 _1qjlqvpr"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                        "--_1fb7i9d": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.purple"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grHEz.InlineInput), {
                        value: workingOnValue,
                        placeholder: workingOnSuggestion,
                        ariaLabelledBy: "workingOnLabel",
                        animatePlaceholder: true,
                        focus: focusInput,
                        onEnter: onEnter,
                        onChange: (value)=>{
                            if (onChange) onChange({
                                workingOnValue: value,
                                goalValue: goalValue
                            });
                        },
                        setIsInputValid: setIsWorkingOnInputValid
                    })
                }),
                goalInput: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    id: "goal-input",
                    className: (0, $2jatx.default)([
                        "_syaz17la _179r1p8s _5pio1be1 _y3gn1h6o _1ul953f4 _1e0c1nu9 _1tke1u1b _vwz4d6z3 _s7n4z0dk _1kt9f705 _9tn1qvpr _aetrf705 _1qjlqvpr"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                        "--_1fb7i9d": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.purple"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grHEz.InlineInput), {
                        value: goalValue,
                        placeholder: goalSuggestion,
                        ariaLabelledBy: "goalLabel",
                        animatePlaceholder: true,
                        onEnter: onEnter,
                        onChange: (value)=>{
                            if (onChange) onChange({
                                workingOnValue: workingOnValue,
                                goalValue: value
                            });
                        },
                        setIsInputValid: setIsGoalInputValid
                    })
                })
            }
        }))
    });
};

});
parcelRegister("grHEz", function(module, exports) {
$parcel$export(module.exports, "InlineInput", function () { return $264a45a5b6f2823d$export$36d3e0619bb09209; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $264a45a5b6f2823d$var$inlineInputStyle = null;
const $264a45a5b6f2823d$export$36d3e0619bb09209 = ({ value: value, placeholder: placeholder, animatePlaceholder: animatePlaceholder = false, onChange: onChange, onEnter: onEnter, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, focus: focus, setIsInputValid: setIsInputValid })=>{
    const [isClient, setIsClient] = (0, $1oC0p.useState)(false);
    const [isFocused, setIsFocused] = (0, $1oC0p.useState)(false);
    const [doesInputContainPlaceholder, setDoesInputContainPlaceholder] = (0, $1oC0p.useState)(true);
    const [initFocused, setInitFocused] = (0, $1oC0p.useState)(false);
    const inputRef = (0, $1oC0p.useRef)(null);
    const intervalRef = (0, $1oC0p.useRef)(0);
    const previousOnChangeVal = (0, $1oC0p.useRef)(undefined);
    const previousIsInputValidVal = (0, $1oC0p.useRef)(undefined);
    const previousPlaceholder = (0, $1oC0p.useRef)("");
    const previousValue = (0, $1oC0p.useRef)(undefined);
    const handleOnChange = (doesInputContainPlaceholder)=>{
        if (!isClient || !inputRef.current) return;
        // Call onChange if value changed (user is typing)
        const value = doesInputContainPlaceholder ? "" : inputRef.current.innerText;
        if (onChange && previousOnChangeVal.current !== value) {
            previousOnChangeVal.current = value;
            onChange(value);
        }
        // Call setIsInputValid when input changes between valid/invalid (empty = invalid)
        const isValid = !!(doesInputContainPlaceholder || inputRef.current.innerText);
        if (setIsInputValid && previousIsInputValidVal.current !== isValid) {
            previousIsInputValidVal.current = isValid;
            setIsInputValid(isValid);
        }
        // Focus on input on component load
        if (focus && !initFocused) {
            inputRef.current.focus();
            // Move cursor to the end
            const range = document.createRange();
            range.selectNodeContents(inputRef.current);
            range.collapse(false); // false = to end of node
            const sel = window.getSelection();
            sel === null || sel === void 0 ? void 0 : sel.removeAllRanges();
            sel === null || sel === void 0 ? void 0 : sel.addRange(range);
            setInitFocused(true);
        }
    };
    // Handle blur: restore placeholder if empty
    const handleOnBlur = (0, $1oC0p.useCallback)(()=>{
        if (!isClient || !inputRef.current) return;
        setIsFocused(false);
        if (inputRef.current.innerText === "") {
            // Replace empty input with the placeholder text
            inputRef.current.innerText = placeholder;
            setDoesInputContainPlaceholder(true);
            handleOnChange(true);
        } else handleOnChange(doesInputContainPlaceholder);
    }, [
        isClient,
        placeholder,
        handleOnChange
    ]);
    // Handle input: replace placeholder on input
    const handleOnInput = (0, $1oC0p.useCallback)((e)=>{
        if (!isClient || !inputRef.current) return;
        if (doesInputContainPlaceholder) {
            var _nativeEvent_dataTransfer;
            const nativeEvent = e.nativeEvent;
            // Replace placeholder text with whatever the user typed
            inputRef.current.innerText = nativeEvent.data || ((_nativeEvent_dataTransfer = nativeEvent.dataTransfer) === null || _nativeEvent_dataTransfer === void 0 ? void 0 : _nativeEvent_dataTransfer.getData("text/plain")) || "";
            // Set cursor to the end
            inputRef.current.focus();
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(inputRef.current);
            range.collapse(false);
            selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
            selection === null || selection === void 0 ? void 0 : selection.addRange(range);
            setDoesInputContainPlaceholder(false);
        }
        handleOnChange(false);
    }, [
        isClient,
        doesInputContainPlaceholder,
        handleOnChange
    ]);
    // Set client flag
    (0, $1oC0p.useEffect)(()=>setIsClient(true), []);
    // Animate or set placeholder
    (0, $1oC0p.useEffect)(()=>{
        if (!isClient || !inputRef.current || value) return;
        if (previousPlaceholder.current === placeholder) return;
        previousPlaceholder.current = placeholder;
        // Set placeholder without animation
        if (!animatePlaceholder) {
            inputRef.current.innerText = placeholder;
            setDoesInputContainPlaceholder(true);
            handleOnChange(true);
            return;
        }
        // Animate placeholder
        window.clearInterval(intervalRef.current);
        inputRef.current.innerText = "";
        intervalRef.current = window.setInterval(()=>{
            if (!inputRef.current) {
                window.clearInterval(intervalRef.current);
                return;
            }
            const currentNumChars = inputRef.current.innerText.length;
            const renderNumChars = currentNumChars + (placeholder[currentNumChars] === " " ? 2 : 1);
            inputRef.current.innerText = placeholder.substring(0, renderNumChars);
            if (renderNumChars >= placeholder.length) {
                window.clearInterval(intervalRef.current);
                setDoesInputContainPlaceholder(true);
                handleOnChange(true);
            }
        }, 35);
    }, [
        isClient,
        value,
        placeholder,
        animatePlaceholder,
        handleOnChange
    ]);
    // Sync value with input text
    (0, $1oC0p.useEffect)(()=>{
        if (!isClient || !inputRef.current) return;
        if (previousValue.current === value) return;
        previousValue.current = value;
        if (typeof value !== "string") return;
        if (inputRef.current.innerText !== value) {
            if (value === "" && !isFocused) {
                inputRef.current.innerText = placeholder;
                setDoesInputContainPlaceholder(true);
                handleOnChange(true);
            } else {
                inputRef.current.innerText = value;
                setDoesInputContainPlaceholder(false);
                handleOnChange(false);
            }
        }
    }, [
        isClient,
        value,
        isFocused,
        placeholder,
        handleOnChange
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            !isClient && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_12ji1r31 _1qu2glyw _12y3idpf"
                ]),
                children: placeholder
            }),
            isClient && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                contentEditable: "plaintext-only",
                role: "textbox",
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                "aria-placeholder": placeholder,
                tabIndex: 0,
                onInput: handleOnInput,
                onKeyDown: (e)=>{
                    if (e.key === "Enter") {
                        e.preventDefault();
                        onEnter === null || onEnter === void 0 ? void 0 : onEnter();
                    }
                },
                onFocus: ()=>setIsFocused(true),
                onBlur: ()=>handleOnBlur(),
                ref: inputRef,
                suppressContentEditableWarning: true,
                className: (0, $2jatx.default)([
                    "_12ji1r31 _1qu2glyw _12y3idpf"
                ])
            })
        ]
    });
};

});



parcelRegister("6qT9Y", function(module, exports) {
$parcel$export(module.exports, "Background", function () { return $e2fb81374490b4ca$export$668799e4797757a8; });
/* background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $e2fb81374490b4ca$var$backgroundStyle = null;
const $e2fb81374490b4ca$export$668799e4797757a8 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "1440",
        height: "900",
        viewBox: "0 0 1440 900",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_kqswstnw _1e02idpf _u7coidpf _1bsbauwl _p12fauwl _1ul91fbq _1pby1mrw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M789.13 1872.04C965.261 1810.52 1109.36 1831.72 1247.84 1924.87C1398.51 2026.22 1474.44 2166.31 1480.18 2336.89L2764.78 3200.99C3259.46 2083.95 3014.99 1156.25 2171.57 588.917C1386.05 60.5259 585.163 101.12 -487 1013.63L789.468 1872.27L789.13 1872.04Z",
            fill: "#CFE1FD"
        })
    });
};

});

parcelRegister("6G35q", function(module, exports) {
$parcel$export(module.exports, "Header", function () { return $a782b39b8df6e4f9$export$8b251419efc915eb; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $a1X32 = parcelRequire("a1X32");

var $iUVnd = parcelRequire("iUVnd");

var $jVa6Y = parcelRequire("jVa6Y");

var $7VwhR = parcelRequire("7VwhR");

var $kbpa7 = parcelRequire("kbpa7");

var $jUBSR = parcelRequire("jUBSR");

var $iuNYi = parcelRequire("iuNYi");
const $a782b39b8df6e4f9$var$containerCss = null;
const $a782b39b8df6e4f9$var$paragraphCss = null;
const $a782b39b8df6e4f9$var$messageCss = null;
const $a782b39b8df6e4f9$var$messageHeaderCss = null;
const $a782b39b8df6e4f9$var$messageBodyCss = null;
const $a782b39b8df6e4f9$var$errorCss = null;
const $a782b39b8df6e4f9$var$messageCtaCss = null;
const $a782b39b8df6e4f9$var$accountCreationCss = null;
const $a782b39b8df6e4f9$var$separatorBorderCss = null;
const $a782b39b8df6e4f9$var$separatorCss = null;
const $a782b39b8df6e4f9$export$8b251419efc915eb = ({ onRetryClick: onRetryClick })=>{
    const { firePaidJiraAi: firePaidJiraAi, promptAttemptIndex: promptAttemptIndex, isErrorFromCgs: isErrorFromCgs, hasSubmittedDefaultValues: hasSubmittedDefaultValues } = (0, $jUBSR.useJiraAiFFL)();
    const messages = {
        yourJiraSpaceIsReady: "Your Jira space is ready",
        getStartedNow: "Get started now to keep editing, save your progress, and make it your own.",
        tryAnotherPrompt: "Try another prompt"
    };
    (0, $1oC0p.useEffect)(()=>{
        firePaidJiraAi("AccountCreationViewed", "viewed", {
            promptAttemptIndex: promptAttemptIndex
        });
    }, [
        firePaidJiraAi,
        promptAttemptIndex
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1yb4 _zulpzwfg _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _p12fiafe"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1aom"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_ect41roz _k48p1fw0 _1wybviql _vwz411uf _1dyznmab _syazpmk4"
                        ]),
                        style: {
                            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
                        },
                        children: messages.yourJiraSpaceIsReady
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_ect418aq _1wyb1k92 _vwz41m1q _syazpmk4",
                            "_1pfhoqnp _6rthoqnp"
                        ]),
                        style: {
                            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
                        },
                        children: messages.getStartedNow
                    }),
                    isErrorFromCgs && !hasSubmittedDefaultValues && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_19it3dcd _bfhklnmr _ect418aq _1wyboxwj _vwz410nf _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v _syaz1hlo _1e0c1txw _zulp1j6v _4cvr1h6o _2rko1kwk"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iUVnd))), {
                                label: "error",
                                color: "var(--ds-icon-warning, #E06C00)"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: "We couldn't build the project the way you asked for it. So we have built out a project that showcases what Rovo and Jira are capable of."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_1pfhoqnp _6rthoqnp"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                            onClick: ()=>onRetryClick === null || onRetryClick === void 0 ? void 0 : onRetryClick(),
                            tabIndex: 0,
                            role: "button",
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    onRetryClick === null || onRetryClick === void 0 ? void 0 : onRetryClick();
                                }
                            },
                            "aria-label": messages.tryAnotherPrompt,
                            className: (0, $2jatx.default)([
                                "_ect418aq _k48pni7l _1wyb1j6v _vwz41k92 _syazjk2v _80omtlke"
                            ]),
                            style: {
                                "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
                            },
                            children: [
                                messages.tryAnotherPrompt,
                                " ",
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1X32))), {
                                    label: messages.tryAnotherPrompt,
                                    size: "small"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1os5 _1ul91dxr"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.default), {
                    Input: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iuNYi.InputSubmitButton), {}),
                    Submit: null,
                    Login: null,
                    Separator: /*#__PURE__*/ (0, $7VQPk.jsx)($a782b39b8df6e4f9$var$Separator, {}),
                    Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.Social), {
                        providers: {
                            google: "Google"
                        }
                    })
                })
            })
        ]
    });
};
const $a782b39b8df6e4f9$var$Separator = ()=>{
    const intl = (0, $8e22h.default)();
    const separatorText = intl.formatMessage({
        id: "WacSignupForm.socialSignUpOrSignUpWith",
        defaultMessage: "Or sign up with"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1wyb8oy7 _1e0c1txw _vwz4400g _19pkviql _2hwxidpf _otyrviql _18u0idpf _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $7VwhR.fontSize).sm)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1h6d1kw7 _1dqonqa1 _189esoed _1e0c1ule _16jlkb7n _4t3iidpf _19pkidpf _2hwx1j6v _otyridpf _18u01j6v _tzy41acx"
                ])
            }),
            separatorText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1h6d1kw7 _1dqonqa1 _189esoed _1e0c1ule _16jlkb7n _4t3iidpf _19pkidpf _2hwx1j6v _otyridpf _18u01j6v _tzy41acx"
                ])
            })
        ]
    });
};

});
parcelRegister("iuNYi", function(module, exports) {
$parcel$export(module.exports, "InputSubmitButton", function () { return $69f3df6730317c8b$export$8a1669598804b0aa; });
/* input-submit-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $ddxTX = parcelRequire("ddxTX");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $jVa6Y = parcelRequire("jVa6Y");

var $7VwhR = parcelRequire("7VwhR");

var $jUBSR = parcelRequire("jUBSR");
const $69f3df6730317c8b$export$8a1669598804b0aa = ()=>{
    const intl = (0, $8e22h.default)();
    const { formError: formError, hasSubmitted: hasSubmitted, isReadyForInvalid: isReadyForInvalid, isSubmitting: isSubmitting, onClickSubmitButton: onClickSubmitButton, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $jVa6Y.useAccountCreationContext)();
    const { firePaidJiraAi: firePaidJiraAi, promptAttemptIndex: promptAttemptIndex } = (0, $jUBSR.useJiraAiFFL)();
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    (0, $1oC0p.useEffect)(()=>{
        const isValid = (0, $7VwhR.emailIsValid)(email);
        // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    const buttonText = intl.formatMessage({
        id: "signupForm.accountCreation.signupButton",
        defaultMessage: "Sign up"
    });
    const placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    const errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    const labelText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvresu3 _1bah1yb4 _zulp1kwk _6rthkan1 _1e3j1bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _zzqj1vbe _vq65e4h9 _62vcoqnp _1heu1kw7 _1rwqvuon _125x1syg _17rn1kw7 _1t2q1kw7 _1q9pbfng _12vqewfl _1vyiewfl _1p1fidpf _d78pglyw"
                        ]),
                        style: {
                            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                            "aria-required": true,
                            isRequired: true,
                            label: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1o8l _1bsbr0r7"
                                ]),
                                children: labelText
                            }),
                            name: "email",
                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        isValid === true && "_1lo6af4m",
                                        isValid === false && "_1lo61wfy"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), (0, $dPABA._)((0, $6ogO3._)({}, fieldProps), {
                                        autoComplete: "email",
                                        "aria-describedby": "account_creation_email_help_text",
                                        elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.InputIcon), {
                                            valid: isValid
                                        }),
                                        onBlur: ()=>setIsReadyForInvalid(true),
                                        onChange: (e)=>{
                                            setEmail(e.target.value);
                                            setTypeAheadEmail(e.target.value);
                                            fieldProps.onChange(e);
                                        },
                                        placeholder: placeholderText,
                                        testId: "email_field",
                                        type: "email",
                                        value: email,
                                        style: $69f3df6730317c8b$var$textFieldStyles
                                    }))
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e991osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                            type: "submit",
                            appearance: "primary",
                            style: $69f3df6730317c8b$var$buttonStyles,
                            isDisabled: isSubmitting || hasSubmitted && !formError,
                            onClick: ()=>{
                                onClickSubmitButton();
                                firePaidJiraAi("AccountCreationSubmitClicked", "clicked", {
                                    source: "paidLandingPreview",
                                    method: "email",
                                    promptAttemptIndex: promptAttemptIndex
                                });
                            },
                            children: buttonText
                        })
                    })
                ]
            }),
            isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                id: "account_creation_email_help_text",
                role: "alert",
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1wybepq8 _vwz4bs82 _syaznbxb"
                ]),
                style: {
                    "--_1h1y5xv": (0, $6ZVlx.default)((0, $7VwhR.fontSize).xs)
                },
                children: errorMessageText
            }) : null
        ]
    });
};
const $69f3df6730317c8b$var$containerCss = null;
const $69f3df6730317c8b$var$inputCss = null;
const $69f3df6730317c8b$var$labelChildCss = null;
const $69f3df6730317c8b$var$textFieldStyles = {
    height: "2.286rem",
    paddingInlineStart: "1.125rem",
    paddingInlineEnd: "1.125rem"
};
const $69f3df6730317c8b$var$buttonContainerCss = null;
const $69f3df6730317c8b$var$buttonStyles = {
    borderRadius: "2.5rem",
    paddingInlineStart: "1.5rem",
    paddingInlineEnd: "1.5rem",
    width: "100%"
};
const $69f3df6730317c8b$var$errorMessageCss = null;
const $69f3df6730317c8b$var$inputInvalidCss = null;
const $69f3df6730317c8b$var$inputValidCss = null;

});


parcelRegister("aBUAq", function(module, exports) {
$parcel$export(module.exports, "PreviewTable", function () { return $ac5d463a4909f1e1$export$17497d5d2ced1033; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $FapDU = parcelRequire("FapDU");

var $kbpa7 = parcelRequire("kbpa7");

var $j0ZBv = parcelRequire("j0ZBv");

var $hSlTI = parcelRequire("hSlTI");
const $ac5d463a4909f1e1$var$TABLE_HEADERS = [
    "Work",
    "Status",
    "Due date",
    "Priority",
    "Assignee"
];
const $ac5d463a4909f1e1$var$tableContainerCss = null;
const $ac5d463a4909f1e1$var$tableCss = null;
const $ac5d463a4909f1e1$var$tableCellHeaderCss = null;
const $ac5d463a4909f1e1$var$teamTypeCss = null;
const $ac5d463a4909f1e1$var$loadingBarCss = null;
const $ac5d463a4909f1e1$var$teamTypeLoadingCss = null;
const $ac5d463a4909f1e1$export$17497d5d2ced1033 = ({ rows: rows, spaceName: spaceName })=>{
    const headerCells = $ac5d463a4909f1e1$var$TABLE_HEADERS.map((columnHeader)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
            className: (0, $2jatx.default)([
                "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                "_bfhk1rga _k48p1fw0 _1wyb1yny _syaz1yg0 _1ezzlvwl _12ornqa1 _1r62t94y _y3gnv2br",
                columnHeader !== "Assignee" && "_pxtolvwl _1vn8nqa1 _1ej8t94y"
            ]),
            style: {
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
                "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
            },
            children: columnHeader
        }, `column-header-${columnHeader}`);
    });
    const defaultRowCount = 6;
    const rowCount = (rows === null || rows === void 0 ? void 0 : rows.length) || defaultRowCount;
    const rowCells = Array.from({
        length: rowCount
    }, (_, i)=>{
        const isLastRow = i === rowCount - 1;
        if (rows && rows.length > 0 && rows[i]) {
            const { type: type, summary: summary, status: status, dueDate: dueDate, priority: priority, assignee: assignee, assigneeImgSrc: assigneeImgSrc } = rows[i];
            // Ensure first row defaults to epic if type is missing/undefined (only for Kanban)
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hSlTI.TableRow), {
                type: type,
                summary: summary,
                status: status,
                dueDate: dueDate,
                priority: priority,
                assignee: assignee,
                assigneeImgSrc: assigneeImgSrc,
                isLastRow: isLastRow
            }, "row-" + i);
        }
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hSlTI.TableRow), {
            type: i === 0 ? "epic" : "task",
            isLastRow: isLastRow
        }, "row-" + i);
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                className: (0, $2jatx.default)([
                    "_ect41roz _k48p8n31 _1wyb6zda _vwz49c5v _syazpmk4 _1e0c1txw _4cvr1h6o _gy1p1o4k _1bsb1osq _p12fxwiq _19pkidpf _2hwx1wug _otyridpf _18u01wug _6rthimiu"
                ]),
                style: {
                    "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j0ZBv.ProjectAvatar), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: spaceName ? spaceName : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                                    children: "Generating your Jira space"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
                                        "_1bsb1o99"
                                    ])
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsbxwiq _p12f1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug _154015zi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("table", {
                    className: (0, $2jatx.default)([
                        "_1kqm1wug _2rko1mvu _yq5hus1c _btyzidpf _1h6dlvwl _189et94y _1dqonqa1 _1bsb1osq _11q7cd5j _ect4b1j9"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
                                children: headerCells
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                            children: rowCells
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("j0ZBv", function(module, exports) {
$parcel$export(module.exports, "ProjectAvatar", function () { return $0f20056c3ef369a1$export$ace0beef51336992; });

var $7VQPk = parcelRequire("7VQPk");
const $0f20056c3ef369a1$export$ace0beef51336992 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 34,
        height: 34,
        viewBox: "0 0 34 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                clipPath: "url(#clip0_4862_19690)",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    clipPath: "url(#clip1_4862_19690)",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M33.5999 0H-6.10352e-05V33.6H33.5999V0Z",
                            fill: "#BF63F3"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M4.70404 6.30859V27.3926H28.8876V6.30859H4.70404Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M12.852 28.0643C12.8604 27.8711 12.096 27.3251 11.9196 27.4259C11.6592 27.5603 11.4492 27.7451 11.2644 28.0391C11.0964 28.4003 11.2308 28.5767 11.088 28.8035C10.878 29.1899 10.332 29.7695 10.206 29.9123C10.1892 29.9375 10.1724 29.9543 10.1724 29.9879C10.1304 30.1811 9.95404 31.0211 9.70204 31.6931C9.55924 32.1887 9.49204 32.4911 9.45844 32.6507C9.38284 33.0287 9.41644 33.3395 9.54244 33.6419C9.60964 33.8099 10.416 33.9443 10.542 33.8183C10.7604 33.5915 10.9116 33.3479 10.9956 33.0035C11.0292 32.8691 11.3064 32.6423 11.4576 32.2727C11.4828 32.2139 11.4828 32.1467 11.466 32.0711C11.3232 31.4411 11.676 30.7859 11.676 30.7859C11.676 30.7859 11.7852 30.5339 11.9112 30.2315C12.0456 29.9291 12.222 29.5847 12.3312 29.3831C12.4908 29.0807 12.5748 28.9379 12.6252 28.8455C12.7764 28.5767 12.8436 28.3415 12.8604 28.0643H12.852Z",
                            fill: "#101214"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M22.9993 33.7679C23.1253 33.9107 24.0493 33.7595 24.1165 33.5663C24.2089 33.2975 24.2341 33.0203 24.1669 32.6927C24.0325 32.3231 23.8225 32.2811 23.7805 32.0291C23.6713 31.6091 23.6881 30.8279 23.6797 30.6263C23.6797 30.6011 23.6797 30.5675 23.6629 30.5507C23.5621 30.3743 23.1337 29.6519 22.8649 28.9715C22.6297 28.5179 22.4701 28.2407 22.3861 28.0979C22.1845 27.7619 21.9409 27.5687 21.6301 27.4343C21.4621 27.3587 20.7985 27.8375 20.7985 28.0055C20.7985 28.3247 20.8657 28.5851 21.0337 28.8959C21.1009 29.0135 21.0505 29.3663 21.1933 29.7359C21.2185 29.7947 21.2605 29.8451 21.3193 29.8871C21.8401 30.2483 22.0249 30.9707 22.0249 30.9707C22.0249 30.9707 22.1173 31.2227 22.2265 31.5335C22.3273 31.8443 22.4365 32.2139 22.4953 32.4407C22.5793 32.7767 22.6213 32.9363 22.6465 33.0371C22.7221 33.3395 22.8397 33.5579 23.0161 33.7679H22.9993Z",
                            fill: "#101214"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M6.38403 7.98828V15.5399L7.63563 13.7759C9.12243 11.6759 12.2472 11.6759 13.734 13.7759L16.0944 17.1107C17.4132 18.9671 20.0676 19.2275 21.714 17.6651C23.0328 16.4135 25.0236 16.3211 26.4516 17.3543V7.99668H6.38403V7.98828Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M20.6724 13.9019C20.6976 13.7591 20.7144 13.5995 20.7144 13.4399C20.7144 13.2803 20.6976 13.1123 20.6724 12.9695C20.5128 12.0875 19.908 11.5499 19.0512 11.4071C18.9084 11.3819 18.7488 11.3735 18.5892 11.3735C18.4296 11.3735 18.2616 11.3903 18.1104 11.4155C17.2536 11.5583 16.6488 12.0959 16.4892 12.9695C16.464 13.1207 16.4472 13.2719 16.4472 13.4399C16.4472 13.6079 16.464 13.7591 16.4892 13.9019C16.6488 14.7755 17.2536 15.3131 18.1104 15.4559C18.2616 15.4811 18.4212 15.4979 18.5892 15.4979C18.7572 15.4979 18.9 15.4895 19.0512 15.4643C19.908 15.3215 20.5212 14.7839 20.6724 13.9019Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M26.4601 25.7122V17.3458C25.0237 16.3126 23.0329 16.4134 21.7225 17.6566C20.0761 19.219 17.4133 18.9586 16.1029 17.1022L13.7425 13.7674C12.2557 11.6674 9.13086 11.6674 7.64406 13.7674L6.39246 15.5314V25.7038H26.4685L26.4601 25.7122Z",
                            fill: "#D8A0F7"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M17.2957 3.24225C17.1949 3.16665 16.2625 3.16665 16.1617 3.24225C16.0189 3.35145 15.9517 3.47745 15.9433 3.62865C15.9853 3.80505 16.1785 3.84705 16.1617 3.96465C16.1617 4.16625 15.9013 4.49385 15.8341 4.57785C15.8257 4.58625 15.8257 4.60305 15.8341 4.61145C15.8677 4.69545 16.0105 5.07345 15.9433 5.39265C15.9433 5.61945 15.9433 5.76225 15.9433 5.83785C15.9433 6.01425 16.0441 6.14025 16.2205 6.26625C16.3213 6.33345 17.1361 6.33345 17.2285 6.26625C17.4049 6.14025 17.5057 6.00585 17.5057 5.83785C17.5057 5.77065 17.7325 5.62785 17.7661 5.43465C17.7661 5.40105 17.7577 5.36745 17.7241 5.34225C17.4217 5.06505 17.5057 4.70385 17.5057 4.70385C17.5057 4.70385 17.5057 4.16625 17.5057 3.93945C17.5057 3.77145 17.5057 3.68745 17.5057 3.63705C17.5057 3.48585 17.4217 3.36825 17.2873 3.25065L17.2957 3.24225Z",
                            fill: "#101214"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M5.56922 26.9049C4.41842 27.0057 4.41842 27.9381 5.56922 28.0389C7.19882 28.1817 8.92082 28.2489 11.1216 28.2573C13.6248 28.2153 14.2464 28.0221 15.9348 28.0389C18.7992 28.0389 23.6208 28.2993 24.7884 28.3665C24.9564 28.3749 25.1328 28.3749 25.3092 28.3665C25.5024 28.3665 25.8048 28.3581 26.3508 28.3413C27.0984 28.3413 28.182 28.3245 29.8032 28.3077C29.7948 27.6525 29.7696 26.1741 29.7444 24.3429C29.7276 22.9401 29.7276 21.2601 29.7444 19.6725C29.7444 16.3881 29.7444 14.3469 29.7444 13.2885C29.7444 10.7769 29.6436 8.90371 29.4672 7.06411C29.3664 6.05611 28.5516 6.05611 28.4592 7.06411C28.2828 8.90371 28.182 10.7853 28.182 13.2885C28.182 14.2629 27.9552 16.2957 27.9216 19.1685C27.9216 19.6389 27.93 20.1009 27.9636 20.5629C28.056 21.7305 28.1064 22.9905 28.14 24.1833C28.1568 25.1157 28.1736 25.9893 28.1904 26.6781C27.1656 26.6781 26.5272 26.6697 26.5272 26.6697C26.5272 26.6697 18.774 26.6697 15.5064 26.6697C13.0452 26.6697 11.8608 26.6697 11.13 26.6697C8.92082 26.6697 7.20722 26.7537 5.57762 26.8881L5.56922 26.9049Z",
                            fill: "#101214"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_4862_19690",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "33.6",
                            height: "33.6",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip1_4862_19690",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "33.6",
                            height: "33.6",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("hSlTI", function(module, exports) {
$parcel$export(module.exports, "TableRow", function () { return $1e73233be8a92de3$export$b05581f4e764e162; });
/* table-row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $41d6y = parcelRequire("41d6y");

var $4SA4u = parcelRequire("4SA4u");

var $leqii = parcelRequire("leqii");

var $24zqb = parcelRequire("24zqb");

var $9p3p1 = parcelRequire("9p3p1");

var $h2BxV = parcelRequire("h2BxV");

var $dJqoM = parcelRequire("dJqoM");

var $20Gca = parcelRequire("20Gca");

var $kbpa7 = parcelRequire("kbpa7");
var $1e73233be8a92de3$var$StatusDisplay = /*#__PURE__*/ function(StatusDisplay) {
    StatusDisplay["ToDo"] = "TO DO";
    StatusDisplay["InProgress"] = "IN PROGRESS";
    StatusDisplay["Complete"] = "COMPLETE";
    return StatusDisplay;
}($1e73233be8a92de3$var$StatusDisplay || {});
var $1e73233be8a92de3$var$PriorityDisplay = /*#__PURE__*/ function(PriorityDisplay) {
    PriorityDisplay["Low"] = "Low";
    PriorityDisplay["Medium"] = "Medium";
    PriorityDisplay["High"] = "High";
    return PriorityDisplay;
}($1e73233be8a92de3$var$PriorityDisplay || {});
const $1e73233be8a92de3$var$inlineRowCss = null;
const $1e73233be8a92de3$var$placeHolderBarStyles = {
    root: null,
    narrow: null,
    wide: null
};
const $1e73233be8a92de3$var$lozengeStyles = {
    toDo: {
        backgroundColor: (0, $kbpa7.wacToken)("color.neutral.light300"),
        color: (0, $kbpa7.wacToken)("color.neutral.light1000")
    },
    inProgress: {
        backgroundColor: (0, $kbpa7.wacToken)("color.extended.blue300"),
        color: (0, $kbpa7.wacToken)("color.neutral.light1000")
    },
    complete: {
        backgroundColor: (0, $kbpa7.wacToken)("color.extended.lime300"),
        color: (0, $kbpa7.wacToken)("color.neutral.light1000")
    }
};
const $1e73233be8a92de3$var$dateCss = null;
const $1e73233be8a92de3$var$avatarCss = null;
const $1e73233be8a92de3$var$epicSummaryCss = null;
const $1e73233be8a92de3$var$tableBorderNotLastRowCss = null;
function $1e73233be8a92de3$var$renderStatusLozenge(status) {
    switch(status){
        case "to do":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                style: $1e73233be8a92de3$var$lozengeStyles.toDo,
                children: "TO DO"
            });
        case "in progress":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                style: $1e73233be8a92de3$var$lozengeStyles.inProgress,
                children: "IN PROGRESS"
            });
        case "complete":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                style: $1e73233be8a92de3$var$lozengeStyles.complete,
                children: "COMPLETE"
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
                    "_1bsb1lev"
                ])
            });
    }
}
function $1e73233be8a92de3$var$renderDateLozenge(dueDate) {
    if (!dueDate) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
            "_1bsb1lev"
        ])
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_ect4b1j9 _k48pni7l _1wyb94pf _vwz41j6v _syazpmk4"
        ]),
        style: {
            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
        },
        children: (0, $41d6y.format)(dueDate, "MMM do, yyyy")
    });
}
function $1e73233be8a92de3$var$renderPriority(priority) {
    switch(priority){
        case "low":
            return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _zulp1kwk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9p3p1))), {
                        label: "low priority",
                        color: "var(--ds-icon-accent-blue, #357DE8)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: "Low"
                    })
                ]
            });
        case "medium":
            return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _zulp1kwk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h2BxV))), {
                        label: "medium priority",
                        color: "var(--ds-icon-accent-yellow, #B38600)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: "Medium"
                    })
                ]
            });
        case "high":
            return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _zulp1kwk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24zqb))), {
                        label: "high priority",
                        color: "var(--ds-icon-accent-red, #C9372C)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: "High"
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
                    "_1bsb1lev"
                ])
            });
    }
}
function $1e73233be8a92de3$var$renderAssignee(assignee, assigneeImgSrc) {
    if (assignee && assigneeImgSrc) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o",
            "_1e0c116y _4cvr1h6o _zulp1kwk"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
                appearance: "circle",
                src: assigneeImgSrc,
                size: "small",
                name: assignee
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: assignee
            })
        ]
    });
    else if (assignee) return assignee;
    else return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
            "_1bsb1lev"
        ])
    });
}
const $1e73233be8a92de3$export$b05581f4e764e162 = ({ type: type, summary: summary, status: status, dueDate: dueDate, priority: priority, assignee: assignee, assigneeImgSrc: assigneeImgSrc, isLastRow: isLastRow })=>{
    const summaryIcon = type === "epic" ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($leqii))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dJqoM))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
    const summaryCell = summary || /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
            "_1bsb3jzc"
        ])
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    type === "epic" && "_k48p1fw0",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _4cvr1h6o _zulp1kwk"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: summaryIcon
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: summaryCell
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderStatusLozenge(status)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderDateLozenge(dueDate)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderPriority(priority)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderAssignee(assignee, assigneeImgSrc)
            })
        ]
    });
};

});
parcelRegister("41d6y", function(module, exports) {
$parcel$export(module.exports, "format", function () { return $2ed16bc14c3278e0$export$d9468344d3651243; });

var $04szs = parcelRequire("04szs");

var $52y57 = parcelRequire("52y57");

var $eULoq = parcelRequire("eULoq");

var $kaf1h = parcelRequire("kaf1h");

var $eKVtb = parcelRequire("eKVtb");

var $1vsWe = parcelRequire("1vsWe");

var $frdJf = parcelRequire("frdJf");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $2ed16bc14c3278e0$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $2ed16bc14c3278e0$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $2ed16bc14c3278e0$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $2ed16bc14c3278e0$var$doubleQuoteRegExp = /''/g;
const $2ed16bc14c3278e0$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $2ed16bc14c3278e0$export$d9468344d3651243(date, formatStr, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    const defaultOptions = (0, $52y57.getDefaultOptions)();
    var _options_locale2, _ref;
    const locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $04szs.enUS);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    const firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    const weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    const originalDate = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    if (!(0, $1vsWe.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($2ed16bc14c3278e0$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $kaf1h.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($2ed16bc14c3278e0$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $2ed16bc14c3278e0$var$cleanEscapedString(substring)
        };
        if ((0, $eULoq.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($2ed16bc14c3278e0$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $eKVtb.isProtectedWeekYearToken)(token) || !(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $eKVtb.isProtectedDayOfYearToken)(token)) (0, $eKVtb.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, $eULoq.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $2ed16bc14c3278e0$var$cleanEscapedString(input) {
    const matched = input.match($2ed16bc14c3278e0$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($2ed16bc14c3278e0$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$2ed16bc14c3278e0$export$2e2bcd8739ae039 = $2ed16bc14c3278e0$export$d9468344d3651243;

});
parcelRegister("eULoq", function(module, exports) {
$parcel$export(module.exports, "formatters", function () { return $adbb0eed5a15b217$export$fe98a034cfb96d55; });

var $3vh0T = parcelRequire("3vh0T");

var $kL8sr = parcelRequire("kL8sr");

var $eOBb6 = parcelRequire("eOBb6");

var $3eRpB = parcelRequire("3eRpB");

var $kH0Cl = parcelRequire("kH0Cl");

var $3gdE9 = parcelRequire("3gdE9");

var $9evqZ = parcelRequire("9evqZ");
const $adbb0eed5a15b217$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $adbb0eed5a15b217$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $9evqZ.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $kH0Cl.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $3gdE9.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $3gdE9.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $eOBb6.getISOWeekYear)(date);
        // Padding
        return (0, $3gdE9.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $3gdE9.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $3gdE9.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $3gdE9.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $9evqZ.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $3gdE9.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $3eRpB.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $3gdE9.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $kL8sr.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $3gdE9.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $9evqZ.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $3vh0T.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $3gdE9.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $3gdE9.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $3gdE9.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $3gdE9.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $9evqZ.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $9evqZ.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $3gdE9.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $3gdE9.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $9evqZ.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $9evqZ.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $9evqZ.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $adbb0eed5a15b217$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $adbb0eed5a15b217$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $adbb0eed5a15b217$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $adbb0eed5a15b217$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $3gdE9.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $3gdE9.addLeadingZeros)(+date, token.length);
    }
};
function $adbb0eed5a15b217$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $3gdE9.addLeadingZeros)(minutes, 2);
}
function $adbb0eed5a15b217$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $3gdE9.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $adbb0eed5a15b217$var$formatTimezone(offset, delimiter);
}
function $adbb0eed5a15b217$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $3gdE9.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $3gdE9.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("3vh0T", function(module, exports) {
$parcel$export(module.exports, "getDayOfYear", function () { return $28d176d71133a583$export$d3b42cd8452deec; });

var $bMbri = parcelRequire("bMbri");

var $fVuI3 = parcelRequire("fVuI3");

var $frdJf = parcelRequire("frdJf");
function $28d176d71133a583$export$d3b42cd8452deec(date, options) {
    const _date = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = (0, $bMbri.differenceInCalendarDays)(_date, (0, $fVuI3.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$28d176d71133a583$export$2e2bcd8739ae039 = $28d176d71133a583$export$d3b42cd8452deec;

});
parcelRegister("fVuI3", function(module, exports) {
$parcel$export(module.exports, "startOfYear", function () { return $b984002940bddac0$export$f91e89d3d0406102; });

var $frdJf = parcelRequire("frdJf");
function $b984002940bddac0$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$b984002940bddac0$export$2e2bcd8739ae039 = $b984002940bddac0$export$f91e89d3d0406102;

});


parcelRegister("kL8sr", function(module, exports) {
$parcel$export(module.exports, "getISOWeek", function () { return $f1cec1f1d654300a$export$7cabdc5698b63e2f; });

var $59xhD = parcelRequire("59xhD");

var $beVQG = parcelRequire("beVQG");

var $lsW7j = parcelRequire("lsW7j");

var $frdJf = parcelRequire("frdJf");
function $f1cec1f1d654300a$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = +(0, $beVQG.startOfISOWeek)(_date) - +(0, $lsW7j.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $59xhD.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$f1cec1f1d654300a$export$2e2bcd8739ae039 = $f1cec1f1d654300a$export$7cabdc5698b63e2f;

});
parcelRegister("beVQG", function(module, exports) {
$parcel$export(module.exports, "startOfISOWeek", function () { return $82ede015fb00b7b5$export$6173213f95a4431e; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $6cztB = parcelRequire("6cztB");
function $82ede015fb00b7b5$export$6173213f95a4431e(date, options) {
    return (0, $6cztB.startOfWeek)(date, (0, $dPABA._)((0, $6ogO3._)({}, options), {
        weekStartsOn: 1
    }));
}
var // Fallback for modularized imports:
$82ede015fb00b7b5$export$2e2bcd8739ae039 = $82ede015fb00b7b5$export$6173213f95a4431e;

});

parcelRegister("lsW7j", function(module, exports) {
$parcel$export(module.exports, "startOfISOWeekYear", function () { return $fa094b543f5dd36c$export$236bdfa374eb69a9; });

var $hs1PO = parcelRequire("hs1PO");

var $eOBb6 = parcelRequire("eOBb6");

var $beVQG = parcelRequire("beVQG");
function $fa094b543f5dd36c$export$236bdfa374eb69a9(date, options) {
    const year = (0, $eOBb6.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, $hs1PO.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $beVQG.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$fa094b543f5dd36c$export$2e2bcd8739ae039 = $fa094b543f5dd36c$export$236bdfa374eb69a9;

});
parcelRegister("eOBb6", function(module, exports) {
$parcel$export(module.exports, "getISOWeekYear", function () { return $ac9292f96045be59$export$3dbc52535f6f8fcc; });

var $hs1PO = parcelRequire("hs1PO");

var $beVQG = parcelRequire("beVQG");

var $frdJf = parcelRequire("frdJf");
function $ac9292f96045be59$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $hs1PO.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $beVQG.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $hs1PO.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $beVQG.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$ac9292f96045be59$export$2e2bcd8739ae039 = $ac9292f96045be59$export$3dbc52535f6f8fcc;

});



parcelRegister("3eRpB", function(module, exports) {
$parcel$export(module.exports, "getWeek", function () { return $25bc1c6d66f955c1$export$efe19b760242b2fc; });

var $59xhD = parcelRequire("59xhD");

var $6cztB = parcelRequire("6cztB");

var $lLEjQ = parcelRequire("lLEjQ");

var $frdJf = parcelRequire("frdJf");
function $25bc1c6d66f955c1$export$efe19b760242b2fc(date, options) {
    const _date = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = +(0, $6cztB.startOfWeek)(_date, options) - +(0, $lLEjQ.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $59xhD.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$25bc1c6d66f955c1$export$2e2bcd8739ae039 = $25bc1c6d66f955c1$export$efe19b760242b2fc;

});
parcelRegister("lLEjQ", function(module, exports) {
$parcel$export(module.exports, "startOfWeekYear", function () { return $fd8d434ee1e9a6ff$export$bb7b45bb8e74da0f; });

var $52y57 = parcelRequire("52y57");

var $hs1PO = parcelRequire("hs1PO");

var $kH0Cl = parcelRequire("kH0Cl");

var $6cztB = parcelRequire("6cztB");
function $fd8d434ee1e9a6ff$export$bb7b45bb8e74da0f(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $52y57.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    const firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    const year = (0, $kH0Cl.getWeekYear)(date, options);
    const firstWeek = (0, $hs1PO.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $6cztB.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$fd8d434ee1e9a6ff$export$2e2bcd8739ae039 = $fd8d434ee1e9a6ff$export$bb7b45bb8e74da0f;

});
parcelRegister("kH0Cl", function(module, exports) {
$parcel$export(module.exports, "getWeekYear", function () { return $f1084d691f57e4eb$export$12d572480ceb6e58; });

var $52y57 = parcelRequire("52y57");

var $hs1PO = parcelRequire("hs1PO");

var $6cztB = parcelRequire("6cztB");

var $frdJf = parcelRequire("frdJf");
function $f1084d691f57e4eb$export$12d572480ceb6e58(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const _date = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $52y57.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    const firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    const firstWeekOfNextYear = (0, $hs1PO.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $6cztB.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $hs1PO.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $6cztB.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$f1084d691f57e4eb$export$2e2bcd8739ae039 = $f1084d691f57e4eb$export$12d572480ceb6e58;

});



parcelRegister("3gdE9", function(module, exports) {
$parcel$export(module.exports, "addLeadingZeros", function () { return $25fd73a5842a07c9$export$c8306e720e213c0f; });
function $25fd73a5842a07c9$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("9evqZ", function(module, exports) {
$parcel$export(module.exports, "lightFormatters", function () { return $6b8dce11d3227385$export$b0d4b338e1516f13; });

var $3gdE9 = parcelRequire("3gdE9");
const $6b8dce11d3227385$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $3gdE9.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $3gdE9.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $3gdE9.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("kaf1h", function(module, exports) {
$parcel$export(module.exports, "longFormatters", function () { return $eae06464081ea5f2$export$70cc8fd02856fd58; });
const $eae06464081ea5f2$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $eae06464081ea5f2$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $eae06464081ea5f2$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $eae06464081ea5f2$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $eae06464081ea5f2$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $eae06464081ea5f2$var$timeLongFormatter(timePattern, formatLong));
};
const $eae06464081ea5f2$export$70cc8fd02856fd58 = {
    p: $eae06464081ea5f2$var$timeLongFormatter,
    P: $eae06464081ea5f2$var$dateTimeLongFormatter
};

});

parcelRegister("eKVtb", function(module, exports) {
$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $abe1f0d5862b9833$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $abe1f0d5862b9833$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $abe1f0d5862b9833$export$f5f38f90ecaaf879; });
const $abe1f0d5862b9833$var$dayOfYearTokenRE = /^D+$/;
const $abe1f0d5862b9833$var$weekYearTokenRE = /^Y+$/;
const $abe1f0d5862b9833$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $abe1f0d5862b9833$export$c6cc36aa33304772(token) {
    return $abe1f0d5862b9833$var$dayOfYearTokenRE.test(token);
}
function $abe1f0d5862b9833$export$c6b49d6dceb604a1(token) {
    return $abe1f0d5862b9833$var$weekYearTokenRE.test(token);
}
function $abe1f0d5862b9833$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $abe1f0d5862b9833$var$message(token, format, input);
    console.warn(_message);
    if ($abe1f0d5862b9833$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $abe1f0d5862b9833$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("1vsWe", function(module, exports) {
$parcel$export(module.exports, "isValid", function () { return $118f223a25ac1e92$export$1ea939691cdc45b8; });

var $838H2 = parcelRequire("838H2");

var $frdJf = parcelRequire("frdJf");
function $118f223a25ac1e92$export$1ea939691cdc45b8(date) {
    return !(!(0, $838H2.isDate)(date) && typeof date !== "number" || isNaN(+(0, $frdJf.toDate)(date)));
}
var // Fallback for modularized imports:
$118f223a25ac1e92$export$2e2bcd8739ae039 = $118f223a25ac1e92$export$1ea939691cdc45b8;

});
parcelRegister("838H2", function(module, exports) {
$parcel$export(module.exports, "isDate", function () { return $5dc558d396f78e9b$export$871608497c498473; });
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $5dc558d396f78e9b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$5dc558d396f78e9b$export$2e2bcd8739ae039 = $5dc558d396f78e9b$export$871608497c498473;

});



parcelRegister("24zqb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd64b41739e4b5a1ac8c09f1bbfed3e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18276e72087165bb$var$_react = $18276e72087165bb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $18276e72087165bb$var$_baseNew = $18276e72087165bb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $18276e72087165bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityHigh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for high work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $18276e72087165bb$var$PriorityHighIcon = (props)=>/*#__PURE__*/ $18276e72087165bb$var$_react.default.createElement($18276e72087165bb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 9.25-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353z"/>`
    }, props));
$18276e72087165bb$var$PriorityHighIcon.displayName = 'PriorityHighIcon';
var $18276e72087165bb$var$_default = module.exports.default = $18276e72087165bb$var$PriorityHighIcon;

});

parcelRegister("9p3p1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0a790d91d8a02a088319fd35139d8a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d891685efcb0c3b$var$_react = $6d891685efcb0c3b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6d891685efcb0c3b$var$_baseNew = $6d891685efcb0c3b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6d891685efcb0c3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityLow".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for low work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d891685efcb0c3b$var$PriorityLowIcon = (props)=>/*#__PURE__*/ $6d891685efcb0c3b$var$_react.default.createElement($6d891685efcb0c3b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 7.251-5.5 3.625a.75.75 0 0 1-.826 0l-5.5-3.625.826-1.252L8 9.352l5.087-3.353z"/>`
    }, props));
$6d891685efcb0c3b$var$PriorityLowIcon.displayName = 'PriorityLowIcon';
var $6d891685efcb0c3b$var$_default = module.exports.default = $6d891685efcb0c3b$var$PriorityLowIcon;

});

parcelRegister("h2BxV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8d7d06aafd80a5763505502d0e6cf1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c67fbf7899919f80$var$_react = $c67fbf7899919f80$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c67fbf7899919f80$var$_baseNew = $c67fbf7899919f80$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c67fbf7899919f80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for medium work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c67fbf7899919f80$var$PriorityMediumIcon = (props)=>/*#__PURE__*/ $c67fbf7899919f80$var$_react.default.createElement($c67fbf7899919f80$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 9.5V11H2V9.5zM14 5v1.5H2V5z"/>`
    }, props));
$c67fbf7899919f80$var$PriorityMediumIcon.displayName = 'PriorityMediumIcon';
var $c67fbf7899919f80$var$_default = module.exports.default = $c67fbf7899919f80$var$PriorityMediumIcon;

});





//# sourceMappingURL=index.addb61c5.js.map
